/*! For license information please see vendors.js.LICENSE.txt */
(self.webpackChunkworkflow = self.webpackChunkworkflow || []).push([
  [216],
  {
    6358: function (e, t, i) {
      "use strict";
      function n(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return e;
      }
      function s(e, t) {
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          (e.__proto__ = t);
      }
      i.d(t, {
        p8: function () {
          return qn;
        },
      });
      var r,
        a,
        o,
        l,
        d,
        u,
        c,
        p,
        h,
        f,
        m,
        g,
        v,
        y,
        _,
        b = {
          autoSleep: 120,
          force3D: "auto",
          nullTargetWarn: 1,
          units: { lineHeight: "" },
        },
        w = { duration: 0.5, overwrite: !1, delay: 0 },
        T = 1e8,
        x = 1e-8,
        C = 2 * Math.PI,
        S = C / 4,
        E = 0,
        M = Math.sqrt,
        k = Math.cos,
        O = Math.sin,
        P = function (e) {
          return "string" == typeof e;
        },
        L = function (e) {
          return "function" == typeof e;
        },
        $ = function (e) {
          return "number" == typeof e;
        },
        A = function (e) {
          return void 0 === e;
        },
        z = function (e) {
          return "object" == typeof e;
        },
        D = function (e) {
          return !1 !== e;
        },
        I = function () {
          return "undefined" != typeof window;
        },
        B = function (e) {
          return L(e) || P(e);
        },
        N =
          ("function" == typeof ArrayBuffer && ArrayBuffer.isView) ||
          function () {},
        R = Array.isArray,
        F = /(?:-?\.?\d|\.)+/gi,
        j = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
        G = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
        H = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
        q = /[+-]=-?[.\d]+/,
        V = /[^,'"\[\]\s]+/gi,
        W = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
        Y = {},
        X = {},
        U = function (e) {
          return (X = xe(e, Y)) && Ti;
        },
        Z = function (e, t) {
          return console.warn(
            "Invalid property",
            e,
            "set to",
            t,
            "Missing plugin? gsap.registerPlugin()"
          );
        },
        Q = function (e, t) {
          return !t && console.warn(e);
        },
        K = function (e, t) {
          return (e && (Y[e] = t) && X && (X[e] = t)) || Y;
        },
        J = function () {
          return 0;
        },
        ee = { suppressEvents: !0, isStart: !0 },
        te = { suppressEvents: !0 },
        ie = {},
        ne = [],
        se = {},
        re = {},
        ae = {},
        oe = 30,
        le = [],
        de = "",
        ue = function (e) {
          var t,
            i,
            n = e[0];
          if ((z(n) || L(n) || (e = [e]), !(t = (n._gsap || {}).harness))) {
            for (i = le.length; i-- && !le[i].targetTest(n); );
            t = le[i];
          }
          for (i = e.length; i--; )
            (e[i] && (e[i]._gsap || (e[i]._gsap = new Bt(e[i], t)))) ||
              e.splice(i, 1);
          return e;
        },
        ce = function (e) {
          return e._gsap || ue(tt(e))[0]._gsap;
        },
        pe = function (e, t, i) {
          return (i = e[t]) && L(i)
            ? e[t]()
            : (A(i) && e.getAttribute && e.getAttribute(t)) || i;
        },
        he = function (e, t) {
          return (e = e.split(",")).forEach(t) || e;
        },
        fe = function (e) {
          return Math.round(1e5 * e) / 1e5 || 0;
        },
        me = function (e) {
          return Math.round(1e7 * e) / 1e7 || 0;
        },
        ge = function (e, t) {
          var i = t.charAt(0),
            n = parseFloat(t.substr(2));
          return (
            (e = parseFloat(e)),
            "+" === i ? e + n : "-" === i ? e - n : "*" === i ? e * n : e / n
          );
        },
        ve = function (e, t) {
          for (var i = t.length, n = 0; e.indexOf(t[n]) < 0 && ++n < i; );
          return n < i;
        },
        ye = function () {
          var e,
            t,
            i = ne.length,
            n = ne.slice(0);
          for (se = {}, ne.length = 0, e = 0; e < i; e++)
            (t = n[e]) &&
              t._lazy &&
              (t.render(t._lazy[0], t._lazy[1], !0)._lazy = 0);
        },
        _e = function (e, t, i, n) {
          ne.length && ye(), e.render(t, i, n || a), ne.length && ye();
        },
        be = function (e) {
          var t = parseFloat(e);
          return (t || 0 === t) && (e + "").match(V).length < 2
            ? t
            : P(e)
            ? e.trim()
            : e;
        },
        we = function (e) {
          return e;
        },
        Te = function (e, t) {
          for (var i in t) i in e || (e[i] = t[i]);
          return e;
        },
        xe = function (e, t) {
          for (var i in t) e[i] = t[i];
          return e;
        },
        Ce = function e(t, i) {
          for (var n in i)
            "__proto__" !== n &&
              "constructor" !== n &&
              "prototype" !== n &&
              (t[n] = z(i[n]) ? e(t[n] || (t[n] = {}), i[n]) : i[n]);
          return t;
        },
        Se = function (e, t) {
          var i,
            n = {};
          for (i in e) i in t || (n[i] = e[i]);
          return n;
        },
        Ee = function (e) {
          var t,
            i = e.parent || l,
            n = e.keyframes
              ? ((t = R(e.keyframes)),
                function (e, i) {
                  for (var n in i)
                    n in e ||
                      ("duration" === n && t) ||
                      "ease" === n ||
                      (e[n] = i[n]);
                })
              : Te;
          if (D(e.inherit))
            for (; i; ) n(e, i.vars.defaults), (i = i.parent || i._dp);
          return e;
        },
        Me = function (e, t, i, n, s) {
          void 0 === i && (i = "_first"), void 0 === n && (n = "_last");
          var r,
            a = e[n];
          if (s) for (r = t[s]; a && a[s] > r; ) a = a._prev;
          return (
            a
              ? ((t._next = a._next), (a._next = t))
              : ((t._next = e[i]), (e[i] = t)),
            t._next ? (t._next._prev = t) : (e[n] = t),
            (t._prev = a),
            (t.parent = t._dp = e),
            t
          );
        },
        ke = function (e, t, i, n) {
          void 0 === i && (i = "_first"), void 0 === n && (n = "_last");
          var s = t._prev,
            r = t._next;
          s ? (s._next = r) : e[i] === t && (e[i] = r),
            r ? (r._prev = s) : e[n] === t && (e[n] = s),
            (t._next = t._prev = t.parent = null);
        },
        Oe = function (e, t) {
          e.parent && (!t || e.parent.autoRemoveChildren) && e.parent.remove(e),
            (e._act = 0);
        },
        Pe = function (e, t) {
          if (e && (!t || t._end > e._dur || t._start < 0))
            for (var i = e; i; ) (i._dirty = 1), (i = i.parent);
          return e;
        },
        Le = function (e) {
          for (var t = e.parent; t && t.parent; )
            (t._dirty = 1), t.totalDuration(), (t = t.parent);
          return e;
        },
        $e = function (e, t, i, n) {
          return (
            e._startAt &&
            (a
              ? e._startAt.revert(te)
              : (e.vars.immediateRender && !e.vars.autoRevert) ||
                e._startAt.render(t, !0, n))
          );
        },
        Ae = function e(t) {
          return !t || (t._ts && e(t.parent));
        },
        ze = function (e) {
          return e._repeat
            ? De(e._tTime, (e = e.duration() + e._rDelay)) * e
            : 0;
        },
        De = function (e, t) {
          var i = Math.floor((e /= t));
          return e && i === e ? i - 1 : i;
        },
        Ie = function (e, t) {
          return (
            (e - t._start) * t._ts +
            (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur)
          );
        },
        Be = function (e) {
          return (e._end = me(
            e._start + (e._tDur / Math.abs(e._ts || e._rts || x) || 0)
          ));
        },
        Ne = function (e, t) {
          var i = e._dp;
          return (
            i &&
              i.smoothChildTiming &&
              e._ts &&
              ((e._start = me(
                i._time -
                  (e._ts > 0
                    ? t / e._ts
                    : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts)
              )),
              Be(e),
              i._dirty || Pe(i, e)),
            e
          );
        },
        Re = function (e, t) {
          var i;
          if (
            ((t._time || (t._initted && !t._dur)) &&
              ((i = Ie(e.rawTime(), t)),
              (!t._dur || Qe(0, t.totalDuration(), i) - t._tTime > x) &&
                t.render(i, !0)),
            Pe(e, t)._dp && e._initted && e._time >= e._dur && e._ts)
          ) {
            if (e._dur < e.duration())
              for (i = e; i._dp; )
                i.rawTime() >= 0 && i.totalTime(i._tTime), (i = i._dp);
            e._zTime = -1e-8;
          }
        },
        Fe = function (e, t, i, n) {
          return (
            t.parent && Oe(t),
            (t._start = me(
              ($(i) ? i : i || e !== l ? Xe(e, i, t) : e._time) + t._delay
            )),
            (t._end = me(
              t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)
            )),
            Me(e, t, "_first", "_last", e._sort ? "_start" : 0),
            qe(t) || (e._recent = t),
            n || Re(e, t),
            e._ts < 0 && Ne(e, e._tTime),
            e
          );
        },
        je = function (e, t) {
          return (
            (Y.ScrollTrigger || Z("scrollTrigger", t)) &&
            Y.ScrollTrigger.create(t, e)
          );
        },
        Ge = function (e, t, i, n) {
          return (
            Vt(e, t),
            e._initted
              ? !i &&
                e._pt &&
                ((e._dur && !1 !== e.vars.lazy) || (!e._dur && e.vars.lazy)) &&
                h !== Ct.frame
                ? (ne.push(e), (e._lazy = [t, n]), 1)
                : void 0
              : 1
          );
        },
        He = function e(t) {
          var i = t.parent;
          return (
            i && i._ts && i._initted && !i._lock && (i.rawTime() < 0 || e(i))
          );
        },
        qe = function (e) {
          var t = e.data;
          return "isFromStart" === t || "isStart" === t;
        },
        Ve = function (e, t, i, n) {
          var s = e._repeat,
            r = me(t) || 0,
            a = e._tTime / e._tDur;
          return (
            a && !n && (e._time *= r / e._dur),
            (e._dur = r),
            (e._tDur = s
              ? s < 0
                ? 1e10
                : me(r * (s + 1) + e._rDelay * s)
              : r),
            a > 0 && !n ? Ne(e, (e._tTime = e._tDur * a)) : e.parent && Be(e),
            i || Pe(e.parent, e),
            e
          );
        },
        We = function (e) {
          return e instanceof Rt ? Pe(e) : Ve(e, e._dur);
        },
        Ye = { _start: 0, endTime: J, totalDuration: J },
        Xe = function e(t, i, n) {
          var s,
            r,
            a,
            o = t.labels,
            l = t._recent || Ye,
            d = t.duration() >= T ? l.endTime(!1) : t._dur;
          return P(i) && (isNaN(i) || i in o)
            ? ((r = i.charAt(0)),
              (a = "%" === i.substr(-1)),
              (s = i.indexOf("=")),
              "<" === r || ">" === r
                ? (s >= 0 && (i = i.replace(/=/, "")),
                  ("<" === r ? l._start : l.endTime(l._repeat >= 0)) +
                    (parseFloat(i.substr(1)) || 0) *
                      (a ? (s < 0 ? l : n).totalDuration() / 100 : 1))
                : s < 0
                ? (i in o || (o[i] = d), o[i])
                : ((r = parseFloat(i.charAt(s - 1) + i.substr(s + 1))),
                  a && n && (r = (r / 100) * (R(n) ? n[0] : n).totalDuration()),
                  s > 1 ? e(t, i.substr(0, s - 1), n) + r : d + r))
            : null == i
            ? d
            : +i;
        },
        Ue = function (e, t, i) {
          var n,
            s,
            r = $(t[1]),
            a = (r ? 2 : 1) + (e < 2 ? 0 : 1),
            o = t[a];
          if ((r && (o.duration = t[1]), (o.parent = i), e)) {
            for (n = o, s = i; s && !("immediateRender" in n); )
              (n = s.vars.defaults || {}), (s = D(s.vars.inherit) && s.parent);
            (o.immediateRender = D(n.immediateRender)),
              e < 2 ? (o.runBackwards = 1) : (o.startAt = t[a - 1]);
          }
          return new Zt(t[0], o, t[a + 1]);
        },
        Ze = function (e, t) {
          return e || 0 === e ? t(e) : t;
        },
        Qe = function (e, t, i) {
          return i < e ? e : i > t ? t : i;
        },
        Ke = function (e, t) {
          return P(e) && (t = W.exec(e)) ? t[1] : "";
        },
        Je = [].slice,
        et = function (e, t) {
          return (
            e &&
            z(e) &&
            "length" in e &&
            ((!t && !e.length) || (e.length - 1 in e && z(e[0]))) &&
            !e.nodeType &&
            e !== d
          );
        },
        tt = function (e, t, i) {
          return o && !t && o.selector
            ? o.selector(e)
            : !P(e) || i || (!u && St())
            ? R(e)
              ? (function (e, t, i) {
                  return (
                    void 0 === i && (i = []),
                    e.forEach(function (e) {
                      var n;
                      return (P(e) && !t) || et(e, 1)
                        ? (n = i).push.apply(n, tt(e))
                        : i.push(e);
                    }) || i
                  );
                })(e, i)
              : et(e)
              ? Je.call(e, 0)
              : e
              ? [e]
              : []
            : Je.call((t || c).querySelectorAll(e), 0);
        },
        it = function (e) {
          return (
            (e = tt(e)[0] || Q("Invalid scope") || {}),
            function (t) {
              var i = e.current || e.nativeElement || e;
              return tt(
                t,
                i.querySelectorAll
                  ? i
                  : i === e
                  ? Q("Invalid scope") || c.createElement("div")
                  : e
              );
            }
          );
        },
        nt = function (e) {
          return e.sort(function () {
            return 0.5 - Math.random();
          });
        },
        st = function (e) {
          if (L(e)) return e;
          var t = z(e) ? e : { each: e },
            i = $t(t.ease),
            n = t.from || 0,
            s = parseFloat(t.base) || 0,
            r = {},
            a = n > 0 && n < 1,
            o = isNaN(n) || a,
            l = t.axis,
            d = n,
            u = n;
          return (
            P(n)
              ? (d = u = { center: 0.5, edges: 0.5, end: 1 }[n] || 0)
              : !a && o && ((d = n[0]), (u = n[1])),
            function (e, a, c) {
              var p,
                h,
                f,
                m,
                g,
                v,
                y,
                _,
                b,
                w = (c || t).length,
                x = r[w];
              if (!x) {
                if (!(b = "auto" === t.grid ? 0 : (t.grid || [1, T])[1])) {
                  for (
                    y = -T;
                    y < (y = c[b++].getBoundingClientRect().left) && b < w;

                  );
                  b--;
                }
                for (
                  x = r[w] = [],
                    p = o ? Math.min(b, w) * d - 0.5 : n % b,
                    h = b === T ? 0 : o ? (w * u) / b - 0.5 : (n / b) | 0,
                    y = 0,
                    _ = T,
                    v = 0;
                  v < w;
                  v++
                )
                  (f = (v % b) - p),
                    (m = h - ((v / b) | 0)),
                    (x[v] = g =
                      l ? Math.abs("y" === l ? m : f) : M(f * f + m * m)),
                    g > y && (y = g),
                    g < _ && (_ = g);
                "random" === n && nt(x),
                  (x.max = y - _),
                  (x.min = _),
                  (x.v = w =
                    (parseFloat(t.amount) ||
                      parseFloat(t.each) *
                        (b > w
                          ? w - 1
                          : l
                          ? "y" === l
                            ? w / b
                            : b
                          : Math.max(b, w / b)) ||
                      0) * ("edges" === n ? -1 : 1)),
                  (x.b = w < 0 ? s - w : s),
                  (x.u = Ke(t.amount || t.each) || 0),
                  (i = i && w < 0 ? Pt(i) : i);
              }
              return (
                (w = (x[e] - x.min) / x.max || 0),
                me(x.b + (i ? i(w) : w) * x.v) + x.u
              );
            }
          );
        },
        rt = function (e) {
          var t = Math.pow(10, ((e + "").split(".")[1] || "").length);
          return function (i) {
            var n = me(Math.round(parseFloat(i) / e) * e * t);
            return (n - (n % 1)) / t + ($(i) ? 0 : Ke(i));
          };
        },
        at = function (e, t) {
          var i,
            n,
            s = R(e);
          return (
            !s &&
              z(e) &&
              ((i = s = e.radius || T),
              e.values
                ? ((e = tt(e.values)), (n = !$(e[0])) && (i *= i))
                : (e = rt(e.increment))),
            Ze(
              t,
              s
                ? L(e)
                  ? function (t) {
                      return (n = e(t)), Math.abs(n - t) <= i ? n : t;
                    }
                  : function (t) {
                      for (
                        var s,
                          r,
                          a = parseFloat(n ? t.x : t),
                          o = parseFloat(n ? t.y : 0),
                          l = T,
                          d = 0,
                          u = e.length;
                        u--;

                      )
                        (s = n
                          ? (s = e[u].x - a) * s + (r = e[u].y - o) * r
                          : Math.abs(e[u] - a)) < l && ((l = s), (d = u));
                      return (
                        (d = !i || l <= i ? e[d] : t),
                        n || d === t || $(t) ? d : d + Ke(t)
                      );
                    }
                : rt(e)
            )
          );
        },
        ot = function (e, t, i, n) {
          return Ze(R(e) ? !t : !0 === i ? !!(i = 0) : !n, function () {
            return R(e)
              ? e[~~(Math.random() * e.length)]
              : (i = i || 1e-5) &&
                  (n = i < 1 ? Math.pow(10, (i + "").length - 2) : 1) &&
                  Math.floor(
                    Math.round(
                      (e - i / 2 + Math.random() * (t - e + 0.99 * i)) / i
                    ) *
                      i *
                      n
                  ) / n;
          });
        },
        lt = function (e, t, i) {
          return Ze(i, function (i) {
            return e[~~t(i)];
          });
        },
        dt = function (e) {
          for (var t, i, n, s, r = 0, a = ""; ~(t = e.indexOf("random(", r)); )
            (n = e.indexOf(")", t)),
              (s = "[" === e.charAt(t + 7)),
              (i = e.substr(t + 7, n - t - 7).match(s ? V : F)),
              (a +=
                e.substr(r, t - r) +
                ot(s ? i : +i[0], s ? 0 : +i[1], +i[2] || 1e-5)),
              (r = n + 1);
          return a + e.substr(r, e.length - r);
        },
        ut = function (e, t, i, n, s) {
          var r = t - e,
            a = n - i;
          return Ze(s, function (t) {
            return i + (((t - e) / r) * a || 0);
          });
        },
        ct = function (e, t, i) {
          var n,
            s,
            r,
            a = e.labels,
            o = T;
          for (n in a)
            (s = a[n] - t) < 0 == !!i &&
              s &&
              o > (s = Math.abs(s)) &&
              ((r = n), (o = s));
          return r;
        },
        pt = function (e, t, i) {
          var n,
            s,
            r,
            a = e.vars,
            l = a[t],
            d = o,
            u = e._ctx;
          if (l)
            return (
              (n = a[t + "Params"]),
              (s = a.callbackScope || e),
              i && ne.length && ye(),
              u && (o = u),
              (r = n ? l.apply(s, n) : l.call(s)),
              (o = d),
              r
            );
        },
        ht = function (e) {
          return (
            Oe(e),
            e.scrollTrigger && e.scrollTrigger.kill(!1),
            e.progress() < 1 && pt(e, "onInterrupt"),
            e
          );
        },
        ft = function (e) {
          var t = (e = (!e.name && e.default) || e).name,
            i = L(e),
            n =
              t && !i && e.init
                ? function () {
                    this._props = [];
                  }
                : e,
            s = {
              init: J,
              render: ri,
              add: Ht,
              kill: oi,
              modifier: ai,
              rawVars: 0,
            },
            r = {
              targetTest: 0,
              get: 0,
              getSetter: ti,
              aliases: {},
              register: 0,
            };
          if ((St(), e !== n)) {
            if (re[t]) return;
            Te(n, Te(Se(e, s), r)),
              xe(n.prototype, xe(s, Se(e, r))),
              (re[(n.prop = t)] = n),
              e.targetTest && (le.push(n), (ie[t] = 1)),
              (t =
                ("css" === t
                  ? "CSS"
                  : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin");
          }
          K(t, n), e.register && e.register(Ti, n, ui);
        },
        mt = 255,
        gt = {
          aqua: [0, mt, mt],
          lime: [0, mt, 0],
          silver: [192, 192, 192],
          black: [0, 0, 0],
          maroon: [128, 0, 0],
          teal: [0, 128, 128],
          blue: [0, 0, mt],
          navy: [0, 0, 128],
          white: [mt, mt, mt],
          olive: [128, 128, 0],
          yellow: [mt, mt, 0],
          orange: [mt, 165, 0],
          gray: [128, 128, 128],
          purple: [128, 0, 128],
          green: [0, 128, 0],
          red: [mt, 0, 0],
          pink: [mt, 192, 203],
          cyan: [0, mt, mt],
          transparent: [mt, mt, mt, 0],
        },
        vt = function (e, t, i) {
          return (
            ((6 * (e += e < 0 ? 1 : e > 1 ? -1 : 0) < 1
              ? t + (i - t) * e * 6
              : e < 0.5
              ? i
              : 3 * e < 2
              ? t + (i - t) * (2 / 3 - e) * 6
              : t) *
              mt +
              0.5) |
            0
          );
        },
        yt = function (e, t, i) {
          var n,
            s,
            r,
            a,
            o,
            l,
            d,
            u,
            c,
            p,
            h = e ? ($(e) ? [e >> 16, (e >> 8) & mt, e & mt] : 0) : gt.black;
          if (!h) {
            if (
              ("," === e.substr(-1) && (e = e.substr(0, e.length - 1)), gt[e])
            )
              h = gt[e];
            else if ("#" === e.charAt(0)) {
              if (
                (e.length < 6 &&
                  ((n = e.charAt(1)),
                  (s = e.charAt(2)),
                  (r = e.charAt(3)),
                  (e =
                    "#" +
                    n +
                    n +
                    s +
                    s +
                    r +
                    r +
                    (5 === e.length ? e.charAt(4) + e.charAt(4) : ""))),
                9 === e.length)
              )
                return [
                  (h = parseInt(e.substr(1, 6), 16)) >> 16,
                  (h >> 8) & mt,
                  h & mt,
                  parseInt(e.substr(7), 16) / 255,
                ];
              h = [
                (e = parseInt(e.substr(1), 16)) >> 16,
                (e >> 8) & mt,
                e & mt,
              ];
            } else if ("hsl" === e.substr(0, 3))
              if (((h = p = e.match(F)), t)) {
                if (~e.indexOf("="))
                  return (h = e.match(j)), i && h.length < 4 && (h[3] = 1), h;
              } else
                (a = (+h[0] % 360) / 360),
                  (o = +h[1] / 100),
                  (n =
                    2 * (l = +h[2] / 100) -
                    (s = l <= 0.5 ? l * (o + 1) : l + o - l * o)),
                  h.length > 3 && (h[3] *= 1),
                  (h[0] = vt(a + 1 / 3, n, s)),
                  (h[1] = vt(a, n, s)),
                  (h[2] = vt(a - 1 / 3, n, s));
            else h = e.match(F) || gt.transparent;
            h = h.map(Number);
          }
          return (
            t &&
              !p &&
              ((n = h[0] / mt),
              (s = h[1] / mt),
              (r = h[2] / mt),
              (l = ((d = Math.max(n, s, r)) + (u = Math.min(n, s, r))) / 2),
              d === u
                ? (a = o = 0)
                : ((c = d - u),
                  (o = l > 0.5 ? c / (2 - d - u) : c / (d + u)),
                  (a =
                    d === n
                      ? (s - r) / c + (s < r ? 6 : 0)
                      : d === s
                      ? (r - n) / c + 2
                      : (n - s) / c + 4),
                  (a *= 60)),
              (h[0] = ~~(a + 0.5)),
              (h[1] = ~~(100 * o + 0.5)),
              (h[2] = ~~(100 * l + 0.5))),
            i && h.length < 4 && (h[3] = 1),
            h
          );
        },
        _t = function (e) {
          var t = [],
            i = [],
            n = -1;
          return (
            e.split(wt).forEach(function (e) {
              var s = e.match(G) || [];
              t.push.apply(t, s), i.push((n += s.length + 1));
            }),
            (t.c = i),
            t
          );
        },
        bt = function (e, t, i) {
          var n,
            s,
            r,
            a,
            o = "",
            l = (e + o).match(wt),
            d = t ? "hsla(" : "rgba(",
            u = 0;
          if (!l) return e;
          if (
            ((l = l.map(function (e) {
              return (
                (e = yt(e, t, 1)) &&
                d +
                  (t
                    ? e[0] + "," + e[1] + "%," + e[2] + "%," + e[3]
                    : e.join(",")) +
                  ")"
              );
            })),
            i && ((r = _t(e)), (n = i.c).join(o) !== r.c.join(o)))
          )
            for (a = (s = e.replace(wt, "1").split(G)).length - 1; u < a; u++)
              o +=
                s[u] +
                (~n.indexOf(u)
                  ? l.shift() || d + "0,0,0,0)"
                  : (r.length ? r : l.length ? l : i).shift());
          if (!s)
            for (a = (s = e.split(wt)).length - 1; u < a; u++) o += s[u] + l[u];
          return o + s[a];
        },
        wt = (function () {
          var e,
            t =
              "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
          for (e in gt) t += "|" + e + "\\b";
          return new RegExp(t + ")", "gi");
        })(),
        Tt = /hsl[a]?\(/,
        xt = function (e) {
          var t,
            i = e.join(" ");
          if (((wt.lastIndex = 0), wt.test(i)))
            return (
              (t = Tt.test(i)),
              (e[1] = bt(e[1], t)),
              (e[0] = bt(e[0], t, _t(e[1]))),
              !0
            );
        },
        Ct = (function () {
          var e,
            t,
            i,
            n,
            s,
            r,
            a = Date.now,
            o = 500,
            l = 33,
            h = a(),
            f = h,
            g = 1e3 / 240,
            v = g,
            y = [],
            _ = function i(d) {
              var u,
                c,
                p,
                m,
                _ = a() - f,
                b = !0 === d;
              if (
                (_ > o && (h += _ - l),
                ((u = (p = (f += _) - h) - v) > 0 || b) &&
                  ((m = ++n.frame),
                  (s = p - 1e3 * n.time),
                  (n.time = p /= 1e3),
                  (v += u + (u >= g ? 4 : g - u)),
                  (c = 1)),
                b || (e = t(i)),
                c)
              )
                for (r = 0; r < y.length; r++) y[r](p, s, m, d);
            };
          return (n = {
            time: 0,
            frame: 0,
            tick: function () {
              _(!0);
            },
            deltaRatio: function (e) {
              return s / (1e3 / (e || 60));
            },
            wake: function () {
              p &&
                (!u &&
                  I() &&
                  ((d = u = window),
                  (c = d.document || {}),
                  (Y.gsap = Ti),
                  (d.gsapVersions || (d.gsapVersions = [])).push(Ti.version),
                  U(X || d.GreenSockGlobals || (!d.gsap && d) || {}),
                  (i = d.requestAnimationFrame)),
                e && n.sleep(),
                (t =
                  i ||
                  function (e) {
                    return setTimeout(e, (v - 1e3 * n.time + 1) | 0);
                  }),
                (m = 1),
                _(2));
            },
            sleep: function () {
              (i ? d.cancelAnimationFrame : clearTimeout)(e), (m = 0), (t = J);
            },
            lagSmoothing: function (e, t) {
              (o = e || 1e8), (l = Math.min(t, o, 0));
            },
            fps: function (e) {
              (g = 1e3 / (e || 240)), (v = 1e3 * n.time + g);
            },
            add: function (e, t, i) {
              var s = t
                ? function (t, i, r, a) {
                    e(t, i, r, a), n.remove(s);
                  }
                : e;
              return n.remove(e), y[i ? "unshift" : "push"](s), St(), s;
            },
            remove: function (e, t) {
              ~(t = y.indexOf(e)) && y.splice(t, 1) && r >= t && r--;
            },
            _listeners: y,
          });
        })(),
        St = function () {
          return !m && Ct.wake();
        },
        Et = {},
        Mt = /^[\d.\-M][\d.\-,\s]/,
        kt = /["']/g,
        Ot = function (e) {
          for (
            var t,
              i,
              n,
              s = {},
              r = e.substr(1, e.length - 3).split(":"),
              a = r[0],
              o = 1,
              l = r.length;
            o < l;
            o++
          )
            (i = r[o]),
              (t = o !== l - 1 ? i.lastIndexOf(",") : i.length),
              (n = i.substr(0, t)),
              (s[a] = isNaN(n) ? n.replace(kt, "").trim() : +n),
              (a = i.substr(t + 1).trim());
          return s;
        },
        Pt = function (e) {
          return function (t) {
            return 1 - e(1 - t);
          };
        },
        Lt = function e(t, i) {
          for (var n, s = t._first; s; )
            s instanceof Rt
              ? e(s, i)
              : !s.vars.yoyoEase ||
                (s._yoyo && s._repeat) ||
                s._yoyo === i ||
                (s.timeline
                  ? e(s.timeline, i)
                  : ((n = s._ease),
                    (s._ease = s._yEase),
                    (s._yEase = n),
                    (s._yoyo = i))),
              (s = s._next);
        },
        $t = function (e, t) {
          return (
            (e &&
              (L(e)
                ? e
                : Et[e] ||
                  (function (e) {
                    var t,
                      i,
                      n,
                      s,
                      r = (e + "").split("("),
                      a = Et[r[0]];
                    return a && r.length > 1 && a.config
                      ? a.config.apply(
                          null,
                          ~e.indexOf("{")
                            ? [Ot(r[1])]
                            : ((t = e),
                              (i = t.indexOf("(") + 1),
                              (n = t.indexOf(")")),
                              (s = t.indexOf("(", i)),
                              t.substring(
                                i,
                                ~s && s < n ? t.indexOf(")", n + 1) : n
                              ))
                                .split(",")
                                .map(be)
                        )
                      : Et._CE && Mt.test(e)
                      ? Et._CE("", e)
                      : a;
                  })(e))) ||
            t
          );
        },
        At = function (e, t, i, n) {
          void 0 === i &&
            (i = function (e) {
              return 1 - t(1 - e);
            }),
            void 0 === n &&
              (n = function (e) {
                return e < 0.5 ? t(2 * e) / 2 : 1 - t(2 * (1 - e)) / 2;
              });
          var s,
            r = { easeIn: t, easeOut: i, easeInOut: n };
          return (
            he(e, function (e) {
              for (var t in ((Et[e] = Y[e] = r),
              (Et[(s = e.toLowerCase())] = i),
              r))
                Et[
                  s +
                    ("easeIn" === t
                      ? ".in"
                      : "easeOut" === t
                      ? ".out"
                      : ".inOut")
                ] = Et[e + "." + t] = r[t];
            }),
            r
          );
        },
        zt = function (e) {
          return function (t) {
            return t < 0.5
              ? (1 - e(1 - 2 * t)) / 2
              : 0.5 + e(2 * (t - 0.5)) / 2;
          };
        },
        Dt = function e(t, i, n) {
          var s = i >= 1 ? i : 1,
            r = (n || (t ? 0.3 : 0.45)) / (i < 1 ? i : 1),
            a = (r / C) * (Math.asin(1 / s) || 0),
            o = function (e) {
              return 1 === e
                ? 1
                : s * Math.pow(2, -10 * e) * O((e - a) * r) + 1;
            },
            l =
              "out" === t
                ? o
                : "in" === t
                ? function (e) {
                    return 1 - o(1 - e);
                  }
                : zt(o);
          return (
            (r = C / r),
            (l.config = function (i, n) {
              return e(t, i, n);
            }),
            l
          );
        },
        It = function e(t, i) {
          void 0 === i && (i = 1.70158);
          var n = function (e) {
              return e ? --e * e * ((i + 1) * e + i) + 1 : 0;
            },
            s =
              "out" === t
                ? n
                : "in" === t
                ? function (e) {
                    return 1 - n(1 - e);
                  }
                : zt(n);
          return (
            (s.config = function (i) {
              return e(t, i);
            }),
            s
          );
        };
      he("Linear,Quad,Cubic,Quart,Quint,Strong", function (e, t) {
        var i = t < 5 ? t + 1 : t;
        At(
          e + ",Power" + (i - 1),
          t
            ? function (e) {
                return Math.pow(e, i);
              }
            : function (e) {
                return e;
              },
          function (e) {
            return 1 - Math.pow(1 - e, i);
          },
          function (e) {
            return e < 0.5
              ? Math.pow(2 * e, i) / 2
              : 1 - Math.pow(2 * (1 - e), i) / 2;
          }
        );
      }),
        (Et.Linear.easeNone = Et.none = Et.Linear.easeIn),
        At("Elastic", Dt("in"), Dt("out"), Dt()),
        (g = 7.5625),
        (y = 1 / (v = 2.75)),
        At(
          "Bounce",
          function (e) {
            return 1 - _(1 - e);
          },
          (_ = function (e) {
            return e < y
              ? g * e * e
              : e < 0.7272727272727273
              ? g * Math.pow(e - 1.5 / v, 2) + 0.75
              : e < 0.9090909090909092
              ? g * (e -= 2.25 / v) * e + 0.9375
              : g * Math.pow(e - 2.625 / v, 2) + 0.984375;
          })
        ),
        At("Expo", function (e) {
          return e ? Math.pow(2, 10 * (e - 1)) : 0;
        }),
        At("Circ", function (e) {
          return -(M(1 - e * e) - 1);
        }),
        At("Sine", function (e) {
          return 1 === e ? 1 : 1 - k(e * S);
        }),
        At("Back", It("in"), It("out"), It()),
        (Et.SteppedEase =
          Et.steps =
          Y.SteppedEase =
            {
              config: function (e, t) {
                void 0 === e && (e = 1);
                var i = 1 / e,
                  n = e + (t ? 0 : 1),
                  s = t ? 1 : 0;
                return function (e) {
                  return (((n * Qe(0, 0.99999999, e)) | 0) + s) * i;
                };
              },
            }),
        (w.ease = Et["quad.out"]),
        he(
          "onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",
          function (e) {
            return (de += e + "," + e + "Params,");
          }
        );
      var Bt = function (e, t) {
          (this.id = E++),
            (e._gsap = this),
            (this.target = e),
            (this.harness = t),
            (this.get = t ? t.get : pe),
            (this.set = t ? t.getSetter : ti);
        },
        Nt = (function () {
          function e(e) {
            (this.vars = e),
              (this._delay = +e.delay || 0),
              (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) &&
                ((this._rDelay = e.repeatDelay || 0),
                (this._yoyo = !!e.yoyo || !!e.yoyoEase)),
              (this._ts = 1),
              Ve(this, +e.duration, 1, 1),
              (this.data = e.data),
              o && ((this._ctx = o), o.data.push(this)),
              m || Ct.wake();
          }
          var t = e.prototype;
          return (
            (t.delay = function (e) {
              return e || 0 === e
                ? (this.parent &&
                    this.parent.smoothChildTiming &&
                    this.startTime(this._start + e - this._delay),
                  (this._delay = e),
                  this)
                : this._delay;
            }),
            (t.duration = function (e) {
              return arguments.length
                ? this.totalDuration(
                    this._repeat > 0 ? e + (e + this._rDelay) * this._repeat : e
                  )
                : this.totalDuration() && this._dur;
            }),
            (t.totalDuration = function (e) {
              return arguments.length
                ? ((this._dirty = 0),
                  Ve(
                    this,
                    this._repeat < 0
                      ? e
                      : (e - this._repeat * this._rDelay) / (this._repeat + 1)
                  ))
                : this._tDur;
            }),
            (t.totalTime = function (e, t) {
              if ((St(), !arguments.length)) return this._tTime;
              var i = this._dp;
              if (i && i.smoothChildTiming && this._ts) {
                for (
                  Ne(this, e), !i._dp || i.parent || Re(i, this);
                  i && i.parent;

                )
                  i.parent._time !==
                    i._start +
                      (i._ts >= 0
                        ? i._tTime / i._ts
                        : (i.totalDuration() - i._tTime) / -i._ts) &&
                    i.totalTime(i._tTime, !0),
                    (i = i.parent);
                !this.parent &&
                  this._dp.autoRemoveChildren &&
                  ((this._ts > 0 && e < this._tDur) ||
                    (this._ts < 0 && e > 0) ||
                    (!this._tDur && !e)) &&
                  Fe(this._dp, this, this._start - this._delay);
              }
              return (
                (this._tTime !== e ||
                  (!this._dur && !t) ||
                  (this._initted && Math.abs(this._zTime) === x) ||
                  (!e && !this._initted && (this.add || this._ptLookup))) &&
                  (this._ts || (this._pTime = e), _e(this, e, t)),
                this
              );
            }),
            (t.time = function (e, t) {
              return arguments.length
                ? this.totalTime(
                    Math.min(this.totalDuration(), e + ze(this)) %
                      (this._dur + this._rDelay) || (e ? this._dur : 0),
                    t
                  )
                : this._time;
            }),
            (t.totalProgress = function (e, t) {
              return arguments.length
                ? this.totalTime(this.totalDuration() * e, t)
                : this.totalDuration()
                ? Math.min(1, this._tTime / this._tDur)
                : this.ratio;
            }),
            (t.progress = function (e, t) {
              return arguments.length
                ? this.totalTime(
                    this.duration() *
                      (!this._yoyo || 1 & this.iteration() ? e : 1 - e) +
                      ze(this),
                    t
                  )
                : this.duration()
                ? Math.min(1, this._time / this._dur)
                : this.ratio;
            }),
            (t.iteration = function (e, t) {
              var i = this.duration() + this._rDelay;
              return arguments.length
                ? this.totalTime(this._time + (e - 1) * i, t)
                : this._repeat
                ? De(this._tTime, i) + 1
                : 1;
            }),
            (t.timeScale = function (e) {
              if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
              if (this._rts === e) return this;
              var t =
                this.parent && this._ts
                  ? Ie(this.parent._time, this)
                  : this._tTime;
              return (
                (this._rts = +e || 0),
                (this._ts = this._ps || -1e-8 === e ? 0 : this._rts),
                this.totalTime(Qe(-this._delay, this._tDur, t), !0),
                Be(this),
                Le(this)
              );
            }),
            (t.paused = function (e) {
              return arguments.length
                ? (this._ps !== e &&
                    ((this._ps = e),
                    e
                      ? ((this._pTime =
                          this._tTime ||
                          Math.max(-this._delay, this.rawTime())),
                        (this._ts = this._act = 0))
                      : (St(),
                        (this._ts = this._rts),
                        this.totalTime(
                          this.parent && !this.parent.smoothChildTiming
                            ? this.rawTime()
                            : this._tTime || this._pTime,
                          1 === this.progress() &&
                            Math.abs(this._zTime) !== x &&
                            (this._tTime -= x)
                        ))),
                  this)
                : this._ps;
            }),
            (t.startTime = function (e) {
              if (arguments.length) {
                this._start = e;
                var t = this.parent || this._dp;
                return (
                  t &&
                    (t._sort || !this.parent) &&
                    Fe(t, this, e - this._delay),
                  this
                );
              }
              return this._start;
            }),
            (t.endTime = function (e) {
              return (
                this._start +
                (D(e) ? this.totalDuration() : this.duration()) /
                  Math.abs(this._ts || 1)
              );
            }),
            (t.rawTime = function (e) {
              var t = this.parent || this._dp;
              return t
                ? e &&
                  (!this._ts ||
                    (this._repeat && this._time && this.totalProgress() < 1))
                  ? this._tTime % (this._dur + this._rDelay)
                  : this._ts
                  ? Ie(t.rawTime(e), this)
                  : this._tTime
                : this._tTime;
            }),
            (t.revert = function (e) {
              void 0 === e && (e = te);
              var t = a;
              return (
                (a = e),
                this.timeline && this.timeline.revert(e),
                this.totalTime(-0.01, e.suppressEvents),
                "nested" !== this.data && Oe(this),
                (a = t),
                this
              );
            }),
            (t.globalTime = function (e) {
              for (var t = this, i = arguments.length ? e : t.rawTime(); t; )
                (i = t._start + i / (t._ts || 1)), (t = t._dp);
              return !this.parent && this.vars.immediateRender ? -1 : i;
            }),
            (t.repeat = function (e) {
              return arguments.length
                ? ((this._repeat = e === 1 / 0 ? -2 : e), We(this))
                : -2 === this._repeat
                ? 1 / 0
                : this._repeat;
            }),
            (t.repeatDelay = function (e) {
              if (arguments.length) {
                var t = this._time;
                return (this._rDelay = e), We(this), t ? this.time(t) : this;
              }
              return this._rDelay;
            }),
            (t.yoyo = function (e) {
              return arguments.length ? ((this._yoyo = e), this) : this._yoyo;
            }),
            (t.seek = function (e, t) {
              return this.totalTime(Xe(this, e), D(t));
            }),
            (t.restart = function (e, t) {
              return this.play().totalTime(e ? -this._delay : 0, D(t));
            }),
            (t.play = function (e, t) {
              return null != e && this.seek(e, t), this.reversed(!1).paused(!1);
            }),
            (t.reverse = function (e, t) {
              return (
                null != e && this.seek(e || this.totalDuration(), t),
                this.reversed(!0).paused(!1)
              );
            }),
            (t.pause = function (e, t) {
              return null != e && this.seek(e, t), this.paused(!0);
            }),
            (t.resume = function () {
              return this.paused(!1);
            }),
            (t.reversed = function (e) {
              return arguments.length
                ? (!!e !== this.reversed() &&
                    this.timeScale(-this._rts || (e ? -1e-8 : 0)),
                  this)
                : this._rts < 0;
            }),
            (t.invalidate = function () {
              return (
                (this._initted = this._act = 0), (this._zTime = -1e-8), this
              );
            }),
            (t.isActive = function () {
              var e,
                t = this.parent || this._dp,
                i = this._start;
              return !(
                t &&
                !(
                  this._ts &&
                  this._initted &&
                  t.isActive() &&
                  (e = t.rawTime(!0)) >= i &&
                  e < this.endTime(!0) - x
                )
              );
            }),
            (t.eventCallback = function (e, t, i) {
              var n = this.vars;
              return arguments.length > 1
                ? (t
                    ? ((n[e] = t),
                      i && (n[e + "Params"] = i),
                      "onUpdate" === e && (this._onUpdate = t))
                    : delete n[e],
                  this)
                : n[e];
            }),
            (t.then = function (e) {
              var t = this;
              return new Promise(function (i) {
                var n = L(e) ? e : we,
                  s = function () {
                    var e = t.then;
                    (t.then = null),
                      L(n) && (n = n(t)) && (n.then || n === t) && (t.then = e),
                      i(n),
                      (t.then = e);
                  };
                (t._initted && 1 === t.totalProgress() && t._ts >= 0) ||
                (!t._tTime && t._ts < 0)
                  ? s()
                  : (t._prom = s);
              });
            }),
            (t.kill = function () {
              ht(this);
            }),
            e
          );
        })();
      Te(Nt.prototype, {
        _time: 0,
        _start: 0,
        _end: 0,
        _tTime: 0,
        _tDur: 0,
        _dirty: 0,
        _repeat: 0,
        _yoyo: !1,
        parent: null,
        _initted: !1,
        _rDelay: 0,
        _ts: 1,
        _dp: 0,
        ratio: 0,
        _zTime: -1e-8,
        _prom: 0,
        _ps: !1,
        _rts: 1,
      });
      var Rt = (function (e) {
        function t(t, i) {
          var s;
          return (
            void 0 === t && (t = {}),
            ((s = e.call(this, t) || this).labels = {}),
            (s.smoothChildTiming = !!t.smoothChildTiming),
            (s.autoRemoveChildren = !!t.autoRemoveChildren),
            (s._sort = D(t.sortChildren)),
            l && Fe(t.parent || l, n(s), i),
            t.reversed && s.reverse(),
            t.paused && s.paused(!0),
            t.scrollTrigger && je(n(s), t.scrollTrigger),
            s
          );
        }
        s(t, e);
        var i = t.prototype;
        return (
          (i.to = function (e, t, i) {
            return Ue(0, arguments, this), this;
          }),
          (i.from = function (e, t, i) {
            return Ue(1, arguments, this), this;
          }),
          (i.fromTo = function (e, t, i, n) {
            return Ue(2, arguments, this), this;
          }),
          (i.set = function (e, t, i) {
            return (
              (t.duration = 0),
              (t.parent = this),
              Ee(t).repeatDelay || (t.repeat = 0),
              (t.immediateRender = !!t.immediateRender),
              new Zt(e, t, Xe(this, i), 1),
              this
            );
          }),
          (i.call = function (e, t, i) {
            return Fe(this, Zt.delayedCall(0, e, t), i);
          }),
          (i.staggerTo = function (e, t, i, n, s, r, a) {
            return (
              (i.duration = t),
              (i.stagger = i.stagger || n),
              (i.onComplete = r),
              (i.onCompleteParams = a),
              (i.parent = this),
              new Zt(e, i, Xe(this, s)),
              this
            );
          }),
          (i.staggerFrom = function (e, t, i, n, s, r, a) {
            return (
              (i.runBackwards = 1),
              (Ee(i).immediateRender = D(i.immediateRender)),
              this.staggerTo(e, t, i, n, s, r, a)
            );
          }),
          (i.staggerFromTo = function (e, t, i, n, s, r, a, o) {
            return (
              (n.startAt = i),
              (Ee(n).immediateRender = D(n.immediateRender)),
              this.staggerTo(e, t, n, s, r, a, o)
            );
          }),
          (i.render = function (e, t, i) {
            var n,
              s,
              r,
              o,
              d,
              u,
              c,
              p,
              h,
              f,
              m,
              g,
              v = this._time,
              y = this._dirty ? this.totalDuration() : this._tDur,
              _ = this._dur,
              b = e <= 0 ? 0 : me(e),
              w = this._zTime < 0 != e < 0 && (this._initted || !_);
            if (
              (this !== l && b > y && e >= 0 && (b = y),
              b !== this._tTime || i || w)
            ) {
              if (
                (v !== this._time &&
                  _ &&
                  ((b += this._time - v), (e += this._time - v)),
                (n = b),
                (h = this._start),
                (u = !(p = this._ts)),
                w && (_ || (v = this._zTime), (e || !t) && (this._zTime = e)),
                this._repeat)
              ) {
                if (
                  ((m = this._yoyo),
                  (d = _ + this._rDelay),
                  this._repeat < -1 && e < 0)
                )
                  return this.totalTime(100 * d + e, t, i);
                if (
                  ((n = me(b % d)),
                  b === y
                    ? ((o = this._repeat), (n = _))
                    : ((o = ~~(b / d)) && o === b / d && ((n = _), o--),
                      n > _ && (n = _)),
                  (f = De(this._tTime, d)),
                  !v && this._tTime && f !== o && (f = o),
                  m && 1 & o && ((n = _ - n), (g = 1)),
                  o !== f && !this._lock)
                ) {
                  var T = m && 1 & f,
                    C = T === (m && 1 & o);
                  if (
                    (o < f && (T = !T),
                    (v = T ? 0 : _),
                    (this._lock = 1),
                    (this.render(v || (g ? 0 : me(o * d)), t, !_)._lock = 0),
                    (this._tTime = b),
                    !t && this.parent && pt(this, "onRepeat"),
                    this.vars.repeatRefresh &&
                      !g &&
                      (this.invalidate()._lock = 1),
                    (v && v !== this._time) ||
                      u !== !this._ts ||
                      (this.vars.onRepeat && !this.parent && !this._act))
                  )
                    return this;
                  if (
                    ((_ = this._dur),
                    (y = this._tDur),
                    C &&
                      ((this._lock = 2),
                      (v = T ? _ : -1e-4),
                      this.render(v, !0),
                      this.vars.repeatRefresh && !g && this.invalidate()),
                    (this._lock = 0),
                    !this._ts && !u)
                  )
                    return this;
                  Lt(this, g);
                }
              }
              if (
                (this._hasPause &&
                  !this._forcing &&
                  this._lock < 2 &&
                  ((c = (function (e, t, i) {
                    var n;
                    if (i > t)
                      for (n = e._first; n && n._start <= i; ) {
                        if ("isPause" === n.data && n._start > t) return n;
                        n = n._next;
                      }
                    else
                      for (n = e._last; n && n._start >= i; ) {
                        if ("isPause" === n.data && n._start < t) return n;
                        n = n._prev;
                      }
                  })(this, me(v), me(n))),
                  c && (b -= n - (n = c._start))),
                (this._tTime = b),
                (this._time = n),
                (this._act = !p),
                this._initted ||
                  ((this._onUpdate = this.vars.onUpdate),
                  (this._initted = 1),
                  (this._zTime = e),
                  (v = 0)),
                !v && n && !t && (pt(this, "onStart"), this._tTime !== b))
              )
                return this;
              if (n >= v && e >= 0)
                for (s = this._first; s; ) {
                  if (
                    ((r = s._next),
                    (s._act || n >= s._start) && s._ts && c !== s)
                  ) {
                    if (s.parent !== this) return this.render(e, t, i);
                    if (
                      (s.render(
                        s._ts > 0
                          ? (n - s._start) * s._ts
                          : (s._dirty ? s.totalDuration() : s._tDur) +
                              (n - s._start) * s._ts,
                        t,
                        i
                      ),
                      n !== this._time || (!this._ts && !u))
                    ) {
                      (c = 0), r && (b += this._zTime = -1e-8);
                      break;
                    }
                  }
                  s = r;
                }
              else {
                (i = i || a), (s = this._last);
                for (var S = e < 0 ? e : n; s; ) {
                  if (
                    ((r = s._prev), (s._act || S <= s._end) && s._ts && c !== s)
                  ) {
                    if (s.parent !== this) return this.render(e, t, i);
                    if (
                      (s.render(
                        s._ts > 0
                          ? (S - s._start) * s._ts
                          : (s._dirty ? s.totalDuration() : s._tDur) +
                              (S - s._start) * s._ts,
                        t,
                        i
                      ),
                      n !== this._time || (!this._ts && !u))
                    ) {
                      (c = 0), r && (b += this._zTime = S ? -1e-8 : x);
                      break;
                    }
                  }
                  s = r;
                }
              }
              if (
                c &&
                !t &&
                (this.pause(),
                (c.render(n >= v ? 0 : -1e-8)._zTime = n >= v ? 1 : -1),
                this._ts)
              )
                return (this._start = h), Be(this), this.render(e, t, i);
              this._onUpdate && !t && pt(this, "onUpdate", !0),
                ((b === y && this._tTime >= this.totalDuration()) ||
                  (!b && v)) &&
                  ((h !== this._start && Math.abs(p) === Math.abs(this._ts)) ||
                    this._lock ||
                    ((e || !_) &&
                      ((b === y && this._ts > 0) || (!b && this._ts < 0)) &&
                      Oe(this, 1),
                    t ||
                      (e < 0 && !v) ||
                      (!b && !v && y) ||
                      (pt(
                        this,
                        b === y && e >= 0 ? "onComplete" : "onReverseComplete",
                        !0
                      ),
                      this._prom &&
                        !(b < y && this.timeScale() > 0) &&
                        this._prom())));
            }
            return this;
          }),
          (i.add = function (e, t) {
            var i = this;
            if (($(t) || (t = Xe(this, t, e)), !(e instanceof Nt))) {
              if (R(e))
                return (
                  e.forEach(function (e) {
                    return i.add(e, t);
                  }),
                  this
                );
              if (P(e)) return this.addLabel(e, t);
              if (!L(e)) return this;
              e = Zt.delayedCall(0, e);
            }
            return this !== e ? Fe(this, e, t) : this;
          }),
          (i.getChildren = function (e, t, i, n) {
            void 0 === e && (e = !0),
              void 0 === t && (t = !0),
              void 0 === i && (i = !0),
              void 0 === n && (n = -T);
            for (var s = [], r = this._first; r; )
              r._start >= n &&
                (r instanceof Zt
                  ? t && s.push(r)
                  : (i && s.push(r),
                    e && s.push.apply(s, r.getChildren(!0, t, i)))),
                (r = r._next);
            return s;
          }),
          (i.getById = function (e) {
            for (var t = this.getChildren(1, 1, 1), i = t.length; i--; )
              if (t[i].vars.id === e) return t[i];
          }),
          (i.remove = function (e) {
            return P(e)
              ? this.removeLabel(e)
              : L(e)
              ? this.killTweensOf(e)
              : (ke(this, e),
                e === this._recent && (this._recent = this._last),
                Pe(this));
          }),
          (i.totalTime = function (t, i) {
            return arguments.length
              ? ((this._forcing = 1),
                !this._dp &&
                  this._ts &&
                  (this._start = me(
                    Ct.time -
                      (this._ts > 0
                        ? t / this._ts
                        : (this.totalDuration() - t) / -this._ts)
                  )),
                e.prototype.totalTime.call(this, t, i),
                (this._forcing = 0),
                this)
              : this._tTime;
          }),
          (i.addLabel = function (e, t) {
            return (this.labels[e] = Xe(this, t)), this;
          }),
          (i.removeLabel = function (e) {
            return delete this.labels[e], this;
          }),
          (i.addPause = function (e, t, i) {
            var n = Zt.delayedCall(0, t || J, i);
            return (
              (n.data = "isPause"),
              (this._hasPause = 1),
              Fe(this, n, Xe(this, e))
            );
          }),
          (i.removePause = function (e) {
            var t = this._first;
            for (e = Xe(this, e); t; )
              t._start === e && "isPause" === t.data && Oe(t), (t = t._next);
          }),
          (i.killTweensOf = function (e, t, i) {
            for (var n = this.getTweensOf(e, i), s = n.length; s--; )
              Ft !== n[s] && n[s].kill(e, t);
            return this;
          }),
          (i.getTweensOf = function (e, t) {
            for (var i, n = [], s = tt(e), r = this._first, a = $(t); r; )
              r instanceof Zt
                ? ve(r._targets, s) &&
                  (a
                    ? (!Ft || (r._initted && r._ts)) &&
                      r.globalTime(0) <= t &&
                      r.globalTime(r.totalDuration()) > t
                    : !t || r.isActive()) &&
                  n.push(r)
                : (i = r.getTweensOf(s, t)).length && n.push.apply(n, i),
                (r = r._next);
            return n;
          }),
          (i.tweenTo = function (e, t) {
            t = t || {};
            var i,
              n = this,
              s = Xe(n, e),
              r = t,
              a = r.startAt,
              o = r.onStart,
              l = r.onStartParams,
              d = r.immediateRender,
              u = Zt.to(
                n,
                Te(
                  {
                    ease: t.ease || "none",
                    lazy: !1,
                    immediateRender: !1,
                    time: s,
                    overwrite: "auto",
                    duration:
                      t.duration ||
                      Math.abs(
                        (s - (a && "time" in a ? a.time : n._time)) /
                          n.timeScale()
                      ) ||
                      x,
                    onStart: function () {
                      if ((n.pause(), !i)) {
                        var e =
                          t.duration ||
                          Math.abs(
                            (s - (a && "time" in a ? a.time : n._time)) /
                              n.timeScale()
                          );
                        u._dur !== e && Ve(u, e, 0, 1).render(u._time, !0, !0),
                          (i = 1);
                      }
                      o && o.apply(u, l || []);
                    },
                  },
                  t
                )
              );
            return d ? u.render(0) : u;
          }),
          (i.tweenFromTo = function (e, t, i) {
            return this.tweenTo(t, Te({ startAt: { time: Xe(this, e) } }, i));
          }),
          (i.recent = function () {
            return this._recent;
          }),
          (i.nextLabel = function (e) {
            return void 0 === e && (e = this._time), ct(this, Xe(this, e));
          }),
          (i.previousLabel = function (e) {
            return void 0 === e && (e = this._time), ct(this, Xe(this, e), 1);
          }),
          (i.currentLabel = function (e) {
            return arguments.length
              ? this.seek(e, !0)
              : this.previousLabel(this._time + x);
          }),
          (i.shiftChildren = function (e, t, i) {
            void 0 === i && (i = 0);
            for (var n, s = this._first, r = this.labels; s; )
              s._start >= i && ((s._start += e), (s._end += e)), (s = s._next);
            if (t) for (n in r) r[n] >= i && (r[n] += e);
            return Pe(this);
          }),
          (i.invalidate = function () {
            var t = this._first;
            for (this._lock = 0; t; ) t.invalidate(), (t = t._next);
            return e.prototype.invalidate.call(this);
          }),
          (i.clear = function (e) {
            void 0 === e && (e = !0);
            for (var t, i = this._first; i; )
              (t = i._next), this.remove(i), (i = t);
            return (
              this._dp && (this._time = this._tTime = this._pTime = 0),
              e && (this.labels = {}),
              Pe(this)
            );
          }),
          (i.totalDuration = function (e) {
            var t,
              i,
              n,
              s = 0,
              r = this,
              a = r._last,
              o = T;
            if (arguments.length)
              return r.timeScale(
                (r._repeat < 0 ? r.duration() : r.totalDuration()) /
                  (r.reversed() ? -e : e)
              );
            if (r._dirty) {
              for (n = r.parent; a; )
                (t = a._prev),
                  a._dirty && a.totalDuration(),
                  (i = a._start) > o && r._sort && a._ts && !r._lock
                    ? ((r._lock = 1), (Fe(r, a, i - a._delay, 1)._lock = 0))
                    : (o = i),
                  i < 0 &&
                    a._ts &&
                    ((s -= i),
                    ((!n && !r._dp) || (n && n.smoothChildTiming)) &&
                      ((r._start += i / r._ts),
                      (r._time -= i),
                      (r._tTime -= i)),
                    r.shiftChildren(-i, !1, -Infinity),
                    (o = 0)),
                  a._end > s && a._ts && (s = a._end),
                  (a = t);
              Ve(r, r === l && r._time > s ? r._time : s, 1, 1), (r._dirty = 0);
            }
            return r._tDur;
          }),
          (t.updateRoot = function (e) {
            if ((l._ts && (_e(l, Ie(e, l)), (h = Ct.frame)), Ct.frame >= oe)) {
              oe += b.autoSleep || 120;
              var t = l._first;
              if ((!t || !t._ts) && b.autoSleep && Ct._listeners.length < 2) {
                for (; t && !t._ts; ) t = t._next;
                t || Ct.sleep();
              }
            }
          }),
          t
        );
      })(Nt);
      Te(Rt.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
      var Ft,
        jt,
        Gt = function (e, t, i, n, s, r, a) {
          var o,
            l,
            d,
            u,
            c,
            p,
            h,
            f,
            m = new ui(this._pt, e, t, 0, 1, si, null, s),
            g = 0,
            v = 0;
          for (
            m.b = i,
              m.e = n,
              i += "",
              (h = ~(n += "").indexOf("random(")) && (n = dt(n)),
              r && (r((f = [i, n]), e, t), (i = f[0]), (n = f[1])),
              l = i.match(H) || [];
            (o = H.exec(n));

          )
            (u = o[0]),
              (c = n.substring(g, o.index)),
              d ? (d = (d + 1) % 5) : "rgba(" === c.substr(-5) && (d = 1),
              u !== l[v++] &&
                ((p = parseFloat(l[v - 1]) || 0),
                (m._pt = {
                  _next: m._pt,
                  p: c || 1 === v ? c : ",",
                  s: p,
                  c: "=" === u.charAt(1) ? ge(p, u) - p : parseFloat(u) - p,
                  m: d && d < 4 ? Math.round : 0,
                }),
                (g = H.lastIndex));
          return (
            (m.c = g < n.length ? n.substring(g, n.length) : ""),
            (m.fp = a),
            (q.test(n) || h) && (m.e = 0),
            (this._pt = m),
            m
          );
        },
        Ht = function (e, t, i, n, s, r, a, o, l, d) {
          L(n) && (n = n(s || 0, e, r));
          var u,
            c = e[t],
            p =
              "get" !== i
                ? i
                : L(c)
                ? l
                  ? e[
                      t.indexOf("set") || !L(e["get" + t.substr(3)])
                        ? t
                        : "get" + t.substr(3)
                    ](l)
                  : e[t]()
                : c,
            h = L(c) ? (l ? Jt : Kt) : Qt;
          if (
            (P(n) &&
              (~n.indexOf("random(") && (n = dt(n)),
              "=" === n.charAt(1) &&
                ((u = ge(p, n) + (Ke(p) || 0)) || 0 === u) &&
                (n = u)),
            !d || p !== n || jt)
          )
            return isNaN(p * n) || "" === n
              ? (!c && !(t in e) && Z(t, n),
                Gt.call(this, e, t, p, n, h, o || b.stringFilter, l))
              : ((u = new ui(
                  this._pt,
                  e,
                  t,
                  +p || 0,
                  n - (p || 0),
                  "boolean" == typeof c ? ni : ii,
                  0,
                  h
                )),
                l && (u.fp = l),
                a && u.modifier(a, this, e),
                (this._pt = u));
        },
        qt = function (e, t, i, n, s, r) {
          var a, o, l, d;
          if (
            re[e] &&
            !1 !==
              (a = new re[e]()).init(
                s,
                a.rawVars
                  ? t[e]
                  : (function (e, t, i, n, s) {
                      if (
                        (L(e) && (e = Yt(e, s, t, i, n)),
                        !z(e) || (e.style && e.nodeType) || R(e) || N(e))
                      )
                        return P(e) ? Yt(e, s, t, i, n) : e;
                      var r,
                        a = {};
                      for (r in e) a[r] = Yt(e[r], s, t, i, n);
                      return a;
                    })(t[e], n, s, r, i),
                i,
                n,
                r
              ) &&
            ((i._pt = o =
              new ui(i._pt, s, e, 0, 1, a.render, a, 0, a.priority)),
            i !== f)
          )
            for (
              l = i._ptLookup[i._targets.indexOf(s)], d = a._props.length;
              d--;

            )
              l[a._props[d]] = o;
          return a;
        },
        Vt = function e(t, i) {
          var n,
            s,
            o,
            d,
            u,
            c,
            p,
            h,
            f,
            m,
            g,
            v,
            y,
            _ = t.vars,
            b = _.ease,
            C = _.startAt,
            S = _.immediateRender,
            E = _.lazy,
            M = _.onUpdate,
            k = _.onUpdateParams,
            O = _.callbackScope,
            P = _.runBackwards,
            L = _.yoyoEase,
            $ = _.keyframes,
            A = _.autoRevert,
            z = t._dur,
            I = t._startAt,
            B = t._targets,
            N = t.parent,
            R = N && "nested" === N.data ? N.vars.targets : B,
            F = "auto" === t._overwrite && !r,
            j = t.timeline;
          if (
            (j && (!$ || !b) && (b = "none"),
            (t._ease = $t(b, w.ease)),
            (t._yEase = L ? Pt($t(!0 === L ? b : L, w.ease)) : 0),
            L &&
              t._yoyo &&
              !t._repeat &&
              ((L = t._yEase), (t._yEase = t._ease), (t._ease = L)),
            (t._from = !j && !!_.runBackwards),
            !j || ($ && !_.stagger))
          ) {
            if (
              ((v = (h = B[0] ? ce(B[0]).harness : 0) && _[h.prop]),
              (n = Se(_, ie)),
              I &&
                (i < 0 && P && S && !A
                  ? I.render(-1, !0)
                  : I.revert(P && z ? te : ee),
                (I._lazy = 0)),
              C)
            ) {
              if (
                (Oe(
                  (t._startAt = Zt.set(
                    B,
                    Te(
                      {
                        data: "isStart",
                        overwrite: !1,
                        parent: N,
                        immediateRender: !0,
                        lazy: D(E),
                        startAt: null,
                        delay: 0,
                        onUpdate: M,
                        onUpdateParams: k,
                        callbackScope: O,
                        stagger: 0,
                      },
                      C
                    )
                  ))
                ),
                i < 0 && (a || (!S && !A)) && t._startAt.revert(te),
                S && z && i <= 0)
              )
                return void (i && (t._zTime = i));
            } else if (P && z && !I)
              if (
                (i && (S = !1),
                (o = Te(
                  {
                    overwrite: !1,
                    data: "isFromStart",
                    lazy: S && D(E),
                    immediateRender: S,
                    stagger: 0,
                    parent: N,
                  },
                  n
                )),
                v && (o[h.prop] = v),
                Oe((t._startAt = Zt.set(B, o))),
                i < 0 &&
                  (a ? t._startAt.revert(te) : t._startAt.render(-1, !0)),
                (t._zTime = i),
                S)
              ) {
                if (!i) return;
              } else e(t._startAt, x);
            for (
              t._pt = t._ptCache = 0, E = (z && D(E)) || (E && !z), s = 0;
              s < B.length;
              s++
            ) {
              if (
                ((p = (u = B[s])._gsap || ue(B)[s]._gsap),
                (t._ptLookup[s] = m = {}),
                se[p.id] && ne.length && ye(),
                (g = R === B ? s : R.indexOf(u)),
                h &&
                  !1 !== (f = new h()).init(u, v || n, t, g, R) &&
                  ((t._pt = d =
                    new ui(t._pt, u, f.name, 0, 1, f.render, f, 0, f.priority)),
                  f._props.forEach(function (e) {
                    m[e] = d;
                  }),
                  f.priority && (c = 1)),
                !h || v)
              )
                for (o in n)
                  re[o] && (f = qt(o, n, t, g, u, R))
                    ? f.priority && (c = 1)
                    : (m[o] = d =
                        Ht.call(t, u, o, "get", n[o], g, R, 0, _.stringFilter));
              t._op && t._op[s] && t.kill(u, t._op[s]),
                F &&
                  t._pt &&
                  ((Ft = t),
                  l.killTweensOf(u, m, t.globalTime(i)),
                  (y = !t.parent),
                  (Ft = 0)),
                t._pt && E && (se[p.id] = 1);
            }
            c && di(t), t._onInit && t._onInit(t);
          }
          (t._onUpdate = M),
            (t._initted = (!t._op || t._pt) && !y),
            $ && i <= 0 && j.render(T, !0, !0);
        },
        Wt = function (e, t, i, n) {
          var s,
            r,
            a = t.ease || n || "power1.inOut";
          if (R(t))
            (r = i[e] || (i[e] = [])),
              t.forEach(function (e, i) {
                return r.push({ t: (i / (t.length - 1)) * 100, v: e, e: a });
              });
          else
            for (s in t)
              (r = i[s] || (i[s] = [])),
                "ease" === s || r.push({ t: parseFloat(e), v: t[s], e: a });
        },
        Yt = function (e, t, i, n, s) {
          return L(e)
            ? e.call(t, i, n, s)
            : P(e) && ~e.indexOf("random(")
            ? dt(e)
            : e;
        },
        Xt = de + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
        Ut = {};
      he(Xt + ",id,stagger,delay,duration,paused,scrollTrigger", function (e) {
        return (Ut[e] = 1);
      });
      var Zt = (function (e) {
        function t(t, i, s, a) {
          var o;
          "number" == typeof i && ((s.duration = i), (i = s), (s = null));
          var d,
            u,
            c,
            p,
            h,
            f,
            m,
            g,
            v = (o = e.call(this, a ? i : Ee(i)) || this).vars,
            y = v.duration,
            _ = v.delay,
            w = v.immediateRender,
            T = v.stagger,
            x = v.overwrite,
            C = v.keyframes,
            S = v.defaults,
            E = v.scrollTrigger,
            M = v.yoyoEase,
            k = i.parent || l,
            O = (R(t) || N(t) ? $(t[0]) : "length" in i) ? [t] : tt(t);
          if (
            ((o._targets = O.length
              ? ue(O)
              : Q(
                  "GSAP target " + t + " not found. https://greensock.com",
                  !b.nullTargetWarn
                ) || []),
            (o._ptLookup = []),
            (o._overwrite = x),
            C || T || B(y) || B(_))
          ) {
            if (
              ((i = o.vars),
              (d = o.timeline =
                new Rt({
                  data: "nested",
                  defaults: S || {},
                  targets: k && "nested" === k.data ? k.vars.targets : O,
                })).kill(),
              (d.parent = d._dp = n(o)),
              (d._start = 0),
              T || B(y) || B(_))
            ) {
              if (((p = O.length), (m = T && st(T)), z(T)))
                for (h in T) ~Xt.indexOf(h) && (g || (g = {}), (g[h] = T[h]));
              for (u = 0; u < p; u++)
                ((c = Se(i, Ut)).stagger = 0),
                  M && (c.yoyoEase = M),
                  g && xe(c, g),
                  (f = O[u]),
                  (c.duration = +Yt(y, n(o), u, f, O)),
                  (c.delay = (+Yt(_, n(o), u, f, O) || 0) - o._delay),
                  !T &&
                    1 === p &&
                    c.delay &&
                    ((o._delay = _ = c.delay), (o._start += _), (c.delay = 0)),
                  d.to(f, c, m ? m(u, f, O) : 0),
                  (d._ease = Et.none);
              d.duration() ? (y = _ = 0) : (o.timeline = 0);
            } else if (C) {
              Ee(Te(d.vars.defaults, { ease: "none" })),
                (d._ease = $t(C.ease || i.ease || "none"));
              var P,
                L,
                A,
                I = 0;
              if (R(C))
                C.forEach(function (e) {
                  return d.to(O, e, ">");
                }),
                  d.duration();
              else {
                for (h in ((c = {}), C))
                  "ease" === h ||
                    "easeEach" === h ||
                    Wt(h, C[h], c, C.easeEach);
                for (h in c)
                  for (
                    P = c[h].sort(function (e, t) {
                      return e.t - t.t;
                    }),
                      I = 0,
                      u = 0;
                    u < P.length;
                    u++
                  )
                    ((A = {
                      ease: (L = P[u]).e,
                      duration: ((L.t - (u ? P[u - 1].t : 0)) / 100) * y,
                    })[h] = L.v),
                      d.to(O, A, I),
                      (I += A.duration);
                d.duration() < y && d.to({}, { duration: y - d.duration() });
              }
            }
            y || o.duration((y = d.duration()));
          } else o.timeline = 0;
          return (
            !0 !== x || r || ((Ft = n(o)), l.killTweensOf(O), (Ft = 0)),
            Fe(k, n(o), s),
            i.reversed && o.reverse(),
            i.paused && o.paused(!0),
            (w ||
              (!y &&
                !C &&
                o._start === me(k._time) &&
                D(w) &&
                Ae(n(o)) &&
                "nested" !== k.data)) &&
              ((o._tTime = -1e-8), o.render(Math.max(0, -_))),
            E && je(n(o), E),
            o
          );
        }
        s(t, e);
        var i = t.prototype;
        return (
          (i.render = function (e, t, i) {
            var n,
              s,
              r,
              o,
              l,
              d,
              u,
              c,
              p,
              h = this._time,
              f = this._tDur,
              m = this._dur,
              g = e < 0,
              v = e > f - x && !g ? f : e < x ? 0 : e;
            if (m) {
              if (
                v !== this._tTime ||
                !e ||
                i ||
                (!this._initted && this._tTime) ||
                (this._startAt && this._zTime < 0 !== g)
              ) {
                if (((n = v), (c = this.timeline), this._repeat)) {
                  if (((o = m + this._rDelay), this._repeat < -1 && g))
                    return this.totalTime(100 * o + e, t, i);
                  if (
                    ((n = me(v % o)),
                    v === f
                      ? ((r = this._repeat), (n = m))
                      : ((r = ~~(v / o)) && r === v / o && ((n = m), r--),
                        n > m && (n = m)),
                    (d = this._yoyo && 1 & r) &&
                      ((p = this._yEase), (n = m - n)),
                    (l = De(this._tTime, o)),
                    n === h && !i && this._initted)
                  )
                    return (this._tTime = v), this;
                  r !== l &&
                    (c && this._yEase && Lt(c, d),
                    !this.vars.repeatRefresh ||
                      d ||
                      this._lock ||
                      ((this._lock = i = 1),
                      (this.render(me(o * r), !0).invalidate()._lock = 0)));
                }
                if (!this._initted) {
                  if (Ge(this, g ? e : n, i, t)) return (this._tTime = 0), this;
                  if (h !== this._time) return this;
                  if (m !== this._dur) return this.render(e, t, i);
                }
                if (
                  ((this._tTime = v),
                  (this._time = n),
                  !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
                  (this.ratio = u = (p || this._ease)(n / m)),
                  this._from && (this.ratio = u = 1 - u),
                  n && !h && !t && (pt(this, "onStart"), this._tTime !== v))
                )
                  return this;
                for (s = this._pt; s; ) s.r(u, s.d), (s = s._next);
                (c &&
                  c.render(
                    e < 0
                      ? e
                      : !n && d
                      ? -1e-8
                      : c._dur * c._ease(n / this._dur),
                    t,
                    i
                  )) ||
                  (this._startAt && (this._zTime = e)),
                  this._onUpdate &&
                    !t &&
                    (g && $e(this, e, 0, i), pt(this, "onUpdate")),
                  this._repeat &&
                    r !== l &&
                    this.vars.onRepeat &&
                    !t &&
                    this.parent &&
                    pt(this, "onRepeat"),
                  (v !== this._tDur && v) ||
                    this._tTime !== v ||
                    (g && !this._onUpdate && $e(this, e, 0, !0),
                    (e || !m) &&
                      ((v === this._tDur && this._ts > 0) ||
                        (!v && this._ts < 0)) &&
                      Oe(this, 1),
                    t ||
                      (g && !h) ||
                      (!v && !h) ||
                      (pt(
                        this,
                        v === f ? "onComplete" : "onReverseComplete",
                        !0
                      ),
                      this._prom &&
                        !(v < f && this.timeScale() > 0) &&
                        this._prom()));
              }
            } else
              !(function (e, t, i, n) {
                var s,
                  r,
                  o,
                  l = e.ratio,
                  d =
                    t < 0 ||
                    (!t &&
                      ((!e._start && He(e) && (e._initted || !qe(e))) ||
                        ((e._ts < 0 || e._dp._ts < 0) && !qe(e))))
                      ? 0
                      : 1,
                  u = e._rDelay,
                  c = 0;
                if (
                  (u &&
                    e._repeat &&
                    ((c = Qe(0, e._tDur, t)),
                    (r = De(c, u)),
                    e._yoyo && 1 & r && (d = 1 - d),
                    r !== De(e._tTime, u) &&
                      ((l = 1 - d),
                      e.vars.repeatRefresh && e._initted && e.invalidate())),
                  d !== l || a || n || e._zTime === x || (!t && e._zTime))
                ) {
                  if (!e._initted && Ge(e, t, n, i)) return;
                  for (
                    o = e._zTime,
                      e._zTime = t || (i ? x : 0),
                      i || (i = t && !o),
                      e.ratio = d,
                      e._from && (d = 1 - d),
                      e._time = 0,
                      e._tTime = c,
                      s = e._pt;
                    s;

                  )
                    s.r(d, s.d), (s = s._next);
                  t < 0 && $e(e, t, 0, !0),
                    e._onUpdate && !i && pt(e, "onUpdate"),
                    c && e._repeat && !i && e.parent && pt(e, "onRepeat"),
                    (t >= e._tDur || t < 0) &&
                      e.ratio === d &&
                      (d && Oe(e, 1),
                      i ||
                        a ||
                        (pt(e, d ? "onComplete" : "onReverseComplete", !0),
                        e._prom && e._prom()));
                } else e._zTime || (e._zTime = t);
              })(this, e, t, i);
            return this;
          }),
          (i.targets = function () {
            return this._targets;
          }),
          (i.invalidate = function () {
            return (
              (this._pt =
                this._op =
                this._startAt =
                this._onUpdate =
                this._lazy =
                this.ratio =
                  0),
              (this._ptLookup = []),
              this.timeline && this.timeline.invalidate(),
              e.prototype.invalidate.call(this)
            );
          }),
          (i.resetTo = function (e, t, i, n) {
            m || Ct.wake(), this._ts || this.play();
            var s = Math.min(
              this._dur,
              (this._dp._time - this._start) * this._ts
            );
            return (
              this._initted || Vt(this, s),
              (function (e, t, i, n, s, r, a) {
                var o,
                  l,
                  d,
                  u,
                  c = ((e._pt && e._ptCache) || (e._ptCache = {}))[t];
                if (!c)
                  for (
                    c = e._ptCache[t] = [],
                      d = e._ptLookup,
                      u = e._targets.length;
                    u--;

                  ) {
                    if ((o = d[u][t]) && o.d && o.d._pt)
                      for (o = o.d._pt; o && o.p !== t && o.fp !== t; )
                        o = o._next;
                    if (!o)
                      return (
                        (jt = 1), (e.vars[t] = "+=0"), Vt(e, a), (jt = 0), 1
                      );
                    c.push(o);
                  }
                for (u = c.length; u--; )
                  ((o = (l = c[u])._pt || l).s =
                    (!n && 0 !== n) || s ? o.s + (n || 0) + r * o.c : n),
                    (o.c = i - o.s),
                    l.e && (l.e = fe(i) + Ke(l.e)),
                    l.b && (l.b = o.s + Ke(l.b));
              })(this, e, t, i, n, this._ease(s / this._dur), s)
                ? this.resetTo(e, t, i, n)
                : (Ne(this, 0),
                  this.parent ||
                    Me(
                      this._dp,
                      this,
                      "_first",
                      "_last",
                      this._dp._sort ? "_start" : 0
                    ),
                  this.render(0))
            );
          }),
          (i.kill = function (e, t) {
            if ((void 0 === t && (t = "all"), !(e || (t && "all" !== t))))
              return (this._lazy = this._pt = 0), this.parent ? ht(this) : this;
            if (this.timeline) {
              var i = this.timeline.totalDuration();
              return (
                this.timeline.killTweensOf(e, t, Ft && !0 !== Ft.vars.overwrite)
                  ._first || ht(this),
                this.parent &&
                  i !== this.timeline.totalDuration() &&
                  Ve(this, (this._dur * this.timeline._tDur) / i, 0, 1),
                this
              );
            }
            var n,
              s,
              r,
              a,
              o,
              l,
              d,
              u = this._targets,
              c = e ? tt(e) : u,
              p = this._ptLookup,
              h = this._pt;
            if (
              (!t || "all" === t) &&
              (function (e, t) {
                for (
                  var i = e.length, n = i === t.length;
                  n && i-- && e[i] === t[i];

                );
                return i < 0;
              })(u, c)
            )
              return "all" === t && (this._pt = 0), ht(this);
            for (
              n = this._op = this._op || [],
                "all" !== t &&
                  (P(t) &&
                    ((o = {}),
                    he(t, function (e) {
                      return (o[e] = 1);
                    }),
                    (t = o)),
                  (t = (function (e, t) {
                    var i,
                      n,
                      s,
                      r,
                      a = e[0] ? ce(e[0]).harness : 0,
                      o = a && a.aliases;
                    if (!o) return t;
                    for (n in ((i = xe({}, t)), o))
                      if ((n in i))
                        for (s = (r = o[n].split(",")).length; s--; )
                          i[r[s]] = i[n];
                    return i;
                  })(u, t))),
                d = u.length;
              d--;

            )
              if (~c.indexOf(u[d]))
                for (o in ((s = p[d]),
                "all" === t
                  ? ((n[d] = t), (a = s), (r = {}))
                  : ((r = n[d] = n[d] || {}), (a = t)),
                a))
                  (l = s && s[o]) &&
                    (("kill" in l.d && !0 !== l.d.kill(o)) ||
                      ke(this, l, "_pt"),
                    delete s[o]),
                    "all" !== r && (r[o] = 1);
            return this._initted && !this._pt && h && ht(this), this;
          }),
          (t.to = function (e, i) {
            return new t(e, i, arguments[2]);
          }),
          (t.from = function (e, t) {
            return Ue(1, arguments);
          }),
          (t.delayedCall = function (e, i, n, s) {
            return new t(i, 0, {
              immediateRender: !1,
              lazy: !1,
              overwrite: !1,
              delay: e,
              onComplete: i,
              onReverseComplete: i,
              onCompleteParams: n,
              onReverseCompleteParams: n,
              callbackScope: s,
            });
          }),
          (t.fromTo = function (e, t, i) {
            return Ue(2, arguments);
          }),
          (t.set = function (e, i) {
            return (
              (i.duration = 0), i.repeatDelay || (i.repeat = 0), new t(e, i)
            );
          }),
          (t.killTweensOf = function (e, t, i) {
            return l.killTweensOf(e, t, i);
          }),
          t
        );
      })(Nt);
      Te(Zt.prototype, {
        _targets: [],
        _lazy: 0,
        _startAt: 0,
        _op: 0,
        _onInit: 0,
      }),
        he("staggerTo,staggerFrom,staggerFromTo", function (e) {
          Zt[e] = function () {
            var t = new Rt(),
              i = Je.call(arguments, 0);
            return (
              i.splice("staggerFromTo" === e ? 5 : 4, 0, 0), t[e].apply(t, i)
            );
          };
        });
      var Qt = function (e, t, i) {
          return (e[t] = i);
        },
        Kt = function (e, t, i) {
          return e[t](i);
        },
        Jt = function (e, t, i, n) {
          return e[t](n.fp, i);
        },
        ei = function (e, t, i) {
          return e.setAttribute(t, i);
        },
        ti = function (e, t) {
          return L(e[t]) ? Kt : A(e[t]) && e.setAttribute ? ei : Qt;
        },
        ii = function (e, t) {
          return t.set(t.t, t.p, Math.round(1e6 * (t.s + t.c * e)) / 1e6, t);
        },
        ni = function (e, t) {
          return t.set(t.t, t.p, !!(t.s + t.c * e), t);
        },
        si = function (e, t) {
          var i = t._pt,
            n = "";
          if (!e && t.b) n = t.b;
          else if (1 === e && t.e) n = t.e;
          else {
            for (; i; )
              (n =
                i.p +
                (i.m
                  ? i.m(i.s + i.c * e)
                  : Math.round(1e4 * (i.s + i.c * e)) / 1e4) +
                n),
                (i = i._next);
            n += t.c;
          }
          t.set(t.t, t.p, n, t);
        },
        ri = function (e, t) {
          for (var i = t._pt; i; ) i.r(e, i.d), (i = i._next);
        },
        ai = function (e, t, i, n) {
          for (var s, r = this._pt; r; )
            (s = r._next), r.p === n && r.modifier(e, t, i), (r = s);
        },
        oi = function (e) {
          for (var t, i, n = this._pt; n; )
            (i = n._next),
              (n.p === e && !n.op) || n.op === e
                ? ke(this, n, "_pt")
                : n.dep || (t = 1),
              (n = i);
          return !t;
        },
        li = function (e, t, i, n) {
          n.mSet(e, t, n.m.call(n.tween, i, n.mt), n);
        },
        di = function (e) {
          for (var t, i, n, s, r = e._pt; r; ) {
            for (t = r._next, i = n; i && i.pr > r.pr; ) i = i._next;
            (r._prev = i ? i._prev : s) ? (r._prev._next = r) : (n = r),
              (r._next = i) ? (i._prev = r) : (s = r),
              (r = t);
          }
          e._pt = n;
        },
        ui = (function () {
          function e(e, t, i, n, s, r, a, o, l) {
            (this.t = t),
              (this.s = n),
              (this.c = s),
              (this.p = i),
              (this.r = r || ii),
              (this.d = a || this),
              (this.set = o || Qt),
              (this.pr = l || 0),
              (this._next = e),
              e && (e._prev = this);
          }
          return (
            (e.prototype.modifier = function (e, t, i) {
              (this.mSet = this.mSet || this.set),
                (this.set = li),
                (this.m = e),
                (this.mt = i),
                (this.tween = t);
            }),
            e
          );
        })();
      he(
        de +
          "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
        function (e) {
          return (ie[e] = 1);
        }
      ),
        (Y.TweenMax = Y.TweenLite = Zt),
        (Y.TimelineLite = Y.TimelineMax = Rt),
        (l = new Rt({
          sortChildren: !1,
          defaults: w,
          autoRemoveChildren: !0,
          id: "root",
          smoothChildTiming: !0,
        })),
        (b.stringFilter = xt);
      var ci = [],
        pi = {},
        hi = [],
        fi = 0,
        mi = function (e) {
          return (pi[e] || hi).map(function (e) {
            return e();
          });
        },
        gi = function () {
          var e = Date.now(),
            t = [];
          e - fi > 2 &&
            (mi("matchMediaInit"),
            ci.forEach(function (e) {
              var i,
                n,
                s,
                r,
                a = e.queries,
                o = e.conditions;
              for (n in a)
                (i = d.matchMedia(a[n]).matches) && (s = 1),
                  i !== o[n] && ((o[n] = i), (r = 1));
              r && (e.revert(), s && t.push(e));
            }),
            mi("matchMediaRevert"),
            t.forEach(function (e) {
              return e.onMatch(e);
            }),
            (fi = e),
            mi("matchMedia"));
        },
        vi = (function () {
          function e(e, t) {
            (this.selector = t && it(t)),
              (this.data = []),
              (this._r = []),
              (this.isReverted = !1),
              e && this.add(e);
          }
          var t = e.prototype;
          return (
            (t.add = function (e, t, i) {
              L(e) && ((i = t), (t = e), (e = L));
              var n = this,
                s = function () {
                  var e,
                    s = o,
                    r = n.selector;
                  return (
                    s && s !== n && s.data.push(n),
                    i && (n.selector = it(i)),
                    (o = n),
                    (e = t.apply(n, arguments)),
                    L(e) && n._r.push(e),
                    (o = s),
                    (n.selector = r),
                    (n.isReverted = !1),
                    e
                  );
                };
              return (n.last = s), e === L ? s(n) : e ? (n[e] = s) : s;
            }),
            (t.ignore = function (e) {
              var t = o;
              (o = null), e(this), (o = t);
            }),
            (t.getTweens = function () {
              var t = [];
              return (
                this.data.forEach(function (i) {
                  return i instanceof e
                    ? t.push.apply(t, i.getTweens())
                    : i instanceof Zt && t.push(i);
                }),
                t
              );
            }),
            (t.clear = function () {
              this._r.length = this.data.length = 0;
            }),
            (t.kill = function (e, t) {
              var i = this;
              if (
                (e
                  ? (this.getTweens()
                      .map(function (e) {
                        return { g: e.globalTime(0), t: e };
                      })
                      .sort(function (e, t) {
                        return t.g - e.g || -1;
                      })
                      .forEach(function (t) {
                        return t.t.revert(e);
                      }),
                    this.data.forEach(function (t) {
                      return !(t instanceof Nt) && t.revert && t.revert(e);
                    }),
                    this._r.forEach(function (t) {
                      return t(e, i);
                    }),
                    (this.isReverted = !0))
                  : this.data.forEach(function (e) {
                      return e.kill && e.kill();
                    }),
                this.clear(),
                t)
              ) {
                var n = ci.indexOf(this);
                ~n && ci.splice(n, 1);
              }
            }),
            (t.revert = function (e) {
              this.kill(e || {});
            }),
            e
          );
        })(),
        yi = (function () {
          function e(e) {
            (this.contexts = []), (this.scope = e);
          }
          var t = e.prototype;
          return (
            (t.add = function (e, t, i) {
              z(e) || (e = { matches: e });
              var n,
                s,
                r,
                a = new vi(0, i || this.scope),
                o = (a.conditions = {});
              for (s in (this.contexts.push(a),
              (t = a.add("onMatch", t)),
              (a.queries = e),
              e))
                "all" === s
                  ? (r = 1)
                  : (n = d.matchMedia(e[s])) &&
                    (ci.indexOf(a) < 0 && ci.push(a),
                    (o[s] = n.matches) && (r = 1),
                    n.addListener
                      ? n.addListener(gi)
                      : n.addEventListener("change", gi));
              return r && t(a), this;
            }),
            (t.revert = function (e) {
              this.kill(e || {});
            }),
            (t.kill = function (e) {
              this.contexts.forEach(function (t) {
                return t.kill(e, !0);
              });
            }),
            e
          );
        })(),
        _i = {
          registerPlugin: function () {
            for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
              t[i] = arguments[i];
            t.forEach(function (e) {
              return ft(e);
            });
          },
          timeline: function (e) {
            return new Rt(e);
          },
          getTweensOf: function (e, t) {
            return l.getTweensOf(e, t);
          },
          getProperty: function (e, t, i, n) {
            P(e) && (e = tt(e)[0]);
            var s = ce(e || {}).get,
              r = i ? we : be;
            return (
              "native" === i && (i = ""),
              e
                ? t
                  ? r(((re[t] && re[t].get) || s)(e, t, i, n))
                  : function (t, i, n) {
                      return r(((re[t] && re[t].get) || s)(e, t, i, n));
                    }
                : e
            );
          },
          quickSetter: function (e, t, i) {
            if ((e = tt(e)).length > 1) {
              var n = e.map(function (e) {
                  return Ti.quickSetter(e, t, i);
                }),
                s = n.length;
              return function (e) {
                for (var t = s; t--; ) n[t](e);
              };
            }
            e = e[0] || {};
            var r = re[t],
              a = ce(e),
              o = (a.harness && (a.harness.aliases || {})[t]) || t,
              l = r
                ? function (t) {
                    var n = new r();
                    (f._pt = 0),
                      n.init(e, i ? t + i : t, f, 0, [e]),
                      n.render(1, n),
                      f._pt && ri(1, f);
                  }
                : a.set(e, o);
            return r
              ? l
              : function (t) {
                  return l(e, o, i ? t + i : t, a, 1);
                };
          },
          quickTo: function (e, t, i) {
            var n,
              s = Ti.to(
                e,
                xe((((n = {})[t] = "+=0.1"), (n.paused = !0), n), i || {})
              ),
              r = function (e, i, n) {
                return s.resetTo(t, e, i, n);
              };
            return (r.tween = s), r;
          },
          isTweening: function (e) {
            return l.getTweensOf(e, !0).length > 0;
          },
          defaults: function (e) {
            return e && e.ease && (e.ease = $t(e.ease, w.ease)), Ce(w, e || {});
          },
          config: function (e) {
            return Ce(b, e || {});
          },
          registerEffect: function (e) {
            var t = e.name,
              i = e.effect,
              n = e.plugins,
              s = e.defaults,
              r = e.extendTimeline;
            (n || "").split(",").forEach(function (e) {
              return (
                e &&
                !re[e] &&
                !Y[e] &&
                Q(t + " effect requires " + e + " plugin.")
              );
            }),
              (ae[t] = function (e, t, n) {
                return i(tt(e), Te(t || {}, s), n);
              }),
              r &&
                (Rt.prototype[t] = function (e, i, n) {
                  return this.add(ae[t](e, z(i) ? i : (n = i) && {}, this), n);
                });
          },
          registerEase: function (e, t) {
            Et[e] = $t(t);
          },
          parseEase: function (e, t) {
            return arguments.length ? $t(e, t) : Et;
          },
          getById: function (e) {
            return l.getById(e);
          },
          exportRoot: function (e, t) {
            void 0 === e && (e = {});
            var i,
              n,
              s = new Rt(e);
            for (
              s.smoothChildTiming = D(e.smoothChildTiming),
                l.remove(s),
                s._dp = 0,
                s._time = s._tTime = l._time,
                i = l._first;
              i;

            )
              (n = i._next),
                (!t &&
                  !i._dur &&
                  i instanceof Zt &&
                  i.vars.onComplete === i._targets[0]) ||
                  Fe(s, i, i._start - i._delay),
                (i = n);
            return Fe(l, s, 0), s;
          },
          context: function (e, t) {
            return e ? new vi(e, t) : o;
          },
          matchMedia: function (e) {
            return new yi(e);
          },
          matchMediaRefresh: function () {
            return (
              ci.forEach(function (e) {
                var t,
                  i,
                  n = e.conditions;
                for (i in n) n[i] && ((n[i] = !1), (t = 1));
                t && e.revert();
              }) || gi()
            );
          },
          addEventListener: function (e, t) {
            var i = pi[e] || (pi[e] = []);
            ~i.indexOf(t) || i.push(t);
          },
          removeEventListener: function (e, t) {
            var i = pi[e],
              n = i && i.indexOf(t);
            n >= 0 && i.splice(n, 1);
          },
          utils: {
            wrap: function e(t, i, n) {
              var s = i - t;
              return R(t)
                ? lt(t, e(0, t.length), i)
                : Ze(n, function (e) {
                    return ((s + ((e - t) % s)) % s) + t;
                  });
            },
            wrapYoyo: function e(t, i, n) {
              var s = i - t,
                r = 2 * s;
              return R(t)
                ? lt(t, e(0, t.length - 1), i)
                : Ze(n, function (e) {
                    return (
                      t + ((e = (r + ((e - t) % r)) % r || 0) > s ? r - e : e)
                    );
                  });
            },
            distribute: st,
            random: ot,
            snap: at,
            normalize: function (e, t, i) {
              return ut(e, t, 0, 1, i);
            },
            getUnit: Ke,
            clamp: function (e, t, i) {
              return Ze(i, function (i) {
                return Qe(e, t, i);
              });
            },
            splitColor: yt,
            toArray: tt,
            selector: it,
            mapRange: ut,
            pipe: function () {
              for (
                var e = arguments.length, t = new Array(e), i = 0;
                i < e;
                i++
              )
                t[i] = arguments[i];
              return function (e) {
                return t.reduce(function (e, t) {
                  return t(e);
                }, e);
              };
            },
            unitize: function (e, t) {
              return function (i) {
                return e(parseFloat(i)) + (t || Ke(i));
              };
            },
            interpolate: function e(t, i, n, s) {
              var r = isNaN(t + i)
                ? 0
                : function (e) {
                    return (1 - e) * t + e * i;
                  };
              if (!r) {
                var a,
                  o,
                  l,
                  d,
                  u,
                  c = P(t),
                  p = {};
                if ((!0 === n && (s = 1) && (n = null), c))
                  (t = { p: t }), (i = { p: i });
                else if (R(t) && !R(i)) {
                  for (l = [], d = t.length, u = d - 2, o = 1; o < d; o++)
                    l.push(e(t[o - 1], t[o]));
                  d--,
                    (r = function (e) {
                      e *= d;
                      var t = Math.min(u, ~~e);
                      return l[t](e - t);
                    }),
                    (n = i);
                } else s || (t = xe(R(t) ? [] : {}, t));
                if (!l) {
                  for (a in i) Ht.call(p, t, a, "get", i[a]);
                  r = function (e) {
                    return ri(e, p) || (c ? t.p : t);
                  };
                }
              }
              return Ze(n, r);
            },
            shuffle: nt,
          },
          install: U,
          effects: ae,
          ticker: Ct,
          updateRoot: Rt.updateRoot,
          plugins: re,
          globalTimeline: l,
          core: {
            PropTween: ui,
            globals: K,
            Tween: Zt,
            Timeline: Rt,
            Animation: Nt,
            getCache: ce,
            _removeLinkedListItem: ke,
            reverting: function () {
              return a;
            },
            context: function (e) {
              return e && o && (o.data.push(e), (e._ctx = o)), o;
            },
            suppressOverwrites: function (e) {
              return (r = e);
            },
          },
        };
      he("to,from,fromTo,delayedCall,set,killTweensOf", function (e) {
        return (_i[e] = Zt[e]);
      }),
        Ct.add(Rt.updateRoot),
        (f = _i.to({}, { duration: 0 }));
      var bi = function (e, t) {
          for (var i = e._pt; i && i.p !== t && i.op !== t && i.fp !== t; )
            i = i._next;
          return i;
        },
        wi = function (e, t) {
          return {
            name: e,
            rawVars: 1,
            init: function (e, i, n) {
              n._onInit = function (e) {
                var n, s;
                if (
                  (P(i) &&
                    ((n = {}),
                    he(i, function (e) {
                      return (n[e] = 1);
                    }),
                    (i = n)),
                  t)
                ) {
                  for (s in ((n = {}), i)) n[s] = t(i[s]);
                  i = n;
                }
                !(function (e, t) {
                  var i,
                    n,
                    s,
                    r = e._targets;
                  for (i in t)
                    for (n = r.length; n--; )
                      (s = e._ptLookup[n][i]) &&
                        (s = s.d) &&
                        (s._pt && (s = bi(s, i)),
                        s && s.modifier && s.modifier(t[i], e, r[n], i));
                })(e, i);
              };
            },
          };
        },
        Ti =
          _i.registerPlugin(
            {
              name: "attr",
              init: function (e, t, i, n, s) {
                var r, a, o;
                for (r in ((this.tween = i), t))
                  (o = e.getAttribute(r) || ""),
                    ((a = this.add(
                      e,
                      "setAttribute",
                      (o || 0) + "",
                      t[r],
                      n,
                      s,
                      0,
                      0,
                      r
                    )).op = r),
                    (a.b = o),
                    this._props.push(r);
              },
              render: function (e, t) {
                for (var i = t._pt; i; )
                  a ? i.set(i.t, i.p, i.b, i) : i.r(e, i.d), (i = i._next);
              },
            },
            {
              name: "endArray",
              init: function (e, t) {
                for (var i = t.length; i--; )
                  this.add(e, i, e[i] || 0, t[i], 0, 0, 0, 0, 0, 1);
              },
            },
            wi("roundProps", rt),
            wi("modifiers"),
            wi("snap", at)
          ) || _i;
      (Zt.version = Rt.version = Ti.version = "3.11.1"),
        (p = 1),
        I() && St(),
        Et.Power0,
        Et.Power1,
        Et.Power2,
        Et.Power3,
        Et.Power4,
        Et.Linear,
        Et.Quad,
        Et.Cubic,
        Et.Quart,
        Et.Quint,
        Et.Strong,
        Et.Elastic,
        Et.Back,
        Et.SteppedEase,
        Et.Bounce,
        Et.Sine,
        Et.Expo,
        Et.Circ;
      var xi,
        Ci,
        Si,
        Ei,
        Mi,
        ki,
        Oi,
        Pi,
        Li = {},
        $i = 180 / Math.PI,
        Ai = Math.PI / 180,
        zi = Math.atan2,
        Di = /([A-Z])/g,
        Ii = /(left|right|width|margin|padding|x)/i,
        Bi = /[\s,\(]\S/,
        Ni = {
          autoAlpha: "opacity,visibility",
          scale: "scaleX,scaleY",
          alpha: "opacity",
        },
        Ri = function (e, t) {
          return t.set(
            t.t,
            t.p,
            Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u,
            t
          );
        },
        Fi = function (e, t) {
          return t.set(
            t.t,
            t.p,
            1 === e ? t.e : Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u,
            t
          );
        },
        ji = function (e, t) {
          return t.set(
            t.t,
            t.p,
            e ? Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u : t.b,
            t
          );
        },
        Gi = function (e, t) {
          var i = t.s + t.c * e;
          t.set(t.t, t.p, ~~(i + (i < 0 ? -0.5 : 0.5)) + t.u, t);
        },
        Hi = function (e, t) {
          return t.set(t.t, t.p, e ? t.e : t.b, t);
        },
        qi = function (e, t) {
          return t.set(t.t, t.p, 1 !== e ? t.b : t.e, t);
        },
        Vi = function (e, t, i) {
          return (e.style[t] = i);
        },
        Wi = function (e, t, i) {
          return e.style.setProperty(t, i);
        },
        Yi = function (e, t, i) {
          return (e._gsap[t] = i);
        },
        Xi = function (e, t, i) {
          return (e._gsap.scaleX = e._gsap.scaleY = i);
        },
        Ui = function (e, t, i, n, s) {
          var r = e._gsap;
          (r.scaleX = r.scaleY = i), r.renderTransform(s, r);
        },
        Zi = function (e, t, i, n, s) {
          var r = e._gsap;
          (r[t] = i), r.renderTransform(s, r);
        },
        Qi = "transform",
        Ki = Qi + "Origin",
        Ji = function (e) {
          var t = this,
            i = this.target,
            n = i.style;
          if (e in Li) {
            if (
              ((this.tfm = this.tfm || {}),
              "transform" !== e &&
                (~(e = Ni[e] || e).indexOf(",")
                  ? e.split(",").forEach(function (e) {
                      return (t.tfm[e] = yn(i, e));
                    })
                  : (this.tfm[e] = i._gsap.x ? i._gsap[e] : yn(i, e))),
              this.props.indexOf(Qi) >= 0)
            )
              return;
            i._gsap.svg &&
              ((this.svgo = i.getAttribute("data-svg-origin")),
              this.props.push(Ki, "")),
              (e = Qi);
          }
          n && this.props.push(e, n[e]);
        },
        en = function (e) {
          e.translate &&
            (e.removeProperty("translate"),
            e.removeProperty("scale"),
            e.removeProperty("rotate"));
        },
        tn = function () {
          var e,
            t,
            i = this.props,
            n = this.target,
            s = n.style,
            r = n._gsap;
          for (e = 0; e < i.length; e += 2)
            i[e + 1]
              ? (s[i[e]] = i[e + 1])
              : s.removeProperty(i[e].replace(Di, "-$1").toLowerCase());
          if (this.tfm) {
            for (t in this.tfm) r[t] = this.tfm[t];
            r.svg &&
              (r.renderTransform(),
              n.setAttribute("data-svg-origin", this.svgo || "")),
              !(e = Oi()) || e.isStart || s[Qi] || (en(s), (r.uncache = 1));
          }
        },
        nn = function (e, t) {
          var i = { target: e, props: [], revert: tn, save: Ji };
          return (
            t &&
              t.split(",").forEach(function (e) {
                return i.save(e);
              }),
            i
          );
        },
        sn = function (e, t) {
          var i = Ci.createElementNS
            ? Ci.createElementNS(
                (t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"),
                e
              )
            : Ci.createElement(e);
          return i.style ? i : Ci.createElement(e);
        },
        rn = function e(t, i, n) {
          var s = getComputedStyle(t);
          return (
            s[i] ||
            s.getPropertyValue(i.replace(Di, "-$1").toLowerCase()) ||
            s.getPropertyValue(i) ||
            (!n && e(t, on(i) || i, 1)) ||
            ""
          );
        },
        an = "O,Moz,ms,Ms,Webkit".split(","),
        on = function (e, t, i) {
          var n = (t || Mi).style,
            s = 5;
          if (e in n && !i) return e;
          for (
            e = e.charAt(0).toUpperCase() + e.substr(1);
            s-- && !(an[s] + e in n);

          );
          return s < 0 ? null : (3 === s ? "ms" : s >= 0 ? an[s] : "") + e;
        },
        ln = function () {
          "undefined" != typeof window &&
            window.document &&
            ((xi = window),
            (Ci = xi.document),
            (Si = Ci.documentElement),
            (Mi = sn("div") || { style: {} }),
            sn("div"),
            (Qi = on(Qi)),
            (Ki = Qi + "Origin"),
            (Mi.style.cssText =
              "border-width:0;line-height:0;position:absolute;padding:0"),
            (Pi = !!on("perspective")),
            (Oi = Ti.core.reverting),
            (Ei = 1));
        },
        dn = function e(t) {
          var i,
            n = sn(
              "svg",
              (this.ownerSVGElement &&
                this.ownerSVGElement.getAttribute("xmlns")) ||
                "http://www.w3.org/2000/svg"
            ),
            s = this.parentNode,
            r = this.nextSibling,
            a = this.style.cssText;
          if (
            (Si.appendChild(n),
            n.appendChild(this),
            (this.style.display = "block"),
            t)
          )
            try {
              (i = this.getBBox()),
                (this._gsapBBox = this.getBBox),
                (this.getBBox = e);
            } catch (e) {}
          else this._gsapBBox && (i = this._gsapBBox());
          return (
            s && (r ? s.insertBefore(this, r) : s.appendChild(this)),
            Si.removeChild(n),
            (this.style.cssText = a),
            i
          );
        },
        un = function (e, t) {
          for (var i = t.length; i--; )
            if (e.hasAttribute(t[i])) return e.getAttribute(t[i]);
        },
        cn = function (e) {
          var t;
          try {
            t = e.getBBox();
          } catch (i) {
            t = dn.call(e, !0);
          }
          return (
            (t && (t.width || t.height)) ||
              e.getBBox === dn ||
              (t = dn.call(e, !0)),
            !t || t.width || t.x || t.y
              ? t
              : {
                  x: +un(e, ["x", "cx", "x1"]) || 0,
                  y: +un(e, ["y", "cy", "y1"]) || 0,
                  width: 0,
                  height: 0,
                }
          );
        },
        pn = function (e) {
          return !(!e.getCTM || (e.parentNode && !e.ownerSVGElement) || !cn(e));
        },
        hn = function (e, t) {
          if (t) {
            var i = e.style;
            t in Li && t !== Ki && (t = Qi),
              i.removeProperty
                ? (("ms" !== t.substr(0, 2) && "webkit" !== t.substr(0, 6)) ||
                    (t = "-" + t),
                  i.removeProperty(t.replace(Di, "-$1").toLowerCase()))
                : i.removeAttribute(t);
          }
        },
        fn = function (e, t, i, n, s, r) {
          var a = new ui(e._pt, t, i, 0, 1, r ? qi : Hi);
          return (e._pt = a), (a.b = n), (a.e = s), e._props.push(i), a;
        },
        mn = { deg: 1, rad: 1, turn: 1 },
        gn = { grid: 1, flex: 1 },
        vn = function e(t, i, n, s) {
          var r,
            a,
            o,
            l,
            d = parseFloat(n) || 0,
            u = (n + "").trim().substr((d + "").length) || "px",
            c = Mi.style,
            p = Ii.test(i),
            h = "svg" === t.tagName.toLowerCase(),
            f = (h ? "client" : "offset") + (p ? "Width" : "Height"),
            m = 100,
            g = "px" === s,
            v = "%" === s;
          return s === u || !d || mn[s] || mn[u]
            ? d
            : ("px" !== u && !g && (d = e(t, i, n, "px")),
              (l = t.getCTM && pn(t)),
              (!v && "%" !== u) || (!Li[i] && !~i.indexOf("adius"))
                ? ((c[p ? "width" : "height"] = m + (g ? u : s)),
                  (a =
                    ~i.indexOf("adius") || ("em" === s && t.appendChild && !h)
                      ? t
                      : t.parentNode),
                  l && (a = (t.ownerSVGElement || {}).parentNode),
                  (a && a !== Ci && a.appendChild) || (a = Ci.body),
                  (o = a._gsap) &&
                  v &&
                  o.width &&
                  p &&
                  o.time === Ct.time &&
                  !o.uncache
                    ? fe((d / o.width) * m)
                    : ((v || "%" === u) &&
                        !gn[rn(a, "display")] &&
                        (c.position = rn(t, "position")),
                      a === t && (c.position = "static"),
                      a.appendChild(Mi),
                      (r = Mi[f]),
                      a.removeChild(Mi),
                      (c.position = "absolute"),
                      p &&
                        v &&
                        (((o = ce(a)).time = Ct.time), (o.width = a[f])),
                      fe(g ? (r * d) / m : r && d ? (m / r) * d : 0)))
                : ((r = l ? t.getBBox()[p ? "width" : "height"] : t[f]),
                  fe(v ? (d / r) * m : (d / 100) * r)));
        },
        yn = function (e, t, i, n) {
          var s;
          return (
            Ei || ln(),
            t in Ni &&
              "transform" !== t &&
              ~(t = Ni[t]).indexOf(",") &&
              (t = t.split(",")[0]),
            Li[t] && "transform" !== t
              ? ((s = On(e, n)),
                (s =
                  "transformOrigin" !== t
                    ? s[t]
                    : s.svg
                    ? s.origin
                    : Pn(rn(e, Ki)) + " " + s.zOrigin + "px"))
              : (!(s = e.style[t]) ||
                  "auto" === s ||
                  n ||
                  ~(s + "").indexOf("calc(")) &&
                (s =
                  (Tn[t] && Tn[t](e, t, i)) ||
                  rn(e, t) ||
                  pe(e, t) ||
                  ("opacity" === t ? 1 : 0)),
            i && !~(s + "").trim().indexOf(" ") ? vn(e, t, s, i) + i : s
          );
        },
        _n = function (e, t, i, n) {
          if (!i || "none" === i) {
            var s = on(t, e, 1),
              r = s && rn(e, s, 1);
            r && r !== i
              ? ((t = s), (i = r))
              : "borderColor" === t && (i = rn(e, "borderTopColor"));
          }
          var a,
            o,
            l,
            d,
            u,
            c,
            p,
            h,
            f,
            m,
            g,
            v = new ui(this._pt, e.style, t, 0, 1, si),
            y = 0,
            _ = 0;
          if (
            ((v.b = i),
            (v.e = n),
            (i += ""),
            "auto" == (n += "") &&
              ((e.style[t] = n), (n = rn(e, t) || n), (e.style[t] = i)),
            xt((a = [i, n])),
            (n = a[1]),
            (l = (i = a[0]).match(G) || []),
            (n.match(G) || []).length)
          ) {
            for (; (o = G.exec(n)); )
              (p = o[0]),
                (f = n.substring(y, o.index)),
                u
                  ? (u = (u + 1) % 5)
                  : ("rgba(" !== f.substr(-5) && "hsla(" !== f.substr(-5)) ||
                    (u = 1),
                p !== (c = l[_++] || "") &&
                  ((d = parseFloat(c) || 0),
                  (g = c.substr((d + "").length)),
                  "=" === p.charAt(1) && (p = ge(d, p) + g),
                  (h = parseFloat(p)),
                  (m = p.substr((h + "").length)),
                  (y = G.lastIndex - m.length),
                  m ||
                    ((m = m || b.units[t] || g),
                    y === n.length && ((n += m), (v.e += m))),
                  g !== m && (d = vn(e, t, c, m) || 0),
                  (v._pt = {
                    _next: v._pt,
                    p: f || 1 === _ ? f : ",",
                    s: d,
                    c: h - d,
                    m: (u && u < 4) || "zIndex" === t ? Math.round : 0,
                  }));
            v.c = y < n.length ? n.substring(y, n.length) : "";
          } else v.r = "display" === t && "none" === n ? qi : Hi;
          return q.test(n) && (v.e = 0), (this._pt = v), v;
        },
        bn = {
          top: "0%",
          bottom: "100%",
          left: "0%",
          right: "100%",
          center: "50%",
        },
        wn = function (e, t) {
          if (t.tween && t.tween._time === t.tween._dur) {
            var i,
              n,
              s,
              r = t.t,
              a = r.style,
              o = t.u,
              l = r._gsap;
            if ("all" === o || !0 === o) (a.cssText = ""), (n = 1);
            else
              for (s = (o = o.split(",")).length; --s > -1; )
                (i = o[s]),
                  Li[i] && ((n = 1), (i = "transformOrigin" === i ? Ki : Qi)),
                  hn(r, i);
            n &&
              (hn(r, Qi),
              l &&
                (l.svg && r.removeAttribute("transform"),
                On(r, 1),
                (l.uncache = 1),
                en(a)));
          }
        },
        Tn = {
          clearProps: function (e, t, i, n, s) {
            if ("isFromStart" !== s.data) {
              var r = (e._pt = new ui(e._pt, t, i, 0, 0, wn));
              return (
                (r.u = n), (r.pr = -10), (r.tween = s), e._props.push(i), 1
              );
            }
          },
        },
        xn = [1, 0, 0, 1, 0, 0],
        Cn = {},
        Sn = function (e) {
          return "matrix(1, 0, 0, 1, 0, 0)" === e || "none" === e || !e;
        },
        En = function (e) {
          var t = rn(e, Qi);
          return Sn(t) ? xn : t.substr(7).match(j).map(fe);
        },
        Mn = function (e, t) {
          var i,
            n,
            s,
            r,
            a = e._gsap || ce(e),
            o = e.style,
            l = En(e);
          return a.svg && e.getAttribute("transform")
            ? "1,0,0,1,0,0" ===
              (l = [
                (s = e.transform.baseVal.consolidate().matrix).a,
                s.b,
                s.c,
                s.d,
                s.e,
                s.f,
              ]).join(",")
              ? xn
              : l
            : (l !== xn ||
                e.offsetParent ||
                e === Si ||
                a.svg ||
                ((s = o.display),
                (o.display = "block"),
                ((i = e.parentNode) && e.offsetParent) ||
                  ((r = 1), (n = e.nextElementSibling), Si.appendChild(e)),
                (l = En(e)),
                s ? (o.display = s) : hn(e, "display"),
                r &&
                  (n
                    ? i.insertBefore(e, n)
                    : i
                    ? i.appendChild(e)
                    : Si.removeChild(e))),
              t && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l);
        },
        kn = function (e, t, i, n, s, r) {
          var a,
            o,
            l,
            d = e._gsap,
            u = s || Mn(e, !0),
            c = d.xOrigin || 0,
            p = d.yOrigin || 0,
            h = d.xOffset || 0,
            f = d.yOffset || 0,
            m = u[0],
            g = u[1],
            v = u[2],
            y = u[3],
            _ = u[4],
            b = u[5],
            w = t.split(" "),
            T = parseFloat(w[0]) || 0,
            x = parseFloat(w[1]) || 0;
          i
            ? u !== xn &&
              (o = m * y - g * v) &&
              ((l = T * (-g / o) + x * (m / o) - (m * b - g * _) / o),
              (T = T * (y / o) + x * (-v / o) + (v * b - y * _) / o),
              (x = l))
            : ((T =
                (a = cn(e)).x + (~w[0].indexOf("%") ? (T / 100) * a.width : T)),
              (x =
                a.y +
                (~(w[1] || w[0]).indexOf("%") ? (x / 100) * a.height : x))),
            n || (!1 !== n && d.smooth)
              ? ((_ = T - c),
                (b = x - p),
                (d.xOffset = h + (_ * m + b * v) - _),
                (d.yOffset = f + (_ * g + b * y) - b))
              : (d.xOffset = d.yOffset = 0),
            (d.xOrigin = T),
            (d.yOrigin = x),
            (d.smooth = !!n),
            (d.origin = t),
            (d.originIsAbsolute = !!i),
            (e.style[Ki] = "0px 0px"),
            r &&
              (fn(r, d, "xOrigin", c, T),
              fn(r, d, "yOrigin", p, x),
              fn(r, d, "xOffset", h, d.xOffset),
              fn(r, d, "yOffset", f, d.yOffset)),
            e.setAttribute("data-svg-origin", T + " " + x);
        },
        On = function (e, t) {
          var i = e._gsap || new Bt(e);
          if ("x" in i && !t && !i.uncache) return i;
          var n,
            s,
            r,
            a,
            o,
            l,
            d,
            u,
            c,
            p,
            h,
            f,
            m,
            g,
            v,
            y,
            _,
            w,
            T,
            x,
            C,
            S,
            E,
            M,
            k,
            O,
            P,
            L,
            $,
            A,
            z,
            D,
            I = e.style,
            B = i.scaleX < 0,
            N = "px",
            R = "deg",
            F = getComputedStyle(e),
            j = rn(e, Ki) || "0";
          return (
            (n = s = r = l = d = u = c = p = h = 0),
            (a = o = 1),
            (i.svg = !(!e.getCTM || !pn(e))),
            F.translate &&
              (("none" === F.translate &&
                "none" === F.scale &&
                "none" === F.rotate) ||
                (I[Qi] =
                  ("none" !== F.translate
                    ? "translate3d(" +
                      (F.translate + " 0 0").split(" ").slice(0, 3).join(", ") +
                      ") "
                    : "") +
                  ("none" !== F.rotate ? "rotate(" + F.rotate + ") " : "") +
                  ("none" !== F.scale
                    ? "scale(" + F.scale.split(" ").join(",") + ") "
                    : "") +
                  F[Qi]),
              (I.scale = I.rotate = I.translate = "none")),
            (g = Mn(e, i.svg)),
            i.svg &&
              (i.uncache
                ? ((k = e.getBBox()),
                  (j = i.xOrigin - k.x + "px " + (i.yOrigin - k.y) + "px"),
                  (M = ""))
                : (M = !t && e.getAttribute("data-svg-origin")),
              kn(e, M || j, !!M || i.originIsAbsolute, !1 !== i.smooth, g)),
            (f = i.xOrigin || 0),
            (m = i.yOrigin || 0),
            g !== xn &&
              ((w = g[0]),
              (T = g[1]),
              (x = g[2]),
              (C = g[3]),
              (n = S = g[4]),
              (s = E = g[5]),
              6 === g.length
                ? ((a = Math.sqrt(w * w + T * T)),
                  (o = Math.sqrt(C * C + x * x)),
                  (l = w || T ? zi(T, w) * $i : 0),
                  (c = x || C ? zi(x, C) * $i + l : 0) &&
                    (o *= Math.abs(Math.cos(c * Ai))),
                  i.svg &&
                    ((n -= f - (f * w + m * x)), (s -= m - (f * T + m * C))))
                : ((D = g[6]),
                  (A = g[7]),
                  (P = g[8]),
                  (L = g[9]),
                  ($ = g[10]),
                  (z = g[11]),
                  (n = g[12]),
                  (s = g[13]),
                  (r = g[14]),
                  (d = (v = zi(D, $)) * $i),
                  v &&
                    ((M = S * (y = Math.cos(-v)) + P * (_ = Math.sin(-v))),
                    (k = E * y + L * _),
                    (O = D * y + $ * _),
                    (P = S * -_ + P * y),
                    (L = E * -_ + L * y),
                    ($ = D * -_ + $ * y),
                    (z = A * -_ + z * y),
                    (S = M),
                    (E = k),
                    (D = O)),
                  (u = (v = zi(-x, $)) * $i),
                  v &&
                    ((y = Math.cos(-v)),
                    (z = C * (_ = Math.sin(-v)) + z * y),
                    (w = M = w * y - P * _),
                    (T = k = T * y - L * _),
                    (x = O = x * y - $ * _)),
                  (l = (v = zi(T, w)) * $i),
                  v &&
                    ((M = w * (y = Math.cos(v)) + T * (_ = Math.sin(v))),
                    (k = S * y + E * _),
                    (T = T * y - w * _),
                    (E = E * y - S * _),
                    (w = M),
                    (S = k)),
                  d &&
                    Math.abs(d) + Math.abs(l) > 359.9 &&
                    ((d = l = 0), (u = 180 - u)),
                  (a = fe(Math.sqrt(w * w + T * T + x * x))),
                  (o = fe(Math.sqrt(E * E + D * D))),
                  (v = zi(S, E)),
                  (c = Math.abs(v) > 2e-4 ? v * $i : 0),
                  (h = z ? 1 / (z < 0 ? -z : z) : 0)),
              i.svg &&
                ((M = e.getAttribute("transform")),
                (i.forceCSS =
                  e.setAttribute("transform", "") || !Sn(rn(e, Qi))),
                M && e.setAttribute("transform", M))),
            Math.abs(c) > 90 &&
              Math.abs(c) < 270 &&
              (B
                ? ((a *= -1),
                  (c += l <= 0 ? 180 : -180),
                  (l += l <= 0 ? 180 : -180))
                : ((o *= -1), (c += c <= 0 ? 180 : -180))),
            (t = t || i.uncache),
            (i.x =
              n -
              ((i.xPercent =
                n &&
                ((!t && i.xPercent) ||
                  (Math.round(e.offsetWidth / 2) === Math.round(-n) ? -50 : 0)))
                ? (e.offsetWidth * i.xPercent) / 100
                : 0) +
              N),
            (i.y =
              s -
              ((i.yPercent =
                s &&
                ((!t && i.yPercent) ||
                  (Math.round(e.offsetHeight / 2) === Math.round(-s)
                    ? -50
                    : 0)))
                ? (e.offsetHeight * i.yPercent) / 100
                : 0) +
              N),
            (i.z = r + N),
            (i.scaleX = fe(a)),
            (i.scaleY = fe(o)),
            (i.rotation = fe(l) + R),
            (i.rotationX = fe(d) + R),
            (i.rotationY = fe(u) + R),
            (i.skewX = c + R),
            (i.skewY = p + R),
            (i.transformPerspective = h + N),
            (i.zOrigin = parseFloat(j.split(" ")[2]) || 0) && (I[Ki] = Pn(j)),
            (i.xOffset = i.yOffset = 0),
            (i.force3D = b.force3D),
            (i.renderTransform = i.svg ? Bn : Pi ? In : $n),
            (i.uncache = 0),
            i
          );
        },
        Pn = function (e) {
          return (e = e.split(" "))[0] + " " + e[1];
        },
        Ln = function (e, t, i) {
          var n = Ke(t);
          return fe(parseFloat(t) + parseFloat(vn(e, "x", i + "px", n))) + n;
        },
        $n = function (e, t) {
          (t.z = "0px"),
            (t.rotationY = t.rotationX = "0deg"),
            (t.force3D = 0),
            In(e, t);
        },
        An = "0deg",
        zn = "0px",
        Dn = ") ",
        In = function (e, t) {
          var i = t || this,
            n = i.xPercent,
            s = i.yPercent,
            r = i.x,
            a = i.y,
            o = i.z,
            l = i.rotation,
            d = i.rotationY,
            u = i.rotationX,
            c = i.skewX,
            p = i.skewY,
            h = i.scaleX,
            f = i.scaleY,
            m = i.transformPerspective,
            g = i.force3D,
            v = i.target,
            y = i.zOrigin,
            _ = "",
            b = ("auto" === g && e && 1 !== e) || !0 === g;
          if (y && (u !== An || d !== An)) {
            var w,
              T = parseFloat(d) * Ai,
              x = Math.sin(T),
              C = Math.cos(T);
            (T = parseFloat(u) * Ai),
              (w = Math.cos(T)),
              (r = Ln(v, r, x * w * -y)),
              (a = Ln(v, a, -Math.sin(T) * -y)),
              (o = Ln(v, o, C * w * -y + y));
          }
          m !== zn && (_ += "perspective(" + m + Dn),
            (n || s) && (_ += "translate(" + n + "%, " + s + "%) "),
            (b || r !== zn || a !== zn || o !== zn) &&
              (_ +=
                o !== zn || b
                  ? "translate3d(" + r + ", " + a + ", " + o + ") "
                  : "translate(" + r + ", " + a + Dn),
            l !== An && (_ += "rotate(" + l + Dn),
            d !== An && (_ += "rotateY(" + d + Dn),
            u !== An && (_ += "rotateX(" + u + Dn),
            (c === An && p === An) || (_ += "skew(" + c + ", " + p + Dn),
            (1 === h && 1 === f) || (_ += "scale(" + h + ", " + f + Dn),
            (v.style[Qi] = _ || "translate(0, 0)");
        },
        Bn = function (e, t) {
          var i,
            n,
            s,
            r,
            a,
            o = t || this,
            l = o.xPercent,
            d = o.yPercent,
            u = o.x,
            c = o.y,
            p = o.rotation,
            h = o.skewX,
            f = o.skewY,
            m = o.scaleX,
            g = o.scaleY,
            v = o.target,
            y = o.xOrigin,
            _ = o.yOrigin,
            b = o.xOffset,
            w = o.yOffset,
            T = o.forceCSS,
            x = parseFloat(u),
            C = parseFloat(c);
          (p = parseFloat(p)),
            (h = parseFloat(h)),
            (f = parseFloat(f)) && ((h += f = parseFloat(f)), (p += f)),
            p || h
              ? ((p *= Ai),
                (h *= Ai),
                (i = Math.cos(p) * m),
                (n = Math.sin(p) * m),
                (s = Math.sin(p - h) * -g),
                (r = Math.cos(p - h) * g),
                h &&
                  ((f *= Ai),
                  (a = Math.tan(h - f)),
                  (s *= a = Math.sqrt(1 + a * a)),
                  (r *= a),
                  f &&
                    ((a = Math.tan(f)),
                    (i *= a = Math.sqrt(1 + a * a)),
                    (n *= a))),
                (i = fe(i)),
                (n = fe(n)),
                (s = fe(s)),
                (r = fe(r)))
              : ((i = m), (r = g), (n = s = 0)),
            ((x && !~(u + "").indexOf("px")) ||
              (C && !~(c + "").indexOf("px"))) &&
              ((x = vn(v, "x", u, "px")), (C = vn(v, "y", c, "px"))),
            (y || _ || b || w) &&
              ((x = fe(x + y - (y * i + _ * s) + b)),
              (C = fe(C + _ - (y * n + _ * r) + w))),
            (l || d) &&
              ((a = v.getBBox()),
              (x = fe(x + (l / 100) * a.width)),
              (C = fe(C + (d / 100) * a.height))),
            (a =
              "matrix(" +
              i +
              "," +
              n +
              "," +
              s +
              "," +
              r +
              "," +
              x +
              "," +
              C +
              ")"),
            v.setAttribute("transform", a),
            T && (v.style[Qi] = a);
        },
        Nn = function (e, t, i, n, s) {
          var r,
            a,
            o = 360,
            l = P(s),
            d = parseFloat(s) * (l && ~s.indexOf("rad") ? $i : 1) - n,
            u = n + d + "deg";
          return (
            l &&
              ("short" === (r = s.split("_")[1]) &&
                (d %= o) != d % 180 &&
                (d += d < 0 ? o : -360),
              "cw" === r && d < 0
                ? (d = ((d + 36e9) % o) - ~~(d / o) * o)
                : "ccw" === r &&
                  d > 0 &&
                  (d = ((d - 36e9) % o) - ~~(d / o) * o)),
            (e._pt = a = new ui(e._pt, t, i, n, d, Fi)),
            (a.e = u),
            (a.u = "deg"),
            e._props.push(i),
            a
          );
        },
        Rn = function (e, t) {
          for (var i in t) e[i] = t[i];
          return e;
        },
        Fn = function (e, t, i) {
          var n,
            s,
            r,
            a,
            o,
            l,
            d,
            u = Rn({}, i._gsap),
            c = i.style;
          for (s in (u.svg
            ? ((r = i.getAttribute("transform")),
              i.setAttribute("transform", ""),
              (c[Qi] = t),
              (n = On(i, 1)),
              hn(i, Qi),
              i.setAttribute("transform", r))
            : ((r = getComputedStyle(i)[Qi]),
              (c[Qi] = t),
              (n = On(i, 1)),
              (c[Qi] = r)),
          Li))
            (r = u[s]) !== (a = n[s]) &&
              "perspective,force3D,transformOrigin,svgOrigin".indexOf(s) < 0 &&
              ((o = Ke(r) !== (d = Ke(a)) ? vn(i, s, r, d) : parseFloat(r)),
              (l = parseFloat(a)),
              (e._pt = new ui(e._pt, n, s, o, l - o, Ri)),
              (e._pt.u = d || 0),
              e._props.push(s));
          Rn(n, u);
        };
      he("padding,margin,Width,Radius", function (e, t) {
        var i = "Top",
          n = "Right",
          s = "Bottom",
          r = "Left",
          a = (t < 3 ? [i, n, s, r] : [i + r, i + n, s + n, s + r]).map(
            function (i) {
              return t < 2 ? e + i : "border" + i + e;
            }
          );
        Tn[t > 1 ? "border" + e : e] = function (e, t, i, n, s) {
          var r, o;
          if (arguments.length < 4)
            return (
              (r = a.map(function (t) {
                return yn(e, t, i);
              })),
              5 === (o = r.join(" ")).split(r[0]).length ? r[0] : o
            );
          (r = (n + "").split(" ")),
            (o = {}),
            a.forEach(function (e, t) {
              return (o[e] = r[t] = r[t] || r[((t - 1) / 2) | 0]);
            }),
            e.init(t, o, s);
        };
      });
      var jn,
        Gn,
        Hn = {
          name: "css",
          register: ln,
          targetTest: function (e) {
            return e.style && e.nodeType;
          },
          init: function (e, t, i, n, s) {
            var r,
              a,
              o,
              l,
              d,
              u,
              c,
              p,
              h,
              f,
              m,
              g,
              v,
              y,
              _,
              w,
              T,
              x,
              C,
              S,
              E = this._props,
              M = e.style,
              k = i.vars.startAt;
            for (c in (Ei || ln(),
            (this.styles = this.styles || nn(e)),
            (w = this.styles.props),
            (this.tween = i),
            t))
              if (
                "autoRound" !== c &&
                ((a = t[c]), !re[c] || !qt(c, t, i, n, e, s))
              )
                if (
                  ((d = typeof a),
                  (u = Tn[c]),
                  "function" === d && (d = typeof (a = a.call(i, n, e, s))),
                  "string" === d && ~a.indexOf("random(") && (a = dt(a)),
                  u)
                )
                  u(this, e, c, a, i) && (_ = 1);
                else if ("--" === c.substr(0, 2))
                  (r = (getComputedStyle(e).getPropertyValue(c) + "").trim()),
                    (a += ""),
                    (wt.lastIndex = 0),
                    wt.test(r) || ((p = Ke(r)), (h = Ke(a))),
                    h ? p !== h && (r = vn(e, c, r, h) + h) : p && (a += p),
                    this.add(M, "setProperty", r, a, n, s, 0, 0, c),
                    E.push(c),
                    w.push(c, M[c]);
                else if ("undefined" !== d) {
                  if (
                    (k && c in k
                      ? ((r =
                          "function" == typeof k[c]
                            ? k[c].call(i, n, e, s)
                            : k[c]),
                        P(r) && ~r.indexOf("random(") && (r = dt(r)),
                        Ke(r + "") || (r += b.units[c] || Ke(yn(e, c)) || ""),
                        "=" === (r + "").charAt(1) && (r = yn(e, c)))
                      : (r = yn(e, c)),
                    (l = parseFloat(r)),
                    (f =
                      "string" === d &&
                      "=" === a.charAt(1) &&
                      a.substr(0, 2)) && (a = a.substr(2)),
                    (o = parseFloat(a)),
                    c in Ni &&
                      ("autoAlpha" === c &&
                        (1 === l &&
                          "hidden" === yn(e, "visibility") &&
                          o &&
                          (l = 0),
                        w.push("visibility", M.visibility),
                        fn(
                          this,
                          M,
                          "visibility",
                          l ? "inherit" : "hidden",
                          o ? "inherit" : "hidden",
                          !o
                        )),
                      "scale" !== c &&
                        "transform" !== c &&
                        ~(c = Ni[c]).indexOf(",") &&
                        (c = c.split(",")[0])),
                    (m = c in Li))
                  )
                    if (
                      (this.styles.save(c),
                      g ||
                        (((v = e._gsap).renderTransform && !t.parseTransform) ||
                          On(e, t.parseTransform),
                        (y = !1 !== t.smoothOrigin && v.smooth),
                        ((g = this._pt =
                          new ui(
                            this._pt,
                            M,
                            Qi,
                            0,
                            1,
                            v.renderTransform,
                            v,
                            0,
                            -1
                          )).dep = 1)),
                      "scale" === c)
                    )
                      (this._pt = new ui(
                        this._pt,
                        v,
                        "scaleY",
                        v.scaleY,
                        (f ? ge(v.scaleY, f + o) : o) - v.scaleY || 0,
                        Ri
                      )),
                        (this._pt.u = 0),
                        E.push("scaleY", c),
                        (c += "X");
                    else {
                      if ("transformOrigin" === c) {
                        w.push(Ki, M[Ki]),
                          (x = void 0),
                          (C = void 0),
                          (S = void 0),
                          (C = (x = (T = a).split(" "))[0]),
                          (S = x[1] || "50%"),
                          ("top" !== C &&
                            "bottom" !== C &&
                            "left" !== S &&
                            "right" !== S) ||
                            ((T = C), (C = S), (S = T)),
                          (x[0] = bn[C] || C),
                          (x[1] = bn[S] || S),
                          (a = x.join(" ")),
                          v.svg
                            ? kn(e, a, 0, y, 0, this)
                            : ((h = parseFloat(a.split(" ")[2]) || 0) !==
                                v.zOrigin &&
                                fn(this, v, "zOrigin", v.zOrigin, h),
                              fn(this, M, c, Pn(r), Pn(a)));
                        continue;
                      }
                      if ("svgOrigin" === c) {
                        kn(e, a, 1, y, 0, this);
                        continue;
                      }
                      if (c in Cn) {
                        Nn(this, v, c, l, f ? ge(l, f + a) : a);
                        continue;
                      }
                      if ("smoothOrigin" === c) {
                        fn(this, v, "smooth", v.smooth, a);
                        continue;
                      }
                      if ("force3D" === c) {
                        v[c] = a;
                        continue;
                      }
                      if ("transform" === c) {
                        Fn(this, a, e);
                        continue;
                      }
                    }
                  else c in M || (c = on(c) || c);
                  if (
                    m ||
                    ((o || 0 === o) && (l || 0 === l) && !Bi.test(a) && c in M)
                  )
                    o || (o = 0),
                      (p = (r + "").substr((l + "").length)) !==
                        (h = Ke(a) || (c in b.units ? b.units[c] : p)) &&
                        (l = vn(e, c, r, h)),
                      (this._pt = new ui(
                        this._pt,
                        m ? v : M,
                        c,
                        l,
                        (f ? ge(l, f + o) : o) - l,
                        m ||
                        ("px" !== h && "zIndex" !== c) ||
                        !1 === t.autoRound
                          ? Ri
                          : Gi
                      )),
                      (this._pt.u = h || 0),
                      p !== h &&
                        "%" !== h &&
                        ((this._pt.b = r), (this._pt.r = ji));
                  else if (c in M) _n.call(this, e, c, r, f ? f + a : a);
                  else {
                    if (!(c in e)) {
                      Z(c, a);
                      continue;
                    }
                    this.add(e, c, r || e[c], f ? f + a : a, n, s);
                  }
                  m || w.push(c, M[c]), E.push(c);
                }
            _ && di(this);
          },
          render: function (e, t) {
            if (t.tween._time || !Oi())
              for (var i = t._pt; i; ) i.r(e, i.d), (i = i._next);
            else t.styles.revert();
          },
          get: yn,
          aliases: Ni,
          getSetter: function (e, t, i) {
            var n = Ni[t];
            return (
              n && n.indexOf(",") < 0 && (t = n),
              t in Li && t !== Ki && (e._gsap.x || yn(e, "x"))
                ? i && ki === i
                  ? "scale" === t
                    ? Xi
                    : Yi
                  : (ki = i || {}) && ("scale" === t ? Ui : Zi)
                : e.style && !A(e.style[t])
                ? Vi
                : ~t.indexOf("-")
                ? Wi
                : ti(e, t)
            );
          },
          core: { _removeProperty: hn, _getMatrix: Mn },
        };
      (Ti.utils.checkPrefix = on),
        (Ti.core.getStyleSaver = nn),
        (Gn = he(
          "x,y,z,scale,scaleX,scaleY,xPercent,yPercent" +
            "," +
            (jn = "rotation,rotationX,rotationY,skewX,skewY") +
            ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",
          function (e) {
            Li[e] = 1;
          }
        )),
        he(jn, function (e) {
          (b.units[e] = "deg"), (Cn[e] = 1);
        }),
        (Ni[Gn[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + jn),
        he(
          "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",
          function (e) {
            var t = e.split(":");
            Ni[t[1]] = Gn[t[0]];
          }
        ),
        he(
          "x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",
          function (e) {
            b.units[e] = "px";
          }
        ),
        Ti.registerPlugin(Hn);
      var qn = Ti.registerPlugin(Hn) || Ti;
      qn.core.Tween;
    },
    2817: function (e, t) {
      "use strict";
      var i, n, s;
      !(function (r, a) {
        if ("object" == typeof e.exports) {
          if (!r.document)
            throw new Error("HC-Sticky requires a browser to run.");
          e.exports = a(r);
        } else
          (n = []),
            (i = a(r)),
            void 0 === (s = "function" == typeof i ? i.apply(t, n) : i) ||
              (e.exports = s);
      })("undefined" != typeof window ? window : this, function (e) {
        var t,
          i,
          n = e.document,
          s = {
            top: 0,
            bottom: 0,
            bottomEnd: 0,
            innerTop: 0,
            innerSticker: null,
            stickyClass: "sticky",
            stickTo: null,
            followScroll: !0,
            responsive: null,
            mobileFirst: !1,
            onStart: null,
            onStop: null,
            onBeforeResize: null,
            onResize: null,
            resizeDebounce: 100,
            disable: !1,
          },
          r = function (e, t, i) {
            console.warn(
              "%cHC Sticky:%c " +
                i +
                "%c '" +
                e +
                "'%c is now deprecated and will be removed. Use%c '" +
                t +
                "'%c instead.",
              "color: #fa253b",
              "color: default",
              "color: #5595c6",
              "color: default",
              "color: #5595c6",
              "color: default"
            );
          },
          a = function (t, i) {
            var o = this;
            if (
              ((i = i || {}),
              !(t = "string" == typeof t ? n.querySelector(t) : t))
            )
              return !1;
            i.queries && r("queries", "responsive", "option"),
              i.queryFlow && r("queryFlow", "mobileFirst", "option");
            var l = {},
              d = a.Helpers,
              u = t.parentNode;
            function c(e) {
              (d.isEmptyObject((e = e || {})) && !d.isEmptyObject(l)) ||
                (l = Object.assign({}, s, l, e));
            }
            function p() {
              return l.disable;
            }
            function h() {
              var t,
                n = l.responsive || l.queries;
              if (n) {
                var r = e.innerWidth;
                if (((t = i), (l = Object.assign({}, s, t || {})).mobileFirst))
                  for (var a in n) a <= r && !d.isEmptyObject(n[a]) && c(n[a]);
                else {
                  var o,
                    u = [];
                  for (o in n) {
                    var p = {};
                    (p[o] = n[o]), u.push(p);
                  }
                  for (var h = u.length - 1; 0 <= h; h--) {
                    var f = u[h],
                      m = Object.keys(f)[0];
                    r <= m && !d.isEmptyObject(f[m]) && c(f[m]);
                  }
                }
              }
            }
            function f() {
              (z = B()), (x = I()), ($ = C + x - M - P), (A = E < z);
              var i,
                s = e.pageYOffset || n.documentElement.scrollTop,
                r = d.offset(t).top,
                a = r - s;
              (R = s < G ? "up" : "down"),
                (N = s - G),
                L < (G = s)
                  ? $ + M + (A ? k : 0) - (l.followScroll && A ? 0 : M) <=
                    s +
                      z -
                      O -
                      (E - (L - O) < z - O &&
                      l.followScroll &&
                      0 < (i = z - E - O)
                        ? i
                        : 0)
                    ? F.release({
                        position: "absolute",
                        bottom: S + u.offsetHeight - $ - M,
                      })
                    : A && l.followScroll
                    ? "down" == R
                      ? a + z + k <= E + 0.9
                        ? F.stick({ bottom: k })
                        : "fixed" === F.position &&
                          F.release({
                            position: "absolute",
                            top: r - M - L - N + O,
                          })
                      : Math.ceil(a + O) < 0 && "fixed" === F.position
                      ? F.release({
                          position: "absolute",
                          top: r - M - L + O - N,
                        })
                      : s + M - O <= r && F.stick({ top: M - O })
                    : F.stick({ top: M - O })
                  : F.release({ stop: !0 });
            }
            function m() {
              H &&
                (e.removeEventListener("scroll", f, d.supportsPassive),
                (H = !1));
            }
            function g() {
              null !== t.offsetParent && "none" !== d.getStyle(t, "display")
                ? ((function () {
                    var i, s, r, a;
                    (F.css =
                      ((i = t),
                      (s = d.getCascadedStyle(i)),
                      (r = d.getStyle(i)),
                      (a = {
                        height: i.offsetHeight + "px",
                        left: s.left,
                        right: s.right,
                        top: s.top,
                        bottom: s.bottom,
                        position: r.position,
                        display: r.display,
                        verticalAlign: r.verticalAlign,
                        boxSizing: r.boxSizing,
                        marginLeft: s.marginLeft,
                        marginRight: s.marginRight,
                        marginTop: s.marginTop,
                        marginBottom: s.marginBottom,
                        paddingLeft: s.paddingLeft,
                        paddingRight: s.paddingRight,
                      }),
                      s.float && (a.float = s.float || "none"),
                      s.cssFloat && (a.cssFloat = s.cssFloat || "none"),
                      r.MozBoxSizing && (a.MozBoxSizing = r.MozBoxSizing),
                      (a.width =
                        "auto" !== s.width
                          ? s.width
                          : "border-box" === a.boxSizing ||
                            "border-box" === a.MozBoxSizing
                          ? i.offsetWidth + "px"
                          : r.width),
                      a)),
                      j.init(),
                      (b = !(
                        !l.stickTo ||
                        !(
                          "document" === l.stickTo ||
                          (l.stickTo.nodeType && 9 === l.stickTo.nodeType) ||
                          ("object" == typeof l.stickTo &&
                            l.stickTo instanceof
                              ("undefined" != typeof HTMLDocument
                                ? HTMLDocument
                                : Document))
                        )
                      )),
                      (w = l.stickTo ? (b ? n : d.getElement(l.stickTo)) : u),
                      (z = (B = function () {
                        var e =
                            t.offsetHeight +
                            (parseInt(F.css.marginTop) || 0) +
                            (parseInt(F.css.marginBottom) || 0),
                          i = (z || 0) - e;
                        return -1 <= i && i <= 1 ? z : e;
                      })()),
                      (x = (I = function () {
                        return b
                          ? Math.max(
                              n.documentElement.clientHeight,
                              n.body.scrollHeight,
                              n.documentElement.scrollHeight,
                              n.body.offsetHeight,
                              n.documentElement.offsetHeight
                            )
                          : w.offsetHeight;
                      })()),
                      (C = b ? 0 : d.offset(w).top),
                      (S = l.stickTo ? (b ? 0 : d.offset(u).top) : C),
                      (E = e.innerHeight),
                      (D = t.offsetTop - (parseInt(F.css.marginTop) || 0)),
                      (T = d.getElement(l.innerSticker)),
                      (M =
                        isNaN(l.top) && -1 < l.top.indexOf("%")
                          ? (parseFloat(l.top) / 100) * E
                          : l.top),
                      (k =
                        isNaN(l.bottom) && -1 < l.bottom.indexOf("%")
                          ? (parseFloat(l.bottom) / 100) * E
                          : l.bottom),
                      (O = T ? T.offsetTop : l.innerTop || 0),
                      (P =
                        isNaN(l.bottomEnd) && -1 < l.bottomEnd.indexOf("%")
                          ? (parseFloat(l.bottomEnd) / 100) * E
                          : l.bottomEnd),
                      (L = C - M + O + D);
                  })(),
                  x < z
                    ? m()
                    : (f(),
                      H ||
                        (e.addEventListener("scroll", f, d.supportsPassive),
                        (H = !0))))
                : m();
            }
            function v() {
              (t.style.position = ""),
                (t.style.left = ""),
                (t.style.top = ""),
                (t.style.bottom = ""),
                (t.style.width = ""),
                t.classList
                  ? t.classList.remove(l.stickyClass)
                  : (t.className = t.className.replace(
                      new RegExp(
                        "(^|\\b)" +
                          l.stickyClass.split(" ").join("|") +
                          "(\\b|$)",
                        "gi"
                      ),
                      " "
                    )),
                (F.css = {}),
                !(F.position = null) === j.isAttached && j.detach();
            }
            function y() {
              v(), h(), (p() ? m : g)();
            }
            function _() {
              q &&
                (e.removeEventListener("resize", W, d.supportsPassive),
                (q = !1)),
                m();
            }
            "static" === d.getStyle(u, "position") &&
              (u.style.position = "relative");
            var b,
              w,
              T,
              x,
              C,
              S,
              E,
              M,
              k,
              O,
              P,
              L,
              $,
              A,
              z,
              D,
              I,
              B,
              N,
              R,
              /*
              F = {
                css: {},
                position: null,
                stick: function (e) {
                  (e = e || {}),
                    d.hasClass(t, l.stickyClass) ||
                      (!1 === j.isAttached && j.attach(),
                      (F.position = "fixed"),
                      (t.style.position = "fixed"),
                      (t.style.left = j.offsetLeft + "px"),
                      (t.style.width = j.width),
                      void 0 === e.bottom
                        ? (t.style.bottom = "auto")
                        : (t.style.bottom = e.bottom + "px"),
                      void 0 === e.top
                        ? (t.style.top = "auto")
                        : (t.style.top = e.top + "px"),
                      t.classList
                        ? t.classList.add(l.stickyClass)
                        : (t.className += " " + l.stickyClass),
                      l.onStart && l.onStart.call(t, Object.assign({}, l)));
                },
                release: function (e) {
                  var i;
                  ((e = e || {}).stop = e.stop || !1),
                    (!0 !== e.stop &&
                      "fixed" !== F.position &&
                      null !== F.position &&
                      ((void 0 === e.top && void 0 === e.bottom) ||
                        (void 0 !== e.top &&
                          (parseInt(d.getStyle(t, "top")) || 0) === e.top) ||
                        (void 0 !== e.bottom &&
                          (parseInt(d.getStyle(t, "bottom")) || 0) ===
                            e.bottom))) ||
                      (!0 === e.stop
                        ? !0 === j.isAttached && j.detach()
                        : !1 === j.isAttached && j.attach(),
                      (i = e.position || F.css.position),
                      (F.position = i),
                      (t.style.position = i),
                      (t.style.left =
                        !0 === e.stop ? F.css.left : j.positionLeft + "px"),
                      (t.style.width = ("absolute" !== i ? F.css : j).width),
                      void 0 === e.bottom
                        ? (t.style.bottom = !0 === e.stop ? "" : "auto")
                        : (t.style.bottom = e.bottom + "px"),
                      void 0 === e.top
                        ? (t.style.top = !0 === e.stop ? "" : "auto")
                        : (t.style.top = e.top + "px"),
                      t.classList
                        ? t.classList.remove(l.stickyClass)
                        : (t.className = t.className.replace(
                            new RegExp(
                              "(^|\\b)" +
                                l.stickyClass.split(" ").join("|") +
                                "(\\b|$)",
                              "gi"
                            ),
                            " "
                          )),
                      l.onStop && l.onStop.call(t, Object.assign({}, l)));
                },
              },
                */
              j = {
                el: n.createElement("div"),
                offsetLeft: null,
                positionLeft: null,
                width: null,
                isAttached: !1,
                init: function () {
                  for (var e in ((j.el.className = "sticky-spacer"), F.css))
                    j.el.style[e] = F.css[e];
                  j.el.style["z-index"] = "-1";
                  var i = d.getStyle(t);
                  (j.offsetLeft =
                    d.offset(t).left - (parseInt(i.marginLeft) || 0)),
                    (j.positionLeft = d.position(t).left),
                    (j.width = d.getStyle(t, "width"));
                },
                attach: function () {
                  u.insertBefore(j.el, t), (j.isAttached = !0);
                },
                detach: function () {
                  (j.el = u.removeChild(j.el)), (j.isAttached = !1);
                },
              },
              G = e.pageYOffset || n.documentElement.scrollTop,
              H = !1,
              q = !1,
              V = function () {
                l.onBeforeResize &&
                  l.onBeforeResize.call(t, Object.assign({}, l)),
                  y(),
                  l.onResize && l.onResize.call(t, Object.assign({}, l));
              },
              W = l.resizeDebounce ? d.debounce(V, l.resizeDebounce) : V;
            (V = function () {
              q ||
                (e.addEventListener("resize", W, d.supportsPassive), (q = !0)),
                h(),
                (p() ? m : g)();
            }),
              (this.options = function (e) {
                return e ? l[e] : Object.assign({}, l);
              }),
              (this.refresh = y),
              (this.update = function (e) {
                c(e), (i = Object.assign({}, i, e || {})), y();
              }),
              (this.attach = V),
              (this.detach = _),
              (this.destroy = function () {
                _(), v();
              }),
              (this.triggerMethod = function (e, t) {
                "function" == typeof o[e] && o[e](t);
              }),
              (this.reinit = function () {
                r("reinit", "refresh", "method"), y();
              }),
              c(i),
              V(),
              e.addEventListener("load", y);
          };
        return (
          void 0 !== e.jQuery &&
            ((t = e.jQuery),
            (i = "hcSticky"),
            t.fn.extend({
              hcSticky: function (e, n) {
                return this.length
                  ? "options" === e
                    ? t.data(this.get(0), i).options()
                    : this.each(function () {
                        var s = t.data(this, i);
                        s
                          ? s.triggerMethod(e, n)
                          : ((s = new a(this, e)), t.data(this, i, s));
                      })
                  : this;
              },
            })),
          (e.hcSticky = e.hcSticky || a),
          a
        );
      }),
        (function (e) {
          var t = e.hcSticky,
            i = e.document;
          "function" != typeof Object.assign &&
            Object.defineProperty(Object, "assign", {
              value: function (e, t) {
                if (null == e)
                  throw new TypeError(
                    "Cannot convert undefined or null to object"
                  );
                for (var i = Object(e), n = 1; n < arguments.length; n++) {
                  var s = arguments[n];
                  if (null != s)
                    for (var r in s)
                      Object.prototype.hasOwnProperty.call(s, r) &&
                        (i[r] = s[r]);
                }
                return i;
              },
              writable: !0,
              configurable: !0,
            }),
            Array.prototype.forEach ||
              (Array.prototype.forEach = function (e) {
                var t, i;
                if (null == this)
                  throw new TypeError("this is null or not defined");
                var n,
                  s = Object(this),
                  r = s.length >>> 0;
                if ("function" != typeof e)
                  throw new TypeError(e + " is not a function");
                for (1 < arguments.length && (t = arguments[1]), i = 0; i < r; )
                  i in s && ((n = s[i]), e.call(t, n, i, s)), i++;
              });
          var n = !1;
          try {
            var s = Object.defineProperty({}, "passive", {
              get: function () {
                n = { passive: !1 };
              },
            });
            e.addEventListener("testPassive", null, s),
              e.removeEventListener("testPassive", null, s);
          } catch (t) {}
          function r(t, n) {
            return e.getComputedStyle
              ? n
                ? i.defaultView.getComputedStyle(t, null).getPropertyValue(n)
                : i.defaultView.getComputedStyle(t, null)
              : t.currentStyle
              ? n
                ? t.currentStyle[
                    n.replace(/-\w/g, function (e) {
                      return e.toUpperCase().replace("-", "");
                    })
                  ]
                : t.currentStyle
              : void 0;
          }
          function a(t) {
            var n = t.getBoundingClientRect(),
              s = e.pageYOffset || i.documentElement.scrollTop;
            return (
              (t = e.pageXOffset || i.documentElement.scrollLeft),
              { top: n.top + s, left: n.left + t }
            );
          }
          t.Helpers = {
            supportsPassive: n,
            isEmptyObject: function (e) {
              for (var t in e) return !1;
              return !0;
            },
            debounce: function (e, t, i) {
              var n;
              return function () {
                var s = this,
                  r = arguments,
                  a = i && !n;
                clearTimeout(n),
                  (n = setTimeout(function () {
                    (n = null), i || e.apply(s, r);
                  }, t)),
                  a && e.apply(s, r);
              };
            },
            hasClass: function (e, t) {
              return e.classList
                ? e.classList.contains(t)
                : new RegExp("(^| )" + t + "( |$)", "gi").test(e.className);
            },
            offset: a,
            position: function (e) {
              var t = a((n = e.offsetParent)),
                i = a(e),
                n = r(n);
              return (
                (e = r(e)),
                (t.top += parseInt(n.borderTopWidth) || 0),
                (t.left += parseInt(n.borderLeftWidth) || 0),
                {
                  top: i.top - t.top - (parseInt(e.marginTop) || 0),
                  left: i.left - t.left - (parseInt(e.marginLeft) || 0),
                }
              );
            },
            getElement: function (t) {
              var n = null;
              return (
                "string" == typeof t
                  ? (n = i.querySelector(t))
                  : e.jQuery && t instanceof e.jQuery && t.length
                  ? (n = t[0])
                  : t instanceof Element && (n = t),
                n
              );
            },
            getStyle: r,
            getCascadedStyle: function (t) {
              var n,
                s = t.cloneNode(!0);
              (s.style.display = "none"),
                Array.prototype.slice
                  .call(s.querySelectorAll('input[type="radio"]'))
                  .forEach(function (e) {
                    e.removeAttribute("name");
                  }),
                t.parentNode.insertBefore(s, t.nextSibling),
                s.currentStyle
                  ? (n = s.currentStyle)
                  : e.getComputedStyle &&
                    (n = i.defaultView.getComputedStyle(s, null));
              var r,
                a,
                o,
                l = {};
              for (r in n)
                !isNaN(r) ||
                  ("string" != typeof n[r] && "number" != typeof n[r]) ||
                  (l[r] = n[r]);
              if (Object.keys(l).length < 3)
                for (var d in ((l = {}), n))
                  isNaN(d) ||
                    (l[
                      n[d].replace(/-\w/g, function (e) {
                        return e.toUpperCase().replace("-", "");
                      })
                    ] = n.getPropertyValue(n[d]));
              return (
                l.margin || "auto" !== l.marginLeft
                  ? l.margin ||
                    l.marginLeft !== l.marginRight ||
                    l.marginLeft !== l.marginTop ||
                    l.marginLeft !== l.marginBottom ||
                    (l.margin = l.marginLeft)
                  : (l.margin = "auto"),
                l.margin ||
                  "0px" !== l.marginLeft ||
                  "0px" !== l.marginRight ||
                  ((o =
                    (a = t.offsetLeft - t.parentNode.offsetLeft) -
                    (parseInt(l.left) || 0) -
                    (parseInt(l.right) || 0)),
                  (0 !=
                    (o =
                      t.parentNode.offsetWidth -
                      t.offsetWidth -
                      a -
                      (parseInt(l.right) || 0) +
                      (parseInt(l.left) || 0) -
                      o) &&
                    1 != o) ||
                    (l.margin = "auto")),
                s.parentNode.removeChild(s),
                (s = null),
                l
              );
            },
          };
        })(window);
    },
    970: function (e) {
      var t,
        i = "loading" in HTMLImageElement.prototype,
        n = "loading" in HTMLIFrameElement.prototype,
        s = "onscroll" in window;
      function r(e) {
        var t,
          i,
          n = [];
        "picture" === e.parentNode.tagName.toLowerCase() &&
          ((i = (t = e.parentNode).querySelector("source[data-lazy-remove]")) &&
            t.removeChild(i),
          (n = Array.prototype.slice.call(
            e.parentNode.querySelectorAll("source")
          ))),
          n.push(e),
          n.forEach(function (e) {
            e.hasAttribute("data-lazy-srcset") &&
              (e.setAttribute("srcset", e.getAttribute("data-lazy-srcset")),
              e.removeAttribute("data-lazy-srcset"));
          }),
          e.setAttribute("src", e.getAttribute("data-lazy-src")),
          e.removeAttribute("data-lazy-src");
      }
      function a(e) {
        var r = document.createElement("div");
        for (
          r.innerHTML = (function (e) {
            var r = e.textContent || e.innerHTML,
              a =
                "data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 " +
                ((r.match(/width=['"](\d+)['"]/) || !1)[1] || 1) +
                " " +
                ((r.match(/height=['"](\d+)['"]/) || !1)[1] || 1) +
                "%27%3E%3C/svg%3E";
            return (
              ((/<img/gim.test(r) && !i) || (/<iframe/gim.test(r) && !n)) &&
                s &&
                (r =
                  void 0 === t
                    ? r.replace(
                        /(?:\r\n|\r|\n|\t| )src=/g,
                        ' lazyload="1" src='
                      )
                    : (r = r.replace(
                        "<source",
                        '<source srcset="' +
                          a +
                          '" data-lazy-remove="true"></source>\n<source'
                      ))
                        .replace(
                          /(?:\r\n|\r|\n|\t| )srcset=/g,
                          " data-lazy-srcset="
                        )
                        .replace(
                          /(?:\r\n|\r|\n|\t| )src=/g,
                          ' src="' + a + '" data-lazy-src='
                        )),
              r
            );
          })(e);
          r.firstChild;

        ) {
          var a = r.firstChild;
          if (
            s &&
            void 0 !== t &&
            a.tagName &&
            ((("img" === a.tagName.toLowerCase() ||
              "picture" === a.tagName.toLowerCase()) &&
              !i) ||
              ("iframe" === a.tagName.toLowerCase() && !n))
          ) {
            var o =
              "picture" === a.tagName.toLowerCase()
                ? r.querySelector("img")
                : a;
            t.observe(o);
          }
          e.parentNode.insertBefore(a, e);
        }
        e.parentNode.removeChild(e);
      }
      window.NodeList &&
        !NodeList.prototype.forEach &&
        (NodeList.prototype.forEach = Array.prototype.forEach),
        "IntersectionObserver" in window &&
          (t = new IntersectionObserver(
            function (e, t) {
              e.forEach(function (e) {
                if (0 !== e.intersectionRatio) {
                  var i = e.target;
                  t.unobserve(i), r(i);
                }
              });
            },
            { rootMargin: "0px 0px 256px 0px", threshold: 0.01 }
          ));
      var o = function () {
        document
          .querySelectorAll("noscript.loading-lazy")
          .forEach(function (e) {
            return a(e);
          }),
          void 0 !== window.matchMedia &&
            window.matchMedia("print").addListener(function (e) {
              e.matches &&
                document
                  .querySelectorAll(
                    'img[loading="lazy"][data-lazy-src],iframe[loading="lazy"][data-lazy-src]'
                  )
                  .forEach(function (e) {
                    r(e);
                  });
            });
      };
      /comp|inter/.test(document.readyState)
        ? o()
        : "addEventListener" in document
        ? document.addEventListener("DOMContentLoaded", function () {
            o();
          })
        : document.attachEvent("onreadystatechange", function () {
            "complete" === document.readyState && o();
          }),
        (e.exports = { prepareElement: a });
    },
    3901: function (e, t, i) {
      "use strict";
      function n(e) {
        let { swiper: t, runCallbacks: i, direction: n, step: s } = e;
        const { activeIndex: r, previousIndex: a } = t;
        let o = n;
        if (
          (o || (o = r > a ? "next" : r < a ? "prev" : "reset"),
          t.emit(`transition${s}`),
          i && r !== a)
        ) {
          if ("reset" === o) return void t.emit(`slideResetTransition${s}`);
          t.emit(`slideChangeTransition${s}`),
            "next" === o
              ? t.emit(`slideNextTransition${s}`)
              : t.emit(`slidePrevTransition${s}`);
        }
      }
      i.d(t, {
        Z: function () {
          return n;
        },
      });
    },
    1083: function (e, t, i) {
      "use strict";
      if (
        (i.d(t, {
          Z: function () {
            return a;
          },
        }),
        47 == i.j)
      )
        var n = i(5653);
      if (47 == i.j) var s = i(5302);
      if (47 == i.j) var r = i(1166);
      function a(e) {
        let { swiper: t, extendParams: i, on: a } = e;
        i({ fadeEffect: { crossFade: !1, transformEl: null } }),
          (0, n.Z)({
            effect: "fade",
            swiper: t,
            on: a,
            setTranslate: () => {
              const { slides: e } = t,
                i = t.params.fadeEffect;
              for (let n = 0; n < e.length; n += 1) {
                const e = t.slides.eq(n);
                let r = -e[0].swiperSlideOffset;
                t.params.virtualTranslate || (r -= t.translate);
                let a = 0;
                t.isHorizontal() || ((a = r), (r = 0));
                const o = t.params.fadeEffect.crossFade
                  ? Math.max(1 - Math.abs(e[0].progress), 0)
                  : 1 + Math.min(Math.max(e[0].progress, -1), 0);
                (0, s.Z)(i, e)
                  .css({ opacity: o })
                  .transform(`translate3d(${r}px, ${a}px, 0px)`);
              }
            },
            setTransition: (e) => {
              const { transformEl: i } = t.params.fadeEffect;
              (i ? t.slides.find(i) : t.slides).transition(e),
                (0, r.Z)({
                  swiper: t,
                  duration: e,
                  transformEl: i,
                  allSlides: !0,
                });
            },
            overwriteParams: () => ({
              slidesPerView: 1,
              slidesPerGroup: 1,
              watchSlidesProgress: !0,
              spaceBetween: 0,
              virtualTranslate: !t.params.cssMode,
            }),
          });
      }
    },
    3370: function (e, t, i) {
      "use strict";
      function n(e) {
        return (
          void 0 === e && (e = ""),
          `.${e
            .trim()
            .replace(/([\.:!\/])/g, "\\$1")
            .replace(/ /g, ".")}`
        );
      }
      i.d(t, {
        Z: function () {
          return n;
        },
      });
    },
    5653: function (e, t, i) {
      "use strict";
      function n(e) {
        const {
          effect: t,
          swiper: i,
          on: n,
          setTranslate: s,
          setTransition: r,
          overwriteParams: a,
          perspective: o,
          recreateShadows: l,
          getEffectParams: d,
        } = e;
        let u;
        n("beforeInit", () => {
          if (i.params.effect !== t) return;
          i.classNames.push(`${i.params.containerModifierClass}${t}`),
            o &&
              o() &&
              i.classNames.push(`${i.params.containerModifierClass}3d`);
          const e = a ? a() : {};
          Object.assign(i.params, e), Object.assign(i.originalParams, e);
        }),
          n("setTranslate", () => {
            i.params.effect === t && s();
          }),
          n("setTransition", (e, n) => {
            i.params.effect === t && r(n);
          }),
          n("transitionEnd", () => {
            if (i.params.effect === t && l) {
              if (!d || !d().slideShadows) return;
              i.slides.each((e) => {
                i.$(e)
                  .find(
                    ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                  )
                  .remove();
              }),
                l();
            }
          }),
          n("virtualUpdate", () => {
            i.params.effect === t &&
              (i.slides.length || (u = !0),
              requestAnimationFrame(() => {
                u && i.slides && i.slides.length && (s(), (u = !1));
              }));
          });
      }
      i.d(t, {
        Z: function () {
          return n;
        },
      });
    },
    5302: function (e, t, i) {
      "use strict";
      function n(e, t) {
        return e.transformEl
          ? t
              .find(e.transformEl)
              .css({
                "backface-visibility": "hidden",
                "-webkit-backface-visibility": "hidden",
              })
          : t;
      }
      i.d(t, {
        Z: function () {
          return n;
        },
      });
    },
    1166: function (e, t, i) {
      "use strict";
      function n(e) {
        let { swiper: t, duration: i, transformEl: n, allSlides: s } = e;
        const { slides: r, activeIndex: a, $wrapperEl: o } = t;
        if (t.params.virtualTranslate && 0 !== i) {
          let e,
            i = !1;
          (e = s ? (n ? r.find(n) : r) : n ? r.eq(a).find(n) : r.eq(a)),
            e.transitionEnd(() => {
              if (i) return;
              if (!t || t.destroyed) return;
              (i = !0), (t.animating = !1);
              const e = ["webkitTransitionEnd", "transitionend"];
              for (let t = 0; t < e.length; t += 1) o.trigger(e[t]);
            });
        }
      }
      i.d(t, {
        Z: function () {
          return n;
        },
      });
    },
    7099: function (e, t, i) {
      "use strict";
      function n(e) {
        return (
          null !== e &&
          "object" == typeof e &&
          "constructor" in e &&
          e.constructor === Object
        );
      }
      function s(e = {}, t = {}) {
        Object.keys(t).forEach((i) => {
          void 0 === e[i]
            ? (e[i] = t[i])
            : n(t[i]) &&
              n(e[i]) &&
              Object.keys(t[i]).length > 0 &&
              s(e[i], t[i]);
        });
      }
      i.d(t, {
        s5: function () {
          return te;
        },
        pt: function () {
          return ie;
        },
        xW: function () {
          return ne.Z;
        },
        W_: function () {
          return K;
        },
        tl: function () {
          return ee;
        },
        ZP: function () {
          return Z;
        },
      });
      const r = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: "" },
        querySelector() {
          return null;
        },
        querySelectorAll() {
          return [];
        },
        getElementById() {
          return null;
        },
        createEvent() {
          return { initEvent() {} };
        },
        createElement() {
          return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() {},
            getElementsByTagName() {
              return [];
            },
          };
        },
        createElementNS() {
          return {};
        },
        importNode() {
          return null;
        },
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
      };
      function a() {
        const e = "undefined" != typeof document ? document : {};
        return s(e, r), e;
      }
      const o = {
        document: r,
        navigator: { userAgent: "" },
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
        history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle() {
          return {
            getPropertyValue() {
              return "";
            },
          };
        },
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia() {
          return {};
        },
        requestAnimationFrame(e) {
          return "undefined" == typeof setTimeout
            ? (e(), null)
            : setTimeout(e, 0);
        },
        cancelAnimationFrame(e) {
          "undefined" != typeof setTimeout && clearTimeout(e);
        },
      };
      function l() {
        const e = "undefined" != typeof window ? window : {};
        return s(e, o), e;
      }
      class d extends Array {
        constructor(e) {
          "number" == typeof e
            ? super(e)
            : (super(...(e || [])),
              (function (e) {
                const t = e.__proto__;
                Object.defineProperty(e, "__proto__", {
                  get() {
                    return t;
                  },
                  set(e) {
                    t.__proto__ = e;
                  },
                });
              })(this));
        }
      }
      function u(e = []) {
        const t = [];
        return (
          e.forEach((e) => {
            Array.isArray(e) ? t.push(...u(e)) : t.push(e);
          }),
          t
        );
      }
      function c(e, t) {
        return Array.prototype.filter.call(e, t);
      }
      function p(e, t) {
        const i = l(),
          n = a();
        let s = [];
        if (!t && e instanceof d) return e;
        if (!e) return new d(s);
        if ("string" == typeof e) {
          const i = e.trim();
          if (i.indexOf("<") >= 0 && i.indexOf(">") >= 0) {
            let e = "div";
            0 === i.indexOf("<li") && (e = "ul"),
              0 === i.indexOf("<tr") && (e = "tbody"),
              (0 !== i.indexOf("<td") && 0 !== i.indexOf("<th")) || (e = "tr"),
              0 === i.indexOf("<tbody") && (e = "table"),
              0 === i.indexOf("<option") && (e = "select");
            const t = n.createElement(e);
            t.innerHTML = i;
            for (let e = 0; e < t.childNodes.length; e += 1)
              s.push(t.childNodes[e]);
          } else
            s = (function (e, t) {
              if ("string" != typeof e) return [e];
              const i = [],
                n = t.querySelectorAll(e);
              for (let e = 0; e < n.length; e += 1) i.push(n[e]);
              return i;
            })(e.trim(), t || n);
        } else if (e.nodeType || e === i || e === n) s.push(e);
        else if (Array.isArray(e)) {
          if (e instanceof d) return e;
          s = e;
        }
        return new d(
          (function (e) {
            const t = [];
            for (let i = 0; i < e.length; i += 1)
              -1 === t.indexOf(e[i]) && t.push(e[i]);
            return t;
          })(s)
        );
      }
      p.fn = d.prototype;
      const h = "resize scroll".split(" ");
      function f(e) {
        return function (...t) {
          if (void 0 === t[0]) {
            for (let t = 0; t < this.length; t += 1)
              h.indexOf(e) < 0 &&
                (e in this[t] ? this[t][e]() : p(this[t]).trigger(e));
            return this;
          }
          return this.on(e, ...t);
        };
      }
      f("click"),
        f("blur"),
        f("focus"),
        f("focusin"),
        f("focusout"),
        f("keyup"),
        f("keydown"),
        f("keypress"),
        f("submit"),
        f("change"),
        f("mousedown"),
        f("mousemove"),
        f("mouseup"),
        f("mouseenter"),
        f("mouseleave"),
        f("mouseout"),
        f("mouseover"),
        f("touchstart"),
        f("touchend"),
        f("touchmove"),
        f("resize"),
        f("scroll");
      const m = {
        addClass: function (...e) {
          const t = u(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.add(...t);
            }),
            this
          );
        },
        removeClass: function (...e) {
          const t = u(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.remove(...t);
            }),
            this
          );
        },
        hasClass: function (...e) {
          const t = u(e.map((e) => e.split(" ")));
          return (
            c(this, (e) => t.filter((t) => e.classList.contains(t)).length > 0)
              .length > 0
          );
        },
        toggleClass: function (...e) {
          const t = u(e.map((e) => e.split(" ")));
          this.forEach((e) => {
            t.forEach((t) => {
              e.classList.toggle(t);
            });
          });
        },
        attr: function (e, t) {
          if (1 === arguments.length && "string" == typeof e)
            return this[0] ? this[0].getAttribute(e) : void 0;
          for (let i = 0; i < this.length; i += 1)
            if (2 === arguments.length) this[i].setAttribute(e, t);
            else
              for (const t in e)
                (this[i][t] = e[t]), this[i].setAttribute(t, e[t]);
          return this;
        },
        removeAttr: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
          return this;
        },
        transform: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].style.transform = e;
          return this;
        },
        transition: function (e) {
          for (let t = 0; t < this.length; t += 1)
            this[t].style.transitionDuration =
              "string" != typeof e ? `${e}ms` : e;
          return this;
        },
        on: function (...e) {
          let [t, i, n, s] = e;
          function r(e) {
            const t = e.target;
            if (!t) return;
            const s = e.target.dom7EventData || [];
            if ((s.indexOf(e) < 0 && s.unshift(e), p(t).is(i))) n.apply(t, s);
            else {
              const e = p(t).parents();
              for (let t = 0; t < e.length; t += 1)
                p(e[t]).is(i) && n.apply(e[t], s);
            }
          }
          function a(e) {
            const t = (e && e.target && e.target.dom7EventData) || [];
            t.indexOf(e) < 0 && t.unshift(e), n.apply(this, t);
          }
          "function" == typeof e[1] && (([t, n, s] = e), (i = void 0)),
            s || (s = !1);
          const o = t.split(" ");
          let l;
          for (let e = 0; e < this.length; e += 1) {
            const t = this[e];
            if (i)
              for (l = 0; l < o.length; l += 1) {
                const e = o[l];
                t.dom7LiveListeners || (t.dom7LiveListeners = {}),
                  t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
                  t.dom7LiveListeners[e].push({
                    listener: n,
                    proxyListener: r,
                  }),
                  t.addEventListener(e, r, s);
              }
            else
              for (l = 0; l < o.length; l += 1) {
                const e = o[l];
                t.dom7Listeners || (t.dom7Listeners = {}),
                  t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
                  t.dom7Listeners[e].push({ listener: n, proxyListener: a }),
                  t.addEventListener(e, a, s);
              }
          }
          return this;
        },
        off: function (...e) {
          let [t, i, n, s] = e;
          "function" == typeof e[1] && (([t, n, s] = e), (i = void 0)),
            s || (s = !1);
          const r = t.split(" ");
          for (let e = 0; e < r.length; e += 1) {
            const t = r[e];
            for (let e = 0; e < this.length; e += 1) {
              const r = this[e];
              let a;
              if (
                (!i && r.dom7Listeners
                  ? (a = r.dom7Listeners[t])
                  : i && r.dom7LiveListeners && (a = r.dom7LiveListeners[t]),
                a && a.length)
              )
                for (let e = a.length - 1; e >= 0; e -= 1) {
                  const i = a[e];
                  (n && i.listener === n) ||
                  (n &&
                    i.listener &&
                    i.listener.dom7proxy &&
                    i.listener.dom7proxy === n)
                    ? (r.removeEventListener(t, i.proxyListener, s),
                      a.splice(e, 1))
                    : n ||
                      (r.removeEventListener(t, i.proxyListener, s),
                      a.splice(e, 1));
                }
            }
          }
          return this;
        },
        trigger: function (...e) {
          const t = l(),
            i = e[0].split(" "),
            n = e[1];
          for (let s = 0; s < i.length; s += 1) {
            const r = i[s];
            for (let i = 0; i < this.length; i += 1) {
              const s = this[i];
              if (t.CustomEvent) {
                const i = new t.CustomEvent(r, {
                  detail: n,
                  bubbles: !0,
                  cancelable: !0,
                });
                (s.dom7EventData = e.filter((e, t) => t > 0)),
                  s.dispatchEvent(i),
                  (s.dom7EventData = []),
                  delete s.dom7EventData;
              }
            }
          }
          return this;
        },
        transitionEnd: function (e) {
          const t = this;
          return (
            e &&
              t.on("transitionend", function i(n) {
                n.target === this &&
                  (e.call(this, n), t.off("transitionend", i));
              }),
            this
          );
        },
        outerWidth: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetWidth +
                parseFloat(e.getPropertyValue("margin-right")) +
                parseFloat(e.getPropertyValue("margin-left"))
              );
            }
            return this[0].offsetWidth;
          }
          return null;
        },
        outerHeight: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetHeight +
                parseFloat(e.getPropertyValue("margin-top")) +
                parseFloat(e.getPropertyValue("margin-bottom"))
              );
            }
            return this[0].offsetHeight;
          }
          return null;
        },
        styles: function () {
          const e = l();
          return this[0] ? e.getComputedStyle(this[0], null) : {};
        },
        offset: function () {
          if (this.length > 0) {
            const e = l(),
              t = a(),
              i = this[0],
              n = i.getBoundingClientRect(),
              s = t.body,
              r = i.clientTop || s.clientTop || 0,
              o = i.clientLeft || s.clientLeft || 0,
              d = i === e ? e.scrollY : i.scrollTop,
              u = i === e ? e.scrollX : i.scrollLeft;
            return { top: n.top + d - r, left: n.left + u - o };
          }
          return null;
        },
        css: function (e, t) {
          const i = l();
          let n;
          if (1 === arguments.length) {
            if ("string" != typeof e) {
              for (n = 0; n < this.length; n += 1)
                for (const t in e) this[n].style[t] = e[t];
              return this;
            }
            if (this[0])
              return i.getComputedStyle(this[0], null).getPropertyValue(e);
          }
          if (2 === arguments.length && "string" == typeof e) {
            for (n = 0; n < this.length; n += 1) this[n].style[e] = t;
            return this;
          }
          return this;
        },
        each: function (e) {
          return e
            ? (this.forEach((t, i) => {
                e.apply(t, [t, i]);
              }),
              this)
            : this;
        },
        html: function (e) {
          if (void 0 === e) return this[0] ? this[0].innerHTML : null;
          for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
          return this;
        },
        text: function (e) {
          if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
          for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
          return this;
        },
        is: function (e) {
          const t = l(),
            i = a(),
            n = this[0];
          let s, r;
          if (!n || void 0 === e) return !1;
          if ("string" == typeof e) {
            if (n.matches) return n.matches(e);
            if (n.webkitMatchesSelector) return n.webkitMatchesSelector(e);
            if (n.msMatchesSelector) return n.msMatchesSelector(e);
            for (s = p(e), r = 0; r < s.length; r += 1)
              if (s[r] === n) return !0;
            return !1;
          }
          if (e === i) return n === i;
          if (e === t) return n === t;
          if (e.nodeType || e instanceof d) {
            for (s = e.nodeType ? [e] : e, r = 0; r < s.length; r += 1)
              if (s[r] === n) return !0;
            return !1;
          }
          return !1;
        },
        index: function () {
          let e,
            t = this[0];
          if (t) {
            for (e = 0; null !== (t = t.previousSibling); )
              1 === t.nodeType && (e += 1);
            return e;
          }
        },
        eq: function (e) {
          if (void 0 === e) return this;
          const t = this.length;
          if (e > t - 1) return p([]);
          if (e < 0) {
            const i = t + e;
            return p(i < 0 ? [] : [this[i]]);
          }
          return p([this[e]]);
        },
        append: function (...e) {
          let t;
          const i = a();
          for (let n = 0; n < e.length; n += 1) {
            t = e[n];
            for (let e = 0; e < this.length; e += 1)
              if ("string" == typeof t) {
                const n = i.createElement("div");
                for (n.innerHTML = t; n.firstChild; )
                  this[e].appendChild(n.firstChild);
              } else if (t instanceof d)
                for (let i = 0; i < t.length; i += 1) this[e].appendChild(t[i]);
              else this[e].appendChild(t);
          }
          return this;
        },
        prepend: function (e) {
          const t = a();
          let i, n;
          for (i = 0; i < this.length; i += 1)
            if ("string" == typeof e) {
              const s = t.createElement("div");
              for (s.innerHTML = e, n = s.childNodes.length - 1; n >= 0; n -= 1)
                this[i].insertBefore(s.childNodes[n], this[i].childNodes[0]);
            } else if (e instanceof d)
              for (n = 0; n < e.length; n += 1)
                this[i].insertBefore(e[n], this[i].childNodes[0]);
            else this[i].insertBefore(e, this[i].childNodes[0]);
          return this;
        },
        next: function (e) {
          return this.length > 0
            ? e
              ? this[0].nextElementSibling &&
                p(this[0].nextElementSibling).is(e)
                ? p([this[0].nextElementSibling])
                : p([])
              : this[0].nextElementSibling
              ? p([this[0].nextElementSibling])
              : p([])
            : p([]);
        },
        nextAll: function (e) {
          const t = [];
          let i = this[0];
          if (!i) return p([]);
          for (; i.nextElementSibling; ) {
            const n = i.nextElementSibling;
            e ? p(n).is(e) && t.push(n) : t.push(n), (i = n);
          }
          return p(t);
        },
        prev: function (e) {
          if (this.length > 0) {
            const t = this[0];
            return e
              ? t.previousElementSibling && p(t.previousElementSibling).is(e)
                ? p([t.previousElementSibling])
                : p([])
              : t.previousElementSibling
              ? p([t.previousElementSibling])
              : p([]);
          }
          return p([]);
        },
        prevAll: function (e) {
          const t = [];
          let i = this[0];
          if (!i) return p([]);
          for (; i.previousElementSibling; ) {
            const n = i.previousElementSibling;
            e ? p(n).is(e) && t.push(n) : t.push(n), (i = n);
          }
          return p(t);
        },
        parent: function (e) {
          const t = [];
          for (let i = 0; i < this.length; i += 1)
            null !== this[i].parentNode &&
              (e
                ? p(this[i].parentNode).is(e) && t.push(this[i].parentNode)
                : t.push(this[i].parentNode));
          return p(t);
        },
        parents: function (e) {
          const t = [];
          for (let i = 0; i < this.length; i += 1) {
            let n = this[i].parentNode;
            for (; n; )
              e ? p(n).is(e) && t.push(n) : t.push(n), (n = n.parentNode);
          }
          return p(t);
        },
        closest: function (e) {
          let t = this;
          return void 0 === e
            ? p([])
            : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function (e) {
          const t = [];
          for (let i = 0; i < this.length; i += 1) {
            const n = this[i].querySelectorAll(e);
            for (let e = 0; e < n.length; e += 1) t.push(n[e]);
          }
          return p(t);
        },
        children: function (e) {
          const t = [];
          for (let i = 0; i < this.length; i += 1) {
            const n = this[i].children;
            for (let i = 0; i < n.length; i += 1)
              (e && !p(n[i]).is(e)) || t.push(n[i]);
          }
          return p(t);
        },
        filter: function (e) {
          return p(c(this, e));
        },
        remove: function () {
          for (let e = 0; e < this.length; e += 1)
            this[e].parentNode && this[e].parentNode.removeChild(this[e]);
          return this;
        },
      };
      Object.keys(m).forEach((e) => {
        Object.defineProperty(p.fn, e, { value: m[e], writable: !0 });
      });
      var g = p;
      function v(e, t) {
        return void 0 === t && (t = 0), setTimeout(e, t);
      }
      function y() {
        return Date.now();
      }
      function _(e) {
        return (
          "object" == typeof e &&
          null !== e &&
          e.constructor &&
          "Object" === Object.prototype.toString.call(e).slice(8, -1)
        );
      }
      function b(e) {
        return "undefined" != typeof window && void 0 !== window.HTMLElement
          ? e instanceof HTMLElement
          : e && (1 === e.nodeType || 11 === e.nodeType);
      }
      function w() {
        const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
          t = ["__proto__", "constructor", "prototype"];
        for (let i = 1; i < arguments.length; i += 1) {
          const n = i < 0 || arguments.length <= i ? void 0 : arguments[i];
          if (null != n && !b(n)) {
            const i = Object.keys(Object(n)).filter((e) => t.indexOf(e) < 0);
            for (let t = 0, s = i.length; t < s; t += 1) {
              const s = i[t],
                r = Object.getOwnPropertyDescriptor(n, s);
              void 0 !== r &&
                r.enumerable &&
                (_(e[s]) && _(n[s])
                  ? n[s].__swiper__
                    ? (e[s] = n[s])
                    : w(e[s], n[s])
                  : !_(e[s]) && _(n[s])
                  ? ((e[s] = {}),
                    n[s].__swiper__ ? (e[s] = n[s]) : w(e[s], n[s]))
                  : (e[s] = n[s]));
            }
          }
        }
        return e;
      }
      function T(e, t, i) {
        e.style.setProperty(t, i);
      }
      function x(e) {
        let { swiper: t, targetPosition: i, side: n } = e;
        const s = l(),
          r = -t.translate;
        let a,
          o = null;
        const d = t.params.speed;
        (t.wrapperEl.style.scrollSnapType = "none"),
          s.cancelAnimationFrame(t.cssModeFrameID);
        const u = i > r ? "next" : "prev",
          c = (e, t) => ("next" === u && e >= t) || ("prev" === u && e <= t),
          p = () => {
            (a = new Date().getTime()), null === o && (o = a);
            const e = Math.max(Math.min((a - o) / d, 1), 0),
              l = 0.5 - Math.cos(e * Math.PI) / 2;
            let u = r + l * (i - r);
            if ((c(u, i) && (u = i), t.wrapperEl.scrollTo({ [n]: u }), c(u, i)))
              return (
                (t.wrapperEl.style.overflow = "hidden"),
                (t.wrapperEl.style.scrollSnapType = ""),
                setTimeout(() => {
                  (t.wrapperEl.style.overflow = ""),
                    t.wrapperEl.scrollTo({ [n]: u });
                }),
                void s.cancelAnimationFrame(t.cssModeFrameID)
              );
            t.cssModeFrameID = s.requestAnimationFrame(p);
          };
        p();
      }
      let C, S, E;
      function M() {
        return (
          C ||
            (C = (function () {
              const e = l(),
                t = a();
              return {
                smoothScroll:
                  t.documentElement &&
                  "scrollBehavior" in t.documentElement.style,
                touch: !!(
                  "ontouchstart" in e ||
                  (e.DocumentTouch && t instanceof e.DocumentTouch)
                ),
                passiveListener: (function () {
                  let t = !1;
                  try {
                    const i = Object.defineProperty({}, "passive", {
                      get() {
                        t = !0;
                      },
                    });
                    e.addEventListener("testPassiveListener", null, i);
                  } catch (e) {}
                  return t;
                })(),
                gestures: "ongesturestart" in e,
              };
            })()),
          C
        );
      }
      var k = {
          on(e, t, i) {
            const n = this;
            if (!n.eventsListeners || n.destroyed) return n;
            if ("function" != typeof t) return n;
            const s = i ? "unshift" : "push";
            return (
              e.split(" ").forEach((e) => {
                n.eventsListeners[e] || (n.eventsListeners[e] = []),
                  n.eventsListeners[e][s](t);
              }),
              n
            );
          },
          once(e, t, i) {
            const n = this;
            if (!n.eventsListeners || n.destroyed) return n;
            if ("function" != typeof t) return n;
            function s() {
              n.off(e, s), s.__emitterProxy && delete s.__emitterProxy;
              for (
                var i = arguments.length, r = new Array(i), a = 0;
                a < i;
                a++
              )
                r[a] = arguments[a];
              t.apply(n, r);
            }
            return (s.__emitterProxy = t), n.on(e, s, i);
          },
          onAny(e, t) {
            const i = this;
            if (!i.eventsListeners || i.destroyed) return i;
            if ("function" != typeof e) return i;
            const n = t ? "unshift" : "push";
            return (
              i.eventsAnyListeners.indexOf(e) < 0 && i.eventsAnyListeners[n](e),
              i
            );
          },
          offAny(e) {
            const t = this;
            if (!t.eventsListeners || t.destroyed) return t;
            if (!t.eventsAnyListeners) return t;
            const i = t.eventsAnyListeners.indexOf(e);
            return i >= 0 && t.eventsAnyListeners.splice(i, 1), t;
          },
          off(e, t) {
            const i = this;
            return !i.eventsListeners || i.destroyed
              ? i
              : i.eventsListeners
              ? (e.split(" ").forEach((e) => {
                  void 0 === t
                    ? (i.eventsListeners[e] = [])
                    : i.eventsListeners[e] &&
                      i.eventsListeners[e].forEach((n, s) => {
                        (n === t ||
                          (n.__emitterProxy && n.__emitterProxy === t)) &&
                          i.eventsListeners[e].splice(s, 1);
                      });
                }),
                i)
              : i;
          },
          emit() {
            const e = this;
            if (!e.eventsListeners || e.destroyed) return e;
            if (!e.eventsListeners) return e;
            let t, i, n;
            for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
              r[a] = arguments[a];
            return (
              "string" == typeof r[0] || Array.isArray(r[0])
                ? ((t = r[0]), (i = r.slice(1, r.length)), (n = e))
                : ((t = r[0].events), (i = r[0].data), (n = r[0].context || e)),
              i.unshift(n),
              (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
                e.eventsAnyListeners &&
                  e.eventsAnyListeners.length &&
                  e.eventsAnyListeners.forEach((e) => {
                    e.apply(n, [t, ...i]);
                  }),
                  e.eventsListeners &&
                    e.eventsListeners[t] &&
                    e.eventsListeners[t].forEach((e) => {
                      e.apply(n, i);
                    });
              }),
              e
            );
          },
        },
        O = {
          updateSize: function () {
            const e = this;
            let t, i;
            const n = e.$el;
            (t =
              void 0 !== e.params.width && null !== e.params.width
                ? e.params.width
                : n[0].clientWidth),
              (i =
                void 0 !== e.params.height && null !== e.params.height
                  ? e.params.height
                  : n[0].clientHeight),
              (0 === t && e.isHorizontal()) ||
                (0 === i && e.isVertical()) ||
                ((t =
                  t -
                  parseInt(n.css("padding-left") || 0, 10) -
                  parseInt(n.css("padding-right") || 0, 10)),
                (i =
                  i -
                  parseInt(n.css("padding-top") || 0, 10) -
                  parseInt(n.css("padding-bottom") || 0, 10)),
                Number.isNaN(t) && (t = 0),
                Number.isNaN(i) && (i = 0),
                Object.assign(e, {
                  width: t,
                  height: i,
                  size: e.isHorizontal() ? t : i,
                }));
          },
          updateSlides: function () {
            const e = this;
            function t(t) {
              return e.isHorizontal()
                ? t
                : {
                    width: "height",
                    "margin-top": "margin-left",
                    "margin-bottom ": "margin-right",
                    "margin-left": "margin-top",
                    "margin-right": "margin-bottom",
                    "padding-left": "padding-top",
                    "padding-right": "padding-bottom",
                    marginRight: "marginBottom",
                  }[t];
            }
            function i(e, i) {
              return parseFloat(e.getPropertyValue(t(i)) || 0);
            }
            const n = e.params,
              { $wrapperEl: s, size: r, rtlTranslate: a, wrongRTL: o } = e,
              l = e.virtual && n.virtual.enabled,
              d = l ? e.virtual.slides.length : e.slides.length,
              u = s.children(`.${e.params.slideClass}`),
              c = l ? e.virtual.slides.length : u.length;
            let p = [];
            const h = [],
              f = [];
            let m = n.slidesOffsetBefore;
            "function" == typeof m && (m = n.slidesOffsetBefore.call(e));
            let g = n.slidesOffsetAfter;
            "function" == typeof g && (g = n.slidesOffsetAfter.call(e));
            const v = e.snapGrid.length,
              y = e.slidesGrid.length;
            let _ = n.spaceBetween,
              b = -m,
              w = 0,
              x = 0;
            if (void 0 === r) return;
            "string" == typeof _ &&
              _.indexOf("%") >= 0 &&
              (_ = (parseFloat(_.replace("%", "")) / 100) * r),
              (e.virtualSize = -_),
              a
                ? u.css({ marginLeft: "", marginBottom: "", marginTop: "" })
                : u.css({ marginRight: "", marginBottom: "", marginTop: "" }),
              n.centeredSlides &&
                n.cssMode &&
                (T(e.wrapperEl, "--swiper-centered-offset-before", ""),
                T(e.wrapperEl, "--swiper-centered-offset-after", ""));
            const C = n.grid && n.grid.rows > 1 && e.grid;
            let S;
            C && e.grid.initSlides(c);
            const E =
              "auto" === n.slidesPerView &&
              n.breakpoints &&
              Object.keys(n.breakpoints).filter(
                (e) => void 0 !== n.breakpoints[e].slidesPerView
              ).length > 0;
            for (let s = 0; s < c; s += 1) {
              S = 0;
              const a = u.eq(s);
              if (
                (C && e.grid.updateSlide(s, a, c, t),
                "none" !== a.css("display"))
              ) {
                if ("auto" === n.slidesPerView) {
                  E && (u[s].style[t("width")] = "");
                  const r = getComputedStyle(a[0]),
                    o = a[0].style.transform,
                    l = a[0].style.webkitTransform;
                  if (
                    (o && (a[0].style.transform = "none"),
                    l && (a[0].style.webkitTransform = "none"),
                    n.roundLengths)
                  )
                    S = e.isHorizontal() ? a.outerWidth(!0) : a.outerHeight(!0);
                  else {
                    const e = i(r, "width"),
                      t = i(r, "padding-left"),
                      n = i(r, "padding-right"),
                      s = i(r, "margin-left"),
                      o = i(r, "margin-right"),
                      l = r.getPropertyValue("box-sizing");
                    if (l && "border-box" === l) S = e + s + o;
                    else {
                      const { clientWidth: i, offsetWidth: r } = a[0];
                      S = e + t + n + s + o + (r - i);
                    }
                  }
                  o && (a[0].style.transform = o),
                    l && (a[0].style.webkitTransform = l),
                    n.roundLengths && (S = Math.floor(S));
                } else
                  (S = (r - (n.slidesPerView - 1) * _) / n.slidesPerView),
                    n.roundLengths && (S = Math.floor(S)),
                    u[s] && (u[s].style[t("width")] = `${S}px`);
                u[s] && (u[s].swiperSlideSize = S),
                  f.push(S),
                  n.centeredSlides
                    ? ((b = b + S / 2 + w / 2 + _),
                      0 === w && 0 !== s && (b = b - r / 2 - _),
                      0 === s && (b = b - r / 2 - _),
                      Math.abs(b) < 0.001 && (b = 0),
                      n.roundLengths && (b = Math.floor(b)),
                      x % n.slidesPerGroup == 0 && p.push(b),
                      h.push(b))
                    : (n.roundLengths && (b = Math.floor(b)),
                      (x - Math.min(e.params.slidesPerGroupSkip, x)) %
                        e.params.slidesPerGroup ==
                        0 && p.push(b),
                      h.push(b),
                      (b = b + S + _)),
                  (e.virtualSize += S + _),
                  (w = S),
                  (x += 1);
              }
            }
            if (
              ((e.virtualSize = Math.max(e.virtualSize, r) + g),
              a &&
                o &&
                ("slide" === n.effect || "coverflow" === n.effect) &&
                s.css({ width: `${e.virtualSize + n.spaceBetween}px` }),
              n.setWrapperSize &&
                s.css({ [t("width")]: `${e.virtualSize + n.spaceBetween}px` }),
              C && e.grid.updateWrapperSize(S, p, t),
              !n.centeredSlides)
            ) {
              const t = [];
              for (let i = 0; i < p.length; i += 1) {
                let s = p[i];
                n.roundLengths && (s = Math.floor(s)),
                  p[i] <= e.virtualSize - r && t.push(s);
              }
              (p = t),
                Math.floor(e.virtualSize - r) - Math.floor(p[p.length - 1]) >
                  1 && p.push(e.virtualSize - r);
            }
            if ((0 === p.length && (p = [0]), 0 !== n.spaceBetween)) {
              const i = e.isHorizontal() && a ? "marginLeft" : t("marginRight");
              u.filter((e, t) => !n.cssMode || t !== u.length - 1).css({
                [i]: `${_}px`,
              });
            }
            if (n.centeredSlides && n.centeredSlidesBounds) {
              let e = 0;
              f.forEach((t) => {
                e += t + (n.spaceBetween ? n.spaceBetween : 0);
              }),
                (e -= n.spaceBetween);
              const t = e - r;
              p = p.map((e) => (e < 0 ? -m : e > t ? t + g : e));
            }
            if (n.centerInsufficientSlides) {
              let e = 0;
              if (
                (f.forEach((t) => {
                  e += t + (n.spaceBetween ? n.spaceBetween : 0);
                }),
                (e -= n.spaceBetween),
                e < r)
              ) {
                const t = (r - e) / 2;
                p.forEach((e, i) => {
                  p[i] = e - t;
                }),
                  h.forEach((e, i) => {
                    h[i] = e + t;
                  });
              }
            }
            if (
              (Object.assign(e, {
                slides: u,
                snapGrid: p,
                slidesGrid: h,
                slidesSizesGrid: f,
              }),
              n.centeredSlides && n.cssMode && !n.centeredSlidesBounds)
            ) {
              T(e.wrapperEl, "--swiper-centered-offset-before", -p[0] + "px"),
                T(
                  e.wrapperEl,
                  "--swiper-centered-offset-after",
                  e.size / 2 - f[f.length - 1] / 2 + "px"
                );
              const t = -e.snapGrid[0],
                i = -e.slidesGrid[0];
              (e.snapGrid = e.snapGrid.map((e) => e + t)),
                (e.slidesGrid = e.slidesGrid.map((e) => e + i));
            }
            if (
              (c !== d && e.emit("slidesLengthChange"),
              p.length !== v &&
                (e.params.watchOverflow && e.checkOverflow(),
                e.emit("snapGridLengthChange")),
              h.length !== y && e.emit("slidesGridLengthChange"),
              n.watchSlidesProgress && e.updateSlidesOffset(),
              !(
                l ||
                n.cssMode ||
                ("slide" !== n.effect && "fade" !== n.effect)
              ))
            ) {
              const t = `${n.containerModifierClass}backface-hidden`,
                i = e.$el.hasClass(t);
              c <= n.maxBackfaceHiddenSlides
                ? i || e.$el.addClass(t)
                : i && e.$el.removeClass(t);
            }
          },
          updateAutoHeight: function (e) {
            const t = this,
              i = [],
              n = t.virtual && t.params.virtual.enabled;
            let s,
              r = 0;
            "number" == typeof e
              ? t.setTransition(e)
              : !0 === e && t.setTransition(t.params.speed);
            const a = (e) =>
              n
                ? t.slides.filter(
                    (t) =>
                      parseInt(
                        t.getAttribute("data-swiper-slide-index"),
                        10
                      ) === e
                  )[0]
                : t.slides.eq(e)[0];
            if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
              if (t.params.centeredSlides)
                (t.visibleSlides || g([])).each((e) => {
                  i.push(e);
                });
              else
                for (s = 0; s < Math.ceil(t.params.slidesPerView); s += 1) {
                  const e = t.activeIndex + s;
                  if (e > t.slides.length && !n) break;
                  i.push(a(e));
                }
            else i.push(a(t.activeIndex));
            for (s = 0; s < i.length; s += 1)
              if (void 0 !== i[s]) {
                const e = i[s].offsetHeight;
                r = e > r ? e : r;
              }
            (r || 0 === r) && t.$wrapperEl.css("height", `${r}px`);
          },
          updateSlidesOffset: function () {
            const e = this,
              t = e.slides;
            for (let i = 0; i < t.length; i += 1)
              t[i].swiperSlideOffset = e.isHorizontal()
                ? t[i].offsetLeft
                : t[i].offsetTop;
          },
          updateSlidesProgress: function (e) {
            void 0 === e && (e = (this && this.translate) || 0);
            const t = this,
              i = t.params,
              { slides: n, rtlTranslate: s, snapGrid: r } = t;
            if (0 === n.length) return;
            void 0 === n[0].swiperSlideOffset && t.updateSlidesOffset();
            let a = -e;
            s && (a = e),
              n.removeClass(i.slideVisibleClass),
              (t.visibleSlidesIndexes = []),
              (t.visibleSlides = []);
            for (let e = 0; e < n.length; e += 1) {
              const o = n[e];
              let l = o.swiperSlideOffset;
              i.cssMode && i.centeredSlides && (l -= n[0].swiperSlideOffset);
              const d =
                  (a + (i.centeredSlides ? t.minTranslate() : 0) - l) /
                  (o.swiperSlideSize + i.spaceBetween),
                u =
                  (a - r[0] + (i.centeredSlides ? t.minTranslate() : 0) - l) /
                  (o.swiperSlideSize + i.spaceBetween),
                c = -(a - l),
                p = c + t.slidesSizesGrid[e];
              ((c >= 0 && c < t.size - 1) ||
                (p > 1 && p <= t.size) ||
                (c <= 0 && p >= t.size)) &&
                (t.visibleSlides.push(o),
                t.visibleSlidesIndexes.push(e),
                n.eq(e).addClass(i.slideVisibleClass)),
                (o.progress = s ? -d : d),
                (o.originalProgress = s ? -u : u);
            }
            t.visibleSlides = g(t.visibleSlides);
          },
          updateProgress: function (e) {
            const t = this;
            if (void 0 === e) {
              const i = t.rtlTranslate ? -1 : 1;
              e = (t && t.translate && t.translate * i) || 0;
            }
            const i = t.params,
              n = t.maxTranslate() - t.minTranslate();
            let { progress: s, isBeginning: r, isEnd: a } = t;
            const o = r,
              l = a;
            0 === n
              ? ((s = 0), (r = !0), (a = !0))
              : ((s = (e - t.minTranslate()) / n), (r = s <= 0), (a = s >= 1)),
              Object.assign(t, { progress: s, isBeginning: r, isEnd: a }),
              (i.watchSlidesProgress || (i.centeredSlides && i.autoHeight)) &&
                t.updateSlidesProgress(e),
              r && !o && t.emit("reachBeginning toEdge"),
              a && !l && t.emit("reachEnd toEdge"),
              ((o && !r) || (l && !a)) && t.emit("fromEdge"),
              t.emit("progress", s);
          },
          updateSlidesClasses: function () {
            const e = this,
              {
                slides: t,
                params: i,
                $wrapperEl: n,
                activeIndex: s,
                realIndex: r,
              } = e,
              a = e.virtual && i.virtual.enabled;
            let o;
            t.removeClass(
              `${i.slideActiveClass} ${i.slideNextClass} ${i.slidePrevClass} ${i.slideDuplicateActiveClass} ${i.slideDuplicateNextClass} ${i.slideDuplicatePrevClass}`
            ),
              (o = a
                ? e.$wrapperEl.find(
                    `.${i.slideClass}[data-swiper-slide-index="${s}"]`
                  )
                : t.eq(s)),
              o.addClass(i.slideActiveClass),
              i.loop &&
                (o.hasClass(i.slideDuplicateClass)
                  ? n
                      .children(
                        `.${i.slideClass}:not(.${i.slideDuplicateClass})[data-swiper-slide-index="${r}"]`
                      )
                      .addClass(i.slideDuplicateActiveClass)
                  : n
                      .children(
                        `.${i.slideClass}.${i.slideDuplicateClass}[data-swiper-slide-index="${r}"]`
                      )
                      .addClass(i.slideDuplicateActiveClass));
            let l = o
              .nextAll(`.${i.slideClass}`)
              .eq(0)
              .addClass(i.slideNextClass);
            i.loop &&
              0 === l.length &&
              ((l = t.eq(0)), l.addClass(i.slideNextClass));
            let d = o
              .prevAll(`.${i.slideClass}`)
              .eq(0)
              .addClass(i.slidePrevClass);
            i.loop &&
              0 === d.length &&
              ((d = t.eq(-1)), d.addClass(i.slidePrevClass)),
              i.loop &&
                (l.hasClass(i.slideDuplicateClass)
                  ? n
                      .children(
                        `.${i.slideClass}:not(.${
                          i.slideDuplicateClass
                        })[data-swiper-slide-index="${l.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(i.slideDuplicateNextClass)
                  : n
                      .children(
                        `.${i.slideClass}.${
                          i.slideDuplicateClass
                        }[data-swiper-slide-index="${l.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(i.slideDuplicateNextClass),
                d.hasClass(i.slideDuplicateClass)
                  ? n
                      .children(
                        `.${i.slideClass}:not(.${
                          i.slideDuplicateClass
                        })[data-swiper-slide-index="${d.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(i.slideDuplicatePrevClass)
                  : n
                      .children(
                        `.${i.slideClass}.${
                          i.slideDuplicateClass
                        }[data-swiper-slide-index="${d.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(i.slideDuplicatePrevClass)),
              e.emitSlidesClasses();
          },
          updateActiveIndex: function (e) {
            const t = this,
              i = t.rtlTranslate ? t.translate : -t.translate,
              {
                slidesGrid: n,
                snapGrid: s,
                params: r,
                activeIndex: a,
                realIndex: o,
                snapIndex: l,
              } = t;
            let d,
              u = e;
            if (void 0 === u) {
              for (let e = 0; e < n.length; e += 1)
                void 0 !== n[e + 1]
                  ? i >= n[e] && i < n[e + 1] - (n[e + 1] - n[e]) / 2
                    ? (u = e)
                    : i >= n[e] && i < n[e + 1] && (u = e + 1)
                  : i >= n[e] && (u = e);
              r.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0);
            }
            if (s.indexOf(i) >= 0) d = s.indexOf(i);
            else {
              const e = Math.min(r.slidesPerGroupSkip, u);
              d = e + Math.floor((u - e) / r.slidesPerGroup);
            }
            if ((d >= s.length && (d = s.length - 1), u === a))
              return void (
                d !== l && ((t.snapIndex = d), t.emit("snapIndexChange"))
              );
            const c = parseInt(
              t.slides.eq(u).attr("data-swiper-slide-index") || u,
              10
            );
            Object.assign(t, {
              snapIndex: d,
              realIndex: c,
              previousIndex: a,
              activeIndex: u,
            }),
              t.emit("activeIndexChange"),
              t.emit("snapIndexChange"),
              o !== c && t.emit("realIndexChange"),
              (t.initialized || t.params.runCallbacksOnInit) &&
                t.emit("slideChange");
          },
          updateClickedSlide: function (e) {
            const t = this,
              i = t.params,
              n = g(e).closest(`.${i.slideClass}`)[0];
            let s,
              r = !1;
            if (n)
              for (let e = 0; e < t.slides.length; e += 1)
                if (t.slides[e] === n) {
                  (r = !0), (s = e);
                  break;
                }
            if (!n || !r)
              return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
            (t.clickedSlide = n),
              t.virtual && t.params.virtual.enabled
                ? (t.clickedIndex = parseInt(
                    g(n).attr("data-swiper-slide-index"),
                    10
                  ))
                : (t.clickedIndex = s),
              i.slideToClickedSlide &&
                void 0 !== t.clickedIndex &&
                t.clickedIndex !== t.activeIndex &&
                t.slideToClickedSlide();
          },
        },
        P = {
          getTranslate: function (e) {
            void 0 === e && (e = this.isHorizontal() ? "x" : "y");
            const {
              params: t,
              rtlTranslate: i,
              translate: n,
              $wrapperEl: s,
            } = this;
            if (t.virtualTranslate) return i ? -n : n;
            if (t.cssMode) return n;
            let r = (function (e, t) {
              void 0 === t && (t = "x");
              const i = l();
              let n, s, r;
              const a = (function (e) {
                const t = l();
                let i;
                return (
                  t.getComputedStyle && (i = t.getComputedStyle(e, null)),
                  !i && e.currentStyle && (i = e.currentStyle),
                  i || (i = e.style),
                  i
                );
              })(e);
              return (
                i.WebKitCSSMatrix
                  ? ((s = a.transform || a.webkitTransform),
                    s.split(",").length > 6 &&
                      (s = s
                        .split(", ")
                        .map((e) => e.replace(",", "."))
                        .join(", ")),
                    (r = new i.WebKitCSSMatrix("none" === s ? "" : s)))
                  : ((r =
                      a.MozTransform ||
                      a.OTransform ||
                      a.MsTransform ||
                      a.msTransform ||
                      a.transform ||
                      a
                        .getPropertyValue("transform")
                        .replace("translate(", "matrix(1, 0, 0, 1,")),
                    (n = r.toString().split(","))),
                "x" === t &&
                  (s = i.WebKitCSSMatrix
                    ? r.m41
                    : 16 === n.length
                    ? parseFloat(n[12])
                    : parseFloat(n[4])),
                "y" === t &&
                  (s = i.WebKitCSSMatrix
                    ? r.m42
                    : 16 === n.length
                    ? parseFloat(n[13])
                    : parseFloat(n[5])),
                s || 0
              );
            })(s[0], e);
            return i && (r = -r), r || 0;
          },
          setTranslate: function (e, t) {
            const i = this,
              {
                rtlTranslate: n,
                params: s,
                $wrapperEl: r,
                wrapperEl: a,
                progress: o,
              } = i;
            let l,
              d = 0,
              u = 0;
            i.isHorizontal() ? (d = n ? -e : e) : (u = e),
              s.roundLengths && ((d = Math.floor(d)), (u = Math.floor(u))),
              s.cssMode
                ? (a[i.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                    i.isHorizontal() ? -d : -u)
                : s.virtualTranslate ||
                  r.transform(`translate3d(${d}px, ${u}px, 0px)`),
              (i.previousTranslate = i.translate),
              (i.translate = i.isHorizontal() ? d : u);
            const c = i.maxTranslate() - i.minTranslate();
            (l = 0 === c ? 0 : (e - i.minTranslate()) / c),
              l !== o && i.updateProgress(e),
              i.emit("setTranslate", i.translate, t);
          },
          minTranslate: function () {
            return -this.snapGrid[0];
          },
          maxTranslate: function () {
            return -this.snapGrid[this.snapGrid.length - 1];
          },
          translateTo: function (e, t, i, n, s) {
            void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === i && (i = !0),
              void 0 === n && (n = !0);
            const r = this,
              { params: a, wrapperEl: o } = r;
            if (r.animating && a.preventInteractionOnTransition) return !1;
            const l = r.minTranslate(),
              d = r.maxTranslate();
            let u;
            if (
              ((u = n && e > l ? l : n && e < d ? d : e),
              r.updateProgress(u),
              a.cssMode)
            ) {
              const e = r.isHorizontal();
              if (0 === t) o[e ? "scrollLeft" : "scrollTop"] = -u;
              else {
                if (!r.support.smoothScroll)
                  return (
                    x({
                      swiper: r,
                      targetPosition: -u,
                      side: e ? "left" : "top",
                    }),
                    !0
                  );
                o.scrollTo({ [e ? "left" : "top"]: -u, behavior: "smooth" });
              }
              return !0;
            }
            return (
              0 === t
                ? (r.setTransition(0),
                  r.setTranslate(u),
                  i &&
                    (r.emit("beforeTransitionStart", t, s),
                    r.emit("transitionEnd")))
                : (r.setTransition(t),
                  r.setTranslate(u),
                  i &&
                    (r.emit("beforeTransitionStart", t, s),
                    r.emit("transitionStart")),
                  r.animating ||
                    ((r.animating = !0),
                    r.onTranslateToWrapperTransitionEnd ||
                      (r.onTranslateToWrapperTransitionEnd = function (e) {
                        r &&
                          !r.destroyed &&
                          e.target === this &&
                          (r.$wrapperEl[0].removeEventListener(
                            "transitionend",
                            r.onTranslateToWrapperTransitionEnd
                          ),
                          r.$wrapperEl[0].removeEventListener(
                            "webkitTransitionEnd",
                            r.onTranslateToWrapperTransitionEnd
                          ),
                          (r.onTranslateToWrapperTransitionEnd = null),
                          delete r.onTranslateToWrapperTransitionEnd,
                          i && r.emit("transitionEnd"));
                      }),
                    r.$wrapperEl[0].addEventListener(
                      "transitionend",
                      r.onTranslateToWrapperTransitionEnd
                    ),
                    r.$wrapperEl[0].addEventListener(
                      "webkitTransitionEnd",
                      r.onTranslateToWrapperTransitionEnd
                    ))),
              !0
            );
          },
        },
        L = i(3901),
        $ = {
          slideTo: function (e, t, i, n, s) {
            if (
              (void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === i && (i = !0),
              "number" != typeof e && "string" != typeof e)
            )
              throw new Error(
                `The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`
              );
            if ("string" == typeof e) {
              const t = parseInt(e, 10);
              if (!isFinite(t))
                throw new Error(
                  `The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`
                );
              e = t;
            }
            const r = this;
            let a = e;
            a < 0 && (a = 0);
            const {
              params: o,
              snapGrid: l,
              slidesGrid: d,
              previousIndex: u,
              activeIndex: c,
              rtlTranslate: p,
              wrapperEl: h,
              enabled: f,
            } = r;
            if (
              (r.animating && o.preventInteractionOnTransition) ||
              (!f && !n && !s)
            )
              return !1;
            const m = Math.min(r.params.slidesPerGroupSkip, a);
            let g = m + Math.floor((a - m) / r.params.slidesPerGroup);
            g >= l.length && (g = l.length - 1),
              (c || o.initialSlide || 0) === (u || 0) &&
                i &&
                r.emit("beforeSlideChangeStart");
            const v = -l[g];
            if ((r.updateProgress(v), o.normalizeSlideIndex))
              for (let e = 0; e < d.length; e += 1) {
                const t = -Math.floor(100 * v),
                  i = Math.floor(100 * d[e]),
                  n = Math.floor(100 * d[e + 1]);
                void 0 !== d[e + 1]
                  ? t >= i && t < n - (n - i) / 2
                    ? (a = e)
                    : t >= i && t < n && (a = e + 1)
                  : t >= i && (a = e);
              }
            if (r.initialized && a !== c) {
              if (!r.allowSlideNext && v < r.translate && v < r.minTranslate())
                return !1;
              if (
                !r.allowSlidePrev &&
                v > r.translate &&
                v > r.maxTranslate() &&
                (c || 0) !== a
              )
                return !1;
            }
            let y;
            if (
              ((y = a > c ? "next" : a < c ? "prev" : "reset"),
              (p && -v === r.translate) || (!p && v === r.translate))
            )
              return (
                r.updateActiveIndex(a),
                o.autoHeight && r.updateAutoHeight(),
                r.updateSlidesClasses(),
                "slide" !== o.effect && r.setTranslate(v),
                "reset" !== y &&
                  (r.transitionStart(i, y), r.transitionEnd(i, y)),
                !1
              );
            if (o.cssMode) {
              const e = r.isHorizontal(),
                i = p ? v : -v;
              if (0 === t) {
                const t = r.virtual && r.params.virtual.enabled;
                t &&
                  ((r.wrapperEl.style.scrollSnapType = "none"),
                  (r._immediateVirtual = !0)),
                  (h[e ? "scrollLeft" : "scrollTop"] = i),
                  t &&
                    requestAnimationFrame(() => {
                      (r.wrapperEl.style.scrollSnapType = ""),
                        (r._swiperImmediateVirtual = !1);
                    });
              } else {
                if (!r.support.smoothScroll)
                  return (
                    x({
                      swiper: r,
                      targetPosition: i,
                      side: e ? "left" : "top",
                    }),
                    !0
                  );
                h.scrollTo({ [e ? "left" : "top"]: i, behavior: "smooth" });
              }
              return !0;
            }
            return (
              r.setTransition(t),
              r.setTranslate(v),
              r.updateActiveIndex(a),
              r.updateSlidesClasses(),
              r.emit("beforeTransitionStart", t, n),
              r.transitionStart(i, y),
              0 === t
                ? r.transitionEnd(i, y)
                : r.animating ||
                  ((r.animating = !0),
                  r.onSlideToWrapperTransitionEnd ||
                    (r.onSlideToWrapperTransitionEnd = function (e) {
                      r &&
                        !r.destroyed &&
                        e.target === this &&
                        (r.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          r.onSlideToWrapperTransitionEnd
                        ),
                        r.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          r.onSlideToWrapperTransitionEnd
                        ),
                        (r.onSlideToWrapperTransitionEnd = null),
                        delete r.onSlideToWrapperTransitionEnd,
                        r.transitionEnd(i, y));
                    }),
                  r.$wrapperEl[0].addEventListener(
                    "transitionend",
                    r.onSlideToWrapperTransitionEnd
                  ),
                  r.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    r.onSlideToWrapperTransitionEnd
                  )),
              !0
            );
          },
          slideToLoop: function (e, t, i, n) {
            if (
              (void 0 === e && (e = 0),
              void 0 === t && (t = this.params.speed),
              void 0 === i && (i = !0),
              "string" == typeof e)
            ) {
              const t = parseInt(e, 10);
              if (!isFinite(t))
                throw new Error(
                  `The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`
                );
              e = t;
            }
            const s = this;
            let r = e;
            return (
              s.params.loop && (r += s.loopedSlides), s.slideTo(r, t, i, n)
            );
          },
          slideNext: function (e, t, i) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            const n = this,
              { animating: s, enabled: r, params: a } = n;
            if (!r) return n;
            let o = a.slidesPerGroup;
            "auto" === a.slidesPerView &&
              1 === a.slidesPerGroup &&
              a.slidesPerGroupAuto &&
              (o = Math.max(n.slidesPerViewDynamic("current", !0), 1));
            const l = n.activeIndex < a.slidesPerGroupSkip ? 1 : o;
            if (a.loop) {
              if (s && a.loopPreventsSlide) return !1;
              n.loopFix(), (n._clientLeft = n.$wrapperEl[0].clientLeft);
            }
            return a.rewind && n.isEnd
              ? n.slideTo(0, e, t, i)
              : n.slideTo(n.activeIndex + l, e, t, i);
          },
          slidePrev: function (e, t, i) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            const n = this,
              {
                params: s,
                animating: r,
                snapGrid: a,
                slidesGrid: o,
                rtlTranslate: l,
                enabled: d,
              } = n;
            if (!d) return n;
            if (s.loop) {
              if (r && s.loopPreventsSlide) return !1;
              n.loopFix(), (n._clientLeft = n.$wrapperEl[0].clientLeft);
            }
            function u(e) {
              return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            const c = u(l ? n.translate : -n.translate),
              p = a.map((e) => u(e));
            let h = a[p.indexOf(c) - 1];
            if (void 0 === h && s.cssMode) {
              let e;
              a.forEach((t, i) => {
                c >= t && (e = i);
              }),
                void 0 !== e && (h = a[e > 0 ? e - 1 : e]);
            }
            let f = 0;
            if (
              (void 0 !== h &&
                ((f = o.indexOf(h)),
                f < 0 && (f = n.activeIndex - 1),
                "auto" === s.slidesPerView &&
                  1 === s.slidesPerGroup &&
                  s.slidesPerGroupAuto &&
                  ((f = f - n.slidesPerViewDynamic("previous", !0) + 1),
                  (f = Math.max(f, 0)))),
              s.rewind && n.isBeginning)
            ) {
              const s =
                n.params.virtual && n.params.virtual.enabled && n.virtual
                  ? n.virtual.slides.length - 1
                  : n.slides.length - 1;
              return n.slideTo(s, e, t, i);
            }
            return n.slideTo(f, e, t, i);
          },
          slideReset: function (e, t, i) {
            return (
              void 0 === e && (e = this.params.speed),
              void 0 === t && (t = !0),
              this.slideTo(this.activeIndex, e, t, i)
            );
          },
          slideToClosest: function (e, t, i, n) {
            void 0 === e && (e = this.params.speed),
              void 0 === t && (t = !0),
              void 0 === n && (n = 0.5);
            const s = this;
            let r = s.activeIndex;
            const a = Math.min(s.params.slidesPerGroupSkip, r),
              o = a + Math.floor((r - a) / s.params.slidesPerGroup),
              l = s.rtlTranslate ? s.translate : -s.translate;
            if (l >= s.snapGrid[o]) {
              const e = s.snapGrid[o];
              l - e > (s.snapGrid[o + 1] - e) * n &&
                (r += s.params.slidesPerGroup);
            } else {
              const e = s.snapGrid[o - 1];
              l - e <= (s.snapGrid[o] - e) * n &&
                (r -= s.params.slidesPerGroup);
            }
            return (
              (r = Math.max(r, 0)),
              (r = Math.min(r, s.slidesGrid.length - 1)),
              s.slideTo(r, e, t, i)
            );
          },
          slideToClickedSlide: function () {
            const e = this,
              { params: t, $wrapperEl: i } = e,
              n =
                "auto" === t.slidesPerView
                  ? e.slidesPerViewDynamic()
                  : t.slidesPerView;
            let s,
              r = e.clickedIndex;
            if (t.loop) {
              if (e.animating) return;
              (s = parseInt(
                g(e.clickedSlide).attr("data-swiper-slide-index"),
                10
              )),
                t.centeredSlides
                  ? r < e.loopedSlides - n / 2 ||
                    r > e.slides.length - e.loopedSlides + n / 2
                    ? (e.loopFix(),
                      (r = i
                        .children(
                          `.${t.slideClass}[data-swiper-slide-index="${s}"]:not(.${t.slideDuplicateClass})`
                        )
                        .eq(0)
                        .index()),
                      v(() => {
                        e.slideTo(r);
                      }))
                    : e.slideTo(r)
                  : r > e.slides.length - n
                  ? (e.loopFix(),
                    (r = i
                      .children(
                        `.${t.slideClass}[data-swiper-slide-index="${s}"]:not(.${t.slideDuplicateClass})`
                      )
                      .eq(0)
                      .index()),
                    v(() => {
                      e.slideTo(r);
                    }))
                  : e.slideTo(r);
            } else e.slideTo(r);
          },
        };
      function A(e) {
        const t = this,
          i = a(),
          n = l(),
          s = t.touchEventsData,
          { params: r, touches: o, enabled: d } = t;
        if (!d) return;
        if (t.animating && r.preventInteractionOnTransition) return;
        !t.animating && r.cssMode && r.loop && t.loopFix();
        let u = e;
        u.originalEvent && (u = u.originalEvent);
        let c = g(u.target);
        if ("wrapper" === r.touchEventsTarget && !c.closest(t.wrapperEl).length)
          return;
        if (
          ((s.isTouchEvent = "touchstart" === u.type),
          !s.isTouchEvent && "which" in u && 3 === u.which)
        )
          return;
        if (!s.isTouchEvent && "button" in u && u.button > 0) return;
        if (s.isTouched && s.isMoved) return;
        r.noSwipingClass &&
          "" !== r.noSwipingClass &&
          u.target &&
          u.target.shadowRoot &&
          e.path &&
          e.path[0] &&
          (c = g(e.path[0]));
        const p = r.noSwipingSelector
            ? r.noSwipingSelector
            : `.${r.noSwipingClass}`,
          h = !(!u.target || !u.target.shadowRoot);
        if (
          r.noSwiping &&
          (h
            ? (function (e, t) {
                return (
                  void 0 === t && (t = this),
                  (function t(i) {
                    if (!i || i === a() || i === l()) return null;
                    i.assignedSlot && (i = i.assignedSlot);
                    const n = i.closest(e);
                    return n || i.getRootNode
                      ? n || t(i.getRootNode().host)
                      : null;
                  })(t)
                );
              })(p, c[0])
            : c.closest(p)[0])
        )
          return void (t.allowClick = !0);
        if (r.swipeHandler && !c.closest(r.swipeHandler)[0]) return;
        (o.currentX =
          "touchstart" === u.type ? u.targetTouches[0].pageX : u.pageX),
          (o.currentY =
            "touchstart" === u.type ? u.targetTouches[0].pageY : u.pageY);
        const f = o.currentX,
          m = o.currentY,
          v = r.edgeSwipeDetection || r.iOSEdgeSwipeDetection,
          _ = r.edgeSwipeThreshold || r.iOSEdgeSwipeThreshold;
        if (v && (f <= _ || f >= n.innerWidth - _)) {
          if ("prevent" !== v) return;
          e.preventDefault();
        }
        if (
          (Object.assign(s, {
            isTouched: !0,
            isMoved: !1,
            allowTouchCallbacks: !0,
            isScrolling: void 0,
            startMoving: void 0,
          }),
          (o.startX = f),
          (o.startY = m),
          (s.touchStartTime = y()),
          (t.allowClick = !0),
          t.updateSize(),
          (t.swipeDirection = void 0),
          r.threshold > 0 && (s.allowThresholdMove = !1),
          "touchstart" !== u.type)
        ) {
          let e = !0;
          c.is(s.focusableElements) &&
            ((e = !1), "SELECT" === c[0].nodeName && (s.isTouched = !1)),
            i.activeElement &&
              g(i.activeElement).is(s.focusableElements) &&
              i.activeElement !== c[0] &&
              i.activeElement.blur();
          const n = e && t.allowTouchMove && r.touchStartPreventDefault;
          (!r.touchStartForcePreventDefault && !n) ||
            c[0].isContentEditable ||
            u.preventDefault();
        }
        t.params.freeMode &&
          t.params.freeMode.enabled &&
          t.freeMode &&
          t.animating &&
          !r.cssMode &&
          t.freeMode.onTouchStart(),
          t.emit("touchStart", u);
      }
      function z(e) {
        const t = a(),
          i = this,
          n = i.touchEventsData,
          { params: s, touches: r, rtlTranslate: o, enabled: l } = i;
        if (!l) return;
        let d = e;
        if ((d.originalEvent && (d = d.originalEvent), !n.isTouched))
          return void (
            n.startMoving &&
            n.isScrolling &&
            i.emit("touchMoveOpposite", d)
          );
        if (n.isTouchEvent && "touchmove" !== d.type) return;
        const u =
            "touchmove" === d.type &&
            d.targetTouches &&
            (d.targetTouches[0] || d.changedTouches[0]),
          c = "touchmove" === d.type ? u.pageX : d.pageX,
          p = "touchmove" === d.type ? u.pageY : d.pageY;
        if (d.preventedByNestedSwiper)
          return (r.startX = c), void (r.startY = p);
        if (!i.allowTouchMove)
          return (
            g(d.target).is(n.focusableElements) || (i.allowClick = !1),
            void (
              n.isTouched &&
              (Object.assign(r, {
                startX: c,
                startY: p,
                currentX: c,
                currentY: p,
              }),
              (n.touchStartTime = y()))
            )
          );
        if (n.isTouchEvent && s.touchReleaseOnEdges && !s.loop)
          if (i.isVertical()) {
            if (
              (p < r.startY && i.translate <= i.maxTranslate()) ||
              (p > r.startY && i.translate >= i.minTranslate())
            )
              return (n.isTouched = !1), void (n.isMoved = !1);
          } else if (
            (c < r.startX && i.translate <= i.maxTranslate()) ||
            (c > r.startX && i.translate >= i.minTranslate())
          )
            return;
        if (
          n.isTouchEvent &&
          t.activeElement &&
          d.target === t.activeElement &&
          g(d.target).is(n.focusableElements)
        )
          return (n.isMoved = !0), void (i.allowClick = !1);
        if (
          (n.allowTouchCallbacks && i.emit("touchMove", d),
          d.targetTouches && d.targetTouches.length > 1)
        )
          return;
        (r.currentX = c), (r.currentY = p);
        const h = r.currentX - r.startX,
          f = r.currentY - r.startY;
        if (
          i.params.threshold &&
          Math.sqrt(h ** 2 + f ** 2) < i.params.threshold
        )
          return;
        if (void 0 === n.isScrolling) {
          let e;
          (i.isHorizontal() && r.currentY === r.startY) ||
          (i.isVertical() && r.currentX === r.startX)
            ? (n.isScrolling = !1)
            : h * h + f * f >= 25 &&
              ((e = (180 * Math.atan2(Math.abs(f), Math.abs(h))) / Math.PI),
              (n.isScrolling = i.isHorizontal()
                ? e > s.touchAngle
                : 90 - e > s.touchAngle));
        }
        if (
          (n.isScrolling && i.emit("touchMoveOpposite", d),
          void 0 === n.startMoving &&
            ((r.currentX === r.startX && r.currentY === r.startY) ||
              (n.startMoving = !0)),
          n.isScrolling)
        )
          return void (n.isTouched = !1);
        if (!n.startMoving) return;
        (i.allowClick = !1),
          !s.cssMode && d.cancelable && d.preventDefault(),
          s.touchMoveStopPropagation && !s.nested && d.stopPropagation(),
          n.isMoved ||
            (s.loop && !s.cssMode && i.loopFix(),
            (n.startTranslate = i.getTranslate()),
            i.setTransition(0),
            i.animating &&
              i.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
            (n.allowMomentumBounce = !1),
            !s.grabCursor ||
              (!0 !== i.allowSlideNext && !0 !== i.allowSlidePrev) ||
              i.setGrabCursor(!0),
            i.emit("sliderFirstMove", d)),
          i.emit("sliderMove", d),
          (n.isMoved = !0);
        let m = i.isHorizontal() ? h : f;
        (r.diff = m),
          (m *= s.touchRatio),
          o && (m = -m),
          (i.swipeDirection = m > 0 ? "prev" : "next"),
          (n.currentTranslate = m + n.startTranslate);
        let v = !0,
          _ = s.resistanceRatio;
        if (
          (s.touchReleaseOnEdges && (_ = 0),
          m > 0 && n.currentTranslate > i.minTranslate()
            ? ((v = !1),
              s.resistance &&
                (n.currentTranslate =
                  i.minTranslate() -
                  1 +
                  (-i.minTranslate() + n.startTranslate + m) ** _))
            : m < 0 &&
              n.currentTranslate < i.maxTranslate() &&
              ((v = !1),
              s.resistance &&
                (n.currentTranslate =
                  i.maxTranslate() +
                  1 -
                  (i.maxTranslate() - n.startTranslate - m) ** _)),
          v && (d.preventedByNestedSwiper = !0),
          !i.allowSlideNext &&
            "next" === i.swipeDirection &&
            n.currentTranslate < n.startTranslate &&
            (n.currentTranslate = n.startTranslate),
          !i.allowSlidePrev &&
            "prev" === i.swipeDirection &&
            n.currentTranslate > n.startTranslate &&
            (n.currentTranslate = n.startTranslate),
          i.allowSlidePrev ||
            i.allowSlideNext ||
            (n.currentTranslate = n.startTranslate),
          s.threshold > 0)
        ) {
          if (!(Math.abs(m) > s.threshold || n.allowThresholdMove))
            return void (n.currentTranslate = n.startTranslate);
          if (!n.allowThresholdMove)
            return (
              (n.allowThresholdMove = !0),
              (r.startX = r.currentX),
              (r.startY = r.currentY),
              (n.currentTranslate = n.startTranslate),
              void (r.diff = i.isHorizontal()
                ? r.currentX - r.startX
                : r.currentY - r.startY)
            );
        }
        s.followFinger &&
          !s.cssMode &&
          (((s.freeMode && s.freeMode.enabled && i.freeMode) ||
            s.watchSlidesProgress) &&
            (i.updateActiveIndex(), i.updateSlidesClasses()),
          i.params.freeMode &&
            s.freeMode.enabled &&
            i.freeMode &&
            i.freeMode.onTouchMove(),
          i.updateProgress(n.currentTranslate),
          i.setTranslate(n.currentTranslate));
      }
      function D(e) {
        const t = this,
          i = t.touchEventsData,
          {
            params: n,
            touches: s,
            rtlTranslate: r,
            slidesGrid: a,
            enabled: o,
          } = t;
        if (!o) return;
        let l = e;
        if (
          (l.originalEvent && (l = l.originalEvent),
          i.allowTouchCallbacks && t.emit("touchEnd", l),
          (i.allowTouchCallbacks = !1),
          !i.isTouched)
        )
          return (
            i.isMoved && n.grabCursor && t.setGrabCursor(!1),
            (i.isMoved = !1),
            void (i.startMoving = !1)
          );
        n.grabCursor &&
          i.isMoved &&
          i.isTouched &&
          (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
          t.setGrabCursor(!1);
        const d = y(),
          u = d - i.touchStartTime;
        if (t.allowClick) {
          const e = l.path || (l.composedPath && l.composedPath());
          t.updateClickedSlide((e && e[0]) || l.target),
            t.emit("tap click", l),
            u < 300 &&
              d - i.lastClickTime < 300 &&
              t.emit("doubleTap doubleClick", l);
        }
        if (
          ((i.lastClickTime = y()),
          v(() => {
            t.destroyed || (t.allowClick = !0);
          }),
          !i.isTouched ||
            !i.isMoved ||
            !t.swipeDirection ||
            0 === s.diff ||
            i.currentTranslate === i.startTranslate)
        )
          return (
            (i.isTouched = !1), (i.isMoved = !1), void (i.startMoving = !1)
          );
        let c;
        if (
          ((i.isTouched = !1),
          (i.isMoved = !1),
          (i.startMoving = !1),
          (c = n.followFinger
            ? r
              ? t.translate
              : -t.translate
            : -i.currentTranslate),
          n.cssMode)
        )
          return;
        if (t.params.freeMode && n.freeMode.enabled)
          return void t.freeMode.onTouchEnd({ currentPos: c });
        let p = 0,
          h = t.slidesSizesGrid[0];
        for (
          let e = 0;
          e < a.length;
          e += e < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup
        ) {
          const t = e < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
          void 0 !== a[e + t]
            ? c >= a[e] && c < a[e + t] && ((p = e), (h = a[e + t] - a[e]))
            : c >= a[e] && ((p = e), (h = a[a.length - 1] - a[a.length - 2]));
        }
        let f = null,
          m = null;
        n.rewind &&
          (t.isBeginning
            ? (m =
                t.params.virtual && t.params.virtual.enabled && t.virtual
                  ? t.virtual.slides.length - 1
                  : t.slides.length - 1)
            : t.isEnd && (f = 0));
        const g = (c - a[p]) / h,
          _ = p < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
        if (u > n.longSwipesMs) {
          if (!n.longSwipes) return void t.slideTo(t.activeIndex);
          "next" === t.swipeDirection &&
            (g >= n.longSwipesRatio
              ? t.slideTo(n.rewind && t.isEnd ? f : p + _)
              : t.slideTo(p)),
            "prev" === t.swipeDirection &&
              (g > 1 - n.longSwipesRatio
                ? t.slideTo(p + _)
                : null !== m && g < 0 && Math.abs(g) > n.longSwipesRatio
                ? t.slideTo(m)
                : t.slideTo(p));
        } else {
          if (!n.shortSwipes) return void t.slideTo(t.activeIndex);
          !t.navigation ||
          (l.target !== t.navigation.nextEl && l.target !== t.navigation.prevEl)
            ? ("next" === t.swipeDirection && t.slideTo(null !== f ? f : p + _),
              "prev" === t.swipeDirection && t.slideTo(null !== m ? m : p))
            : l.target === t.navigation.nextEl
            ? t.slideTo(p + _)
            : t.slideTo(p);
        }
      }
      function I() {
        const e = this,
          { params: t, el: i } = e;
        if (i && 0 === i.offsetWidth) return;
        t.breakpoints && e.setBreakpoint();
        const { allowSlideNext: n, allowSlidePrev: s, snapGrid: r } = e;
        (e.allowSlideNext = !0),
          (e.allowSlidePrev = !0),
          e.updateSize(),
          e.updateSlides(),
          e.updateSlidesClasses(),
          ("auto" === t.slidesPerView || t.slidesPerView > 1) &&
          e.isEnd &&
          !e.isBeginning &&
          !e.params.centeredSlides
            ? e.slideTo(e.slides.length - 1, 0, !1, !0)
            : e.slideTo(e.activeIndex, 0, !1, !0),
          e.autoplay &&
            e.autoplay.running &&
            e.autoplay.paused &&
            e.autoplay.run(),
          (e.allowSlidePrev = s),
          (e.allowSlideNext = n),
          e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
      }
      function B(e) {
        const t = this;
        t.enabled &&
          (t.allowClick ||
            (t.params.preventClicks && e.preventDefault(),
            t.params.preventClicksPropagation &&
              t.animating &&
              (e.stopPropagation(), e.stopImmediatePropagation())));
      }
      function N() {
        const e = this,
          { wrapperEl: t, rtlTranslate: i, enabled: n } = e;
        if (!n) return;
        let s;
        (e.previousTranslate = e.translate),
          e.isHorizontal()
            ? (e.translate = -t.scrollLeft)
            : (e.translate = -t.scrollTop),
          0 === e.translate && (e.translate = 0),
          e.updateActiveIndex(),
          e.updateSlidesClasses();
        const r = e.maxTranslate() - e.minTranslate();
        (s = 0 === r ? 0 : (e.translate - e.minTranslate()) / r),
          s !== e.progress && e.updateProgress(i ? -e.translate : e.translate),
          e.emit("setTranslate", e.translate, !1);
      }
      let R = !1;
      function F() {}
      const j = (e, t) => {
        const i = a(),
          {
            params: n,
            touchEvents: s,
            el: r,
            wrapperEl: o,
            device: l,
            support: d,
          } = e,
          u = !!n.nested,
          c = "on" === t ? "addEventListener" : "removeEventListener",
          p = t;
        if (d.touch) {
          const t = !(
            "touchstart" !== s.start ||
            !d.passiveListener ||
            !n.passiveListeners
          ) && { passive: !0, capture: !1 };
          r[c](s.start, e.onTouchStart, t),
            r[c](
              s.move,
              e.onTouchMove,
              d.passiveListener ? { passive: !1, capture: u } : u
            ),
            r[c](s.end, e.onTouchEnd, t),
            s.cancel && r[c](s.cancel, e.onTouchEnd, t);
        } else
          r[c](s.start, e.onTouchStart, !1),
            i[c](s.move, e.onTouchMove, u),
            i[c](s.end, e.onTouchEnd, !1);
        (n.preventClicks || n.preventClicksPropagation) &&
          r[c]("click", e.onClick, !0),
          n.cssMode && o[c]("scroll", e.onScroll),
          n.updateOnWindowResize
            ? e[p](
                l.ios || l.android
                  ? "resize orientationchange observerUpdate"
                  : "resize observerUpdate",
                I,
                !0
              )
            : e[p]("observerUpdate", I, !0);
      };
      var G = {
        attachEvents: function () {
          const e = this,
            t = a(),
            { params: i, support: n } = e;
          (e.onTouchStart = A.bind(e)),
            (e.onTouchMove = z.bind(e)),
            (e.onTouchEnd = D.bind(e)),
            i.cssMode && (e.onScroll = N.bind(e)),
            (e.onClick = B.bind(e)),
            n.touch && !R && (t.addEventListener("touchstart", F), (R = !0)),
            j(e, "on");
        },
        detachEvents: function () {
          j(this, "off");
        },
      };
      const H = (e, t) => e.grid && t.grid && t.grid.rows > 1;
      var q = {
          addClasses: function () {
            const e = this,
              {
                classNames: t,
                params: i,
                rtl: n,
                $el: s,
                device: r,
                support: a,
              } = e,
              o = (function (e, t) {
                const i = [];
                return (
                  e.forEach((e) => {
                    "object" == typeof e
                      ? Object.keys(e).forEach((n) => {
                          e[n] && i.push(t + n);
                        })
                      : "string" == typeof e && i.push(t + e);
                  }),
                  i
                );
              })(
                [
                  "initialized",
                  i.direction,
                  { "pointer-events": !a.touch },
                  { "free-mode": e.params.freeMode && i.freeMode.enabled },
                  { autoheight: i.autoHeight },
                  { rtl: n },
                  { grid: i.grid && i.grid.rows > 1 },
                  {
                    "grid-column":
                      i.grid && i.grid.rows > 1 && "column" === i.grid.fill,
                  },
                  { android: r.android },
                  { ios: r.ios },
                  { "css-mode": i.cssMode },
                  { centered: i.cssMode && i.centeredSlides },
                  { "watch-progress": i.watchSlidesProgress },
                ],
                i.containerModifierClass
              );
            t.push(...o),
              s.addClass([...t].join(" ")),
              e.emitContainerClasses();
          },
          removeClasses: function () {
            const { $el: e, classNames: t } = this;
            e.removeClass(t.join(" ")), this.emitContainerClasses();
          },
        },
        V = {
          init: !0,
          direction: "horizontal",
          touchEventsTarget: "wrapper",
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          enabled: !0,
          focusableElements:
            "input, select, option, textarea, button, video, label",
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: "slide",
          breakpoints: void 0,
          breakpointsBase: "window",
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 0,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          preloadImages: !0,
          updateOnImagesReady: !0,
          loop: !1,
          loopAdditionalSlides: 0,
          loopedSlides: null,
          loopedSlidesLimit: !0,
          loopFillGroupWithBlank: !1,
          loopPreventsSlide: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: "swiper-no-swiping",
          noSwipingSelector: null,
          passiveListeners: !0,
          maxBackfaceHiddenSlides: 10,
          containerModifierClass: "swiper-",
          slideClass: "swiper-slide",
          slideBlankClass: "swiper-slide-invisible-blank",
          slideActiveClass: "swiper-slide-active",
          slideDuplicateActiveClass: "swiper-slide-duplicate-active",
          slideVisibleClass: "swiper-slide-visible",
          slideDuplicateClass: "swiper-slide-duplicate",
          slideNextClass: "swiper-slide-next",
          slideDuplicateNextClass: "swiper-slide-duplicate-next",
          slidePrevClass: "swiper-slide-prev",
          slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
          wrapperClass: "swiper-wrapper",
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function W(e, t) {
        return function (i) {
          void 0 === i && (i = {});
          const n = Object.keys(i)[0],
            s = i[n];
          "object" == typeof s && null !== s
            ? (["navigation", "pagination", "scrollbar"].indexOf(n) >= 0 &&
                !0 === e[n] &&
                (e[n] = { auto: !0 }),
              n in e && "enabled" in s
                ? (!0 === e[n] && (e[n] = { enabled: !0 }),
                  "object" != typeof e[n] ||
                    "enabled" in e[n] ||
                    (e[n].enabled = !0),
                  e[n] || (e[n] = { enabled: !1 }),
                  w(t, i))
                : w(t, i))
            : w(t, i);
        };
      }
      const Y = {
          eventsEmitter: k,
          update: O,
          translate: P,
          transition: {
            setTransition: function (e, t) {
              const i = this;
              i.params.cssMode || i.$wrapperEl.transition(e),
                i.emit("setTransition", e, t);
            },
            transitionStart: function (e, t) {
              void 0 === e && (e = !0);
              const i = this,
                { params: n } = i;
              n.cssMode ||
                (n.autoHeight && i.updateAutoHeight(),
                (0, L.Z)({
                  swiper: i,
                  runCallbacks: e,
                  direction: t,
                  step: "Start",
                }));
            },
            transitionEnd: function (e, t) {
              void 0 === e && (e = !0);
              const i = this,
                { params: n } = i;
              (i.animating = !1),
                n.cssMode ||
                  (i.setTransition(0),
                  (0, L.Z)({
                    swiper: i,
                    runCallbacks: e,
                    direction: t,
                    step: "End",
                  }));
            },
          },
          slide: $,
          loop: {
            loopCreate: function () {
              const e = this,
                t = a(),
                { params: i, $wrapperEl: n } = e,
                s = n.children().length > 0 ? g(n.children()[0].parentNode) : n;
              s.children(`.${i.slideClass}.${i.slideDuplicateClass}`).remove();
              let r = s.children(`.${i.slideClass}`);
              if (i.loopFillGroupWithBlank) {
                const e = i.slidesPerGroup - (r.length % i.slidesPerGroup);
                if (e !== i.slidesPerGroup) {
                  for (let n = 0; n < e; n += 1) {
                    const e = g(t.createElement("div")).addClass(
                      `${i.slideClass} ${i.slideBlankClass}`
                    );
                    s.append(e);
                  }
                  r = s.children(`.${i.slideClass}`);
                }
              }
              "auto" !== i.slidesPerView ||
                i.loopedSlides ||
                (i.loopedSlides = r.length),
                (e.loopedSlides = Math.ceil(
                  parseFloat(i.loopedSlides || i.slidesPerView, 10)
                )),
                (e.loopedSlides += i.loopAdditionalSlides),
                e.loopedSlides > r.length &&
                  e.params.loopedSlidesLimit &&
                  (e.loopedSlides = r.length);
              const o = [],
                l = [];
              r.each((e, t) => {
                g(e).attr("data-swiper-slide-index", t);
              });
              for (let t = 0; t < e.loopedSlides; t += 1) {
                const e = t - Math.floor(t / r.length) * r.length;
                l.push(r.eq(e)[0]), o.unshift(r.eq(r.length - e - 1)[0]);
              }
              for (let e = 0; e < l.length; e += 1)
                s.append(g(l[e].cloneNode(!0)).addClass(i.slideDuplicateClass));
              for (let e = o.length - 1; e >= 0; e -= 1)
                s.prepend(
                  g(o[e].cloneNode(!0)).addClass(i.slideDuplicateClass)
                );
            },
            loopFix: function () {
              const e = this;
              e.emit("beforeLoopFix");
              const {
                activeIndex: t,
                slides: i,
                loopedSlides: n,
                allowSlidePrev: s,
                allowSlideNext: r,
                snapGrid: a,
                rtlTranslate: o,
              } = e;
              let l;
              (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
              const d = -a[t] - e.getTranslate();
              t < n
                ? ((l = i.length - 3 * n + t),
                  (l += n),
                  e.slideTo(l, 0, !1, !0) &&
                    0 !== d &&
                    e.setTranslate((o ? -e.translate : e.translate) - d))
                : t >= i.length - n &&
                  ((l = -i.length + t + n),
                  (l += n),
                  e.slideTo(l, 0, !1, !0) &&
                    0 !== d &&
                    e.setTranslate((o ? -e.translate : e.translate) - d)),
                (e.allowSlidePrev = s),
                (e.allowSlideNext = r),
                e.emit("loopFix");
            },
            loopDestroy: function () {
              const { $wrapperEl: e, params: t, slides: i } = this;
              e
                .children(
                  `.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`
                )
                .remove(),
                i.removeAttr("data-swiper-slide-index");
            },
          },
          grabCursor: {
            setGrabCursor: function (e) {
              const t = this;
              if (
                t.support.touch ||
                !t.params.simulateTouch ||
                (t.params.watchOverflow && t.isLocked) ||
                t.params.cssMode
              )
                return;
              const i =
                "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
              (i.style.cursor = "move"),
                (i.style.cursor = e ? "grabbing" : "grab");
            },
            unsetGrabCursor: function () {
              const e = this;
              e.support.touch ||
                (e.params.watchOverflow && e.isLocked) ||
                e.params.cssMode ||
                (e[
                  "container" === e.params.touchEventsTarget
                    ? "el"
                    : "wrapperEl"
                ].style.cursor = "");
            },
          },
          events: G,
          breakpoints: {
            setBreakpoint: function () {
              const e = this,
                {
                  activeIndex: t,
                  initialized: i,
                  loopedSlides: n = 0,
                  params: s,
                  $el: r,
                } = e,
                a = s.breakpoints;
              if (!a || (a && 0 === Object.keys(a).length)) return;
              const o = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
              if (!o || e.currentBreakpoint === o) return;
              const l = (o in a ? a[o] : void 0) || e.originalParams,
                d = H(e, s),
                u = H(e, l),
                c = s.enabled;
              d && !u
                ? (r.removeClass(
                    `${s.containerModifierClass}grid ${s.containerModifierClass}grid-column`
                  ),
                  e.emitContainerClasses())
                : !d &&
                  u &&
                  (r.addClass(`${s.containerModifierClass}grid`),
                  ((l.grid.fill && "column" === l.grid.fill) ||
                    (!l.grid.fill && "column" === s.grid.fill)) &&
                    r.addClass(`${s.containerModifierClass}grid-column`),
                  e.emitContainerClasses()),
                ["navigation", "pagination", "scrollbar"].forEach((t) => {
                  const i = s[t] && s[t].enabled,
                    n = l[t] && l[t].enabled;
                  i && !n && e[t].disable(), !i && n && e[t].enable();
                });
              const p = l.direction && l.direction !== s.direction,
                h = s.loop && (l.slidesPerView !== s.slidesPerView || p);
              p && i && e.changeDirection(), w(e.params, l);
              const f = e.params.enabled;
              Object.assign(e, {
                allowTouchMove: e.params.allowTouchMove,
                allowSlideNext: e.params.allowSlideNext,
                allowSlidePrev: e.params.allowSlidePrev,
              }),
                c && !f ? e.disable() : !c && f && e.enable(),
                (e.currentBreakpoint = o),
                e.emit("_beforeBreakpoint", l),
                h &&
                  i &&
                  (e.loopDestroy(),
                  e.loopCreate(),
                  e.updateSlides(),
                  e.slideTo(t - n + e.loopedSlides, 0, !1)),
                e.emit("breakpoint", l);
            },
            getBreakpoint: function (e, t, i) {
              if (
                (void 0 === t && (t = "window"),
                !e || ("container" === t && !i))
              )
                return;
              let n = !1;
              const s = l(),
                r = "window" === t ? s.innerHeight : i.clientHeight,
                a = Object.keys(e).map((e) => {
                  if ("string" == typeof e && 0 === e.indexOf("@")) {
                    const t = parseFloat(e.substr(1));
                    return { value: r * t, point: e };
                  }
                  return { value: e, point: e };
                });
              a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
              for (let e = 0; e < a.length; e += 1) {
                const { point: r, value: o } = a[e];
                "window" === t
                  ? s.matchMedia(`(min-width: ${o}px)`).matches && (n = r)
                  : o <= i.clientWidth && (n = r);
              }
              return n || "max";
            },
          },
          checkOverflow: {
            checkOverflow: function () {
              const e = this,
                { isLocked: t, params: i } = e,
                { slidesOffsetBefore: n } = i;
              if (n) {
                const t = e.slides.length - 1,
                  i = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * n;
                e.isLocked = e.size > i;
              } else e.isLocked = 1 === e.snapGrid.length;
              !0 === i.allowSlideNext && (e.allowSlideNext = !e.isLocked),
                !0 === i.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
                t && t !== e.isLocked && (e.isEnd = !1),
                t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
            },
          },
          classes: q,
          images: {
            loadImage: function (e, t, i, n, s, r) {
              const a = l();
              let o;
              function d() {
                r && r();
              }
              g(e).parent("picture")[0] || (e.complete && s)
                ? d()
                : t
                ? ((o = new a.Image()),
                  (o.onload = d),
                  (o.onerror = d),
                  n && (o.sizes = n),
                  i && (o.srcset = i),
                  t && (o.src = t))
                : d();
            },
            preloadImages: function () {
              const e = this;
              function t() {
                null != e &&
                  e &&
                  !e.destroyed &&
                  (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                  e.imagesLoaded === e.imagesToLoad.length &&
                    (e.params.updateOnImagesReady && e.update(),
                    e.emit("imagesReady")));
              }
              e.imagesToLoad = e.$el.find("img");
              for (let i = 0; i < e.imagesToLoad.length; i += 1) {
                const n = e.imagesToLoad[i];
                e.loadImage(
                  n,
                  n.currentSrc || n.getAttribute("src"),
                  n.srcset || n.getAttribute("srcset"),
                  n.sizes || n.getAttribute("sizes"),
                  !0,
                  t
                );
              }
            },
          },
        },
        X = {};
      class U {
        constructor() {
          let e, t;
          for (var i = arguments.length, n = new Array(i), s = 0; s < i; s++)
            n[s] = arguments[s];
          if (
            (1 === n.length &&
            n[0].constructor &&
            "Object" === Object.prototype.toString.call(n[0]).slice(8, -1)
              ? (t = n[0])
              : ([e, t] = n),
            t || (t = {}),
            (t = w({}, t)),
            e && !t.el && (t.el = e),
            t.el && g(t.el).length > 1)
          ) {
            const e = [];
            return (
              g(t.el).each((i) => {
                const n = w({}, t, { el: i });
                e.push(new U(n));
              }),
              e
            );
          }
          const r = this;
          var a;
          (r.__swiper__ = !0),
            (r.support = M()),
            (r.device =
              (void 0 === (a = { userAgent: t.userAgent }) && (a = {}),
              S ||
                (S = (function (e) {
                  let { userAgent: t } = void 0 === e ? {} : e;
                  const i = M(),
                    n = l(),
                    s = n.navigator.platform,
                    r = t || n.navigator.userAgent,
                    a = { ios: !1, android: !1 },
                    o = n.screen.width,
                    d = n.screen.height,
                    u = r.match(/(Android);?[\s\/]+([\d.]+)?/);
                  let c = r.match(/(iPad).*OS\s([\d_]+)/);
                  const p = r.match(/(iPod)(.*OS\s([\d_]+))?/),
                    h = !c && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                    f = "Win32" === s;
                  let m = "MacIntel" === s;
                  return (
                    !c &&
                      m &&
                      i.touch &&
                      [
                        "1024x1366",
                        "1366x1024",
                        "834x1194",
                        "1194x834",
                        "834x1112",
                        "1112x834",
                        "768x1024",
                        "1024x768",
                        "820x1180",
                        "1180x820",
                        "810x1080",
                        "1080x810",
                      ].indexOf(`${o}x${d}`) >= 0 &&
                      ((c = r.match(/(Version)\/([\d.]+)/)),
                      c || (c = [0, 1, "13_0_0"]),
                      (m = !1)),
                    u && !f && ((a.os = "android"), (a.android = !0)),
                    (c || h || p) && ((a.os = "ios"), (a.ios = !0)),
                    a
                  );
                })(a)),
              S)),
            (r.browser =
              (E ||
                (E = (function () {
                  const e = l();
                  return {
                    isSafari: (function () {
                      const t = e.navigator.userAgent.toLowerCase();
                      return (
                        t.indexOf("safari") >= 0 &&
                        t.indexOf("chrome") < 0 &&
                        t.indexOf("android") < 0
                      );
                    })(),
                    isWebView:
                      /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                        e.navigator.userAgent
                      ),
                  };
                })()),
              E)),
            (r.eventsListeners = {}),
            (r.eventsAnyListeners = []),
            (r.modules = [...r.__modules__]),
            t.modules &&
              Array.isArray(t.modules) &&
              r.modules.push(...t.modules);
          const o = {};
          r.modules.forEach((e) => {
            e({
              swiper: r,
              extendParams: W(t, o),
              on: r.on.bind(r),
              once: r.once.bind(r),
              off: r.off.bind(r),
              emit: r.emit.bind(r),
            });
          });
          const d = w({}, V, o);
          return (
            (r.params = w({}, d, X, t)),
            (r.originalParams = w({}, r.params)),
            (r.passedParams = w({}, t)),
            r.params &&
              r.params.on &&
              Object.keys(r.params.on).forEach((e) => {
                r.on(e, r.params.on[e]);
              }),
            r.params && r.params.onAny && r.onAny(r.params.onAny),
            (r.$ = g),
            Object.assign(r, {
              enabled: r.params.enabled,
              el: e,
              classNames: [],
              slides: g(),
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal() {
                return "horizontal" === r.params.direction;
              },
              isVertical() {
                return "vertical" === r.params.direction;
              },
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              allowSlideNext: r.params.allowSlideNext,
              allowSlidePrev: r.params.allowSlidePrev,
              touchEvents: (function () {
                const e = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel",
                  ],
                  t = ["pointerdown", "pointermove", "pointerup"];
                return (
                  (r.touchEventsTouch = {
                    start: e[0],
                    move: e[1],
                    end: e[2],
                    cancel: e[3],
                  }),
                  (r.touchEventsDesktop = {
                    start: t[0],
                    move: t[1],
                    end: t[2],
                  }),
                  r.support.touch || !r.params.simulateTouch
                    ? r.touchEventsTouch
                    : r.touchEventsDesktop
                );
              })(),
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: r.params.focusableElements,
                lastClickTime: y(),
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                isTouchEvent: void 0,
                startMoving: void 0,
              },
              allowClick: !0,
              allowTouchMove: r.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            r.emit("_swiper"),
            r.params.init && r.init(),
            r
          );
        }
        enable() {
          const e = this;
          e.enabled ||
            ((e.enabled = !0),
            e.params.grabCursor && e.setGrabCursor(),
            e.emit("enable"));
        }
        disable() {
          const e = this;
          e.enabled &&
            ((e.enabled = !1),
            e.params.grabCursor && e.unsetGrabCursor(),
            e.emit("disable"));
        }
        setProgress(e, t) {
          const i = this;
          e = Math.min(Math.max(e, 0), 1);
          const n = i.minTranslate(),
            s = (i.maxTranslate() - n) * e + n;
          i.translateTo(s, void 0 === t ? 0 : t),
            i.updateActiveIndex(),
            i.updateSlidesClasses();
        }
        emitContainerClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = e.el.className
            .split(" ")
            .filter(
              (t) =>
                0 === t.indexOf("swiper") ||
                0 === t.indexOf(e.params.containerModifierClass)
            );
          e.emit("_containerClasses", t.join(" "));
        }
        getSlideClasses(e) {
          const t = this;
          return t.destroyed
            ? ""
            : e.className
                .split(" ")
                .filter(
                  (e) =>
                    0 === e.indexOf("swiper-slide") ||
                    0 === e.indexOf(t.params.slideClass)
                )
                .join(" ");
        }
        emitSlidesClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = [];
          e.slides.each((i) => {
            const n = e.getSlideClasses(i);
            t.push({ slideEl: i, classNames: n }), e.emit("_slideClass", i, n);
          }),
            e.emit("_slideClasses", t);
        }
        slidesPerViewDynamic(e, t) {
          void 0 === e && (e = "current"), void 0 === t && (t = !1);
          const {
            params: i,
            slides: n,
            slidesGrid: s,
            slidesSizesGrid: r,
            size: a,
            activeIndex: o,
          } = this;
          let l = 1;
          if (i.centeredSlides) {
            let e,
              t = n[o].swiperSlideSize;
            for (let i = o + 1; i < n.length; i += 1)
              n[i] &&
                !e &&
                ((t += n[i].swiperSlideSize), (l += 1), t > a && (e = !0));
            for (let i = o - 1; i >= 0; i -= 1)
              n[i] &&
                !e &&
                ((t += n[i].swiperSlideSize), (l += 1), t > a && (e = !0));
          } else if ("current" === e)
            for (let e = o + 1; e < n.length; e += 1)
              (t ? s[e] + r[e] - s[o] < a : s[e] - s[o] < a) && (l += 1);
          else for (let e = o - 1; e >= 0; e -= 1) s[o] - s[e] < a && (l += 1);
          return l;
        }
        update() {
          const e = this;
          if (!e || e.destroyed) return;
          const { snapGrid: t, params: i } = e;
          function n() {
            const t = e.rtlTranslate ? -1 * e.translate : e.translate,
              i = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            e.setTranslate(i), e.updateActiveIndex(), e.updateSlidesClasses();
          }
          let s;
          i.breakpoints && e.setBreakpoint(),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            e.params.freeMode && e.params.freeMode.enabled
              ? (n(), e.params.autoHeight && e.updateAutoHeight())
              : ((s =
                  ("auto" === e.params.slidesPerView ||
                    e.params.slidesPerView > 1) &&
                  e.isEnd &&
                  !e.params.centeredSlides
                    ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                    : e.slideTo(e.activeIndex, 0, !1, !0)),
                s || n()),
            i.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
            e.emit("update");
        }
        changeDirection(e, t) {
          void 0 === t && (t = !0);
          const i = this,
            n = i.params.direction;
          return (
            e || (e = "horizontal" === n ? "vertical" : "horizontal"),
            e === n ||
              ("horizontal" !== e && "vertical" !== e) ||
              (i.$el
                .removeClass(`${i.params.containerModifierClass}${n}`)
                .addClass(`${i.params.containerModifierClass}${e}`),
              i.emitContainerClasses(),
              (i.params.direction = e),
              i.slides.each((t) => {
                "vertical" === e ? (t.style.width = "") : (t.style.height = "");
              }),
              i.emit("changeDirection"),
              t && i.update()),
            i
          );
        }
        changeLanguageDirection(e) {
          const t = this;
          (t.rtl && "rtl" === e) ||
            (!t.rtl && "ltr" === e) ||
            ((t.rtl = "rtl" === e),
            (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
            t.rtl
              ? (t.$el.addClass(`${t.params.containerModifierClass}rtl`),
                (t.el.dir = "rtl"))
              : (t.$el.removeClass(`${t.params.containerModifierClass}rtl`),
                (t.el.dir = "ltr")),
            t.update());
        }
        mount(e) {
          const t = this;
          if (t.mounted) return !0;
          const i = g(e || t.params.el);
          if (!(e = i[0])) return !1;
          e.swiper = t;
          const n = () =>
            `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
          let s = (() => {
            if (e && e.shadowRoot && e.shadowRoot.querySelector) {
              const t = g(e.shadowRoot.querySelector(n()));
              return (t.children = (e) => i.children(e)), t;
            }
            return i.children ? i.children(n()) : g(i).children(n());
          })();
          if (0 === s.length && t.params.createElements) {
            const e = a().createElement("div");
            (s = g(e)),
              (e.className = t.params.wrapperClass),
              i.append(e),
              i.children(`.${t.params.slideClass}`).each((e) => {
                s.append(e);
              });
          }
          return (
            Object.assign(t, {
              $el: i,
              el: e,
              $wrapperEl: s,
              wrapperEl: s[0],
              mounted: !0,
              rtl:
                "rtl" === e.dir.toLowerCase() || "rtl" === i.css("direction"),
              rtlTranslate:
                "horizontal" === t.params.direction &&
                ("rtl" === e.dir.toLowerCase() || "rtl" === i.css("direction")),
              wrongRTL: "-webkit-box" === s.css("display"),
            }),
            !0
          );
        }
        init(e) {
          const t = this;
          return (
            t.initialized ||
              !1 === t.mount(e) ||
              (t.emit("beforeInit"),
              t.params.breakpoints && t.setBreakpoint(),
              t.addClasses(),
              t.params.loop && t.loopCreate(),
              t.updateSize(),
              t.updateSlides(),
              t.params.watchOverflow && t.checkOverflow(),
              t.params.grabCursor && t.enabled && t.setGrabCursor(),
              t.params.preloadImages && t.preloadImages(),
              t.params.loop
                ? t.slideTo(
                    t.params.initialSlide + t.loopedSlides,
                    0,
                    t.params.runCallbacksOnInit,
                    !1,
                    !0
                  )
                : t.slideTo(
                    t.params.initialSlide,
                    0,
                    t.params.runCallbacksOnInit,
                    !1,
                    !0
                  ),
              t.attachEvents(),
              (t.initialized = !0),
              t.emit("init"),
              t.emit("afterInit")),
            t
          );
        }
        destroy(e, t) {
          void 0 === e && (e = !0), void 0 === t && (t = !0);
          const i = this,
            { params: n, $el: s, $wrapperEl: r, slides: a } = i;
          return (
            void 0 === i.params ||
              i.destroyed ||
              (i.emit("beforeDestroy"),
              (i.initialized = !1),
              i.detachEvents(),
              n.loop && i.loopDestroy(),
              t &&
                (i.removeClasses(),
                s.removeAttr("style"),
                r.removeAttr("style"),
                a &&
                  a.length &&
                  a
                    .removeClass(
                      [
                        n.slideVisibleClass,
                        n.slideActiveClass,
                        n.slideNextClass,
                        n.slidePrevClass,
                      ].join(" ")
                    )
                    .removeAttr("style")
                    .removeAttr("data-swiper-slide-index")),
              i.emit("destroy"),
              Object.keys(i.eventsListeners).forEach((e) => {
                i.off(e);
              }),
              !1 !== e &&
                ((i.$el[0].swiper = null),
                (function (e) {
                  const t = e;
                  Object.keys(t).forEach((e) => {
                    try {
                      t[e] = null;
                    } catch (e) {}
                    try {
                      delete t[e];
                    } catch (e) {}
                  });
                })(i)),
              (i.destroyed = !0)),
            null
          );
        }
        static extendDefaults(e) {
          w(X, e);
        }
        static get extendedDefaults() {
          return X;
        }
        static get defaults() {
          return V;
        }
        static installModule(e) {
          U.prototype.__modules__ || (U.prototype.__modules__ = []);
          const t = U.prototype.__modules__;
          "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
        }
        static use(e) {
          return Array.isArray(e)
            ? (e.forEach((e) => U.installModule(e)), U)
            : (U.installModule(e), U);
        }
      }
      Object.keys(Y).forEach((e) => {
        Object.keys(Y[e]).forEach((t) => {
          U.prototype[t] = Y[e][t];
        });
      }),
        U.use([
          function (e) {
            let { swiper: t, on: i, emit: n } = e;
            const s = l();
            let r = null,
              a = null;
            const o = () => {
                t &&
                  !t.destroyed &&
                  t.initialized &&
                  (n("beforeResize"), n("resize"));
              },
              d = () => {
                t && !t.destroyed && t.initialized && n("orientationchange");
              };
            i("init", () => {
              t.params.resizeObserver && void 0 !== s.ResizeObserver
                ? t &&
                  !t.destroyed &&
                  t.initialized &&
                  ((r = new ResizeObserver((e) => {
                    a = s.requestAnimationFrame(() => {
                      const { width: i, height: n } = t;
                      let s = i,
                        r = n;
                      e.forEach((e) => {
                        let {
                          contentBoxSize: i,
                          contentRect: n,
                          target: a,
                        } = e;
                        (a && a !== t.el) ||
                          ((s = n ? n.width : (i[0] || i).inlineSize),
                          (r = n ? n.height : (i[0] || i).blockSize));
                      }),
                        (s === i && r === n) || o();
                    });
                  })),
                  r.observe(t.el))
                : (s.addEventListener("resize", o),
                  s.addEventListener("orientationchange", d));
            }),
              i("destroy", () => {
                a && s.cancelAnimationFrame(a),
                  r && r.unobserve && t.el && (r.unobserve(t.el), (r = null)),
                  s.removeEventListener("resize", o),
                  s.removeEventListener("orientationchange", d);
              });
          },
          function (e) {
            let { swiper: t, extendParams: i, on: n, emit: s } = e;
            const r = [],
              a = l(),
              o = function (e, t) {
                void 0 === t && (t = {});
                const i = new (a.MutationObserver || a.WebkitMutationObserver)(
                  (e) => {
                    if (1 === e.length) return void s("observerUpdate", e[0]);
                    const t = function () {
                      s("observerUpdate", e[0]);
                    };
                    a.requestAnimationFrame
                      ? a.requestAnimationFrame(t)
                      : a.setTimeout(t, 0);
                  }
                );
                i.observe(e, {
                  attributes: void 0 === t.attributes || t.attributes,
                  childList: void 0 === t.childList || t.childList,
                  characterData: void 0 === t.characterData || t.characterData,
                }),
                  r.push(i);
              };
            i({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
              n("init", () => {
                if (t.params.observer) {
                  if (t.params.observeParents) {
                    const e = t.$el.parents();
                    for (let t = 0; t < e.length; t += 1) o(e[t]);
                  }
                  o(t.$el[0], { childList: t.params.observeSlideChildren }),
                    o(t.$wrapperEl[0], { attributes: !1 });
                }
              }),
              n("destroy", () => {
                r.forEach((e) => {
                  e.disconnect();
                }),
                  r.splice(0, r.length);
              });
          },
        ]);
      var Z = U;
      function Q(e, t, i, n) {
        const s = a();
        return (
          e.params.createElements &&
            Object.keys(n).forEach((r) => {
              if (!i[r] && !0 === i.auto) {
                let a = e.$el.children(`.${n[r]}`)[0];
                a ||
                  ((a = s.createElement("div")),
                  (a.className = n[r]),
                  e.$el.append(a)),
                  (i[r] = a),
                  (t[r] = a);
              }
            }),
          i
        );
      }
      function K(e) {
        let { swiper: t, extendParams: i, on: n, emit: s } = e;
        function r(e) {
          let i;
          return (
            e &&
              ((i = g(e)),
              t.params.uniqueNavElements &&
                "string" == typeof e &&
                i.length > 1 &&
                1 === t.$el.find(e).length &&
                (i = t.$el.find(e))),
            i
          );
        }
        function a(e, i) {
          const n = t.params.navigation;
          e &&
            e.length > 0 &&
            (e[i ? "addClass" : "removeClass"](n.disabledClass),
            e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = i),
            t.params.watchOverflow &&
              t.enabled &&
              e[t.isLocked ? "addClass" : "removeClass"](n.lockClass));
        }
        function o() {
          if (t.params.loop) return;
          const { $nextEl: e, $prevEl: i } = t.navigation;
          a(i, t.isBeginning && !t.params.rewind),
            a(e, t.isEnd && !t.params.rewind);
        }
        function l(e) {
          e.preventDefault(),
            (!t.isBeginning || t.params.loop || t.params.rewind) &&
              (t.slidePrev(), s("navigationPrev"));
        }
        function d(e) {
          e.preventDefault(),
            (!t.isEnd || t.params.loop || t.params.rewind) &&
              (t.slideNext(), s("navigationNext"));
        }
        function u() {
          const e = t.params.navigation;
          if (
            ((t.params.navigation = Q(
              t,
              t.originalParams.navigation,
              t.params.navigation,
              { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }
            )),
            !e.nextEl && !e.prevEl)
          )
            return;
          const i = r(e.nextEl),
            n = r(e.prevEl);
          i && i.length > 0 && i.on("click", d),
            n && n.length > 0 && n.on("click", l),
            Object.assign(t.navigation, {
              $nextEl: i,
              nextEl: i && i[0],
              $prevEl: n,
              prevEl: n && n[0],
            }),
            t.enabled ||
              (i && i.addClass(e.lockClass), n && n.addClass(e.lockClass));
        }
        function c() {
          const { $nextEl: e, $prevEl: i } = t.navigation;
          e &&
            e.length &&
            (e.off("click", d),
            e.removeClass(t.params.navigation.disabledClass)),
            i &&
              i.length &&
              (i.off("click", l),
              i.removeClass(t.params.navigation.disabledClass));
        }
        i({
          navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled",
          },
        }),
          (t.navigation = {
            nextEl: null,
            $nextEl: null,
            prevEl: null,
            $prevEl: null,
          }),
          n("init", () => {
            !1 === t.params.navigation.enabled ? p() : (u(), o());
          }),
          n("toEdge fromEdge lock unlock", () => {
            o();
          }),
          n("destroy", () => {
            c();
          }),
          n("enable disable", () => {
            const { $nextEl: e, $prevEl: i } = t.navigation;
            e &&
              e[t.enabled ? "removeClass" : "addClass"](
                t.params.navigation.lockClass
              ),
              i &&
                i[t.enabled ? "removeClass" : "addClass"](
                  t.params.navigation.lockClass
                );
          }),
          n("click", (e, i) => {
            const { $nextEl: n, $prevEl: r } = t.navigation,
              a = i.target;
            if (t.params.navigation.hideOnClick && !g(a).is(r) && !g(a).is(n)) {
              if (
                t.pagination &&
                t.params.pagination &&
                t.params.pagination.clickable &&
                (t.pagination.el === a || t.pagination.el.contains(a))
              )
                return;
              let e;
              n
                ? (e = n.hasClass(t.params.navigation.hiddenClass))
                : r && (e = r.hasClass(t.params.navigation.hiddenClass)),
                s(!0 === e ? "navigationShow" : "navigationHide"),
                n && n.toggleClass(t.params.navigation.hiddenClass),
                r && r.toggleClass(t.params.navigation.hiddenClass);
            }
          });
        const p = () => {
          t.$el.addClass(t.params.navigation.navigationDisabledClass), c();
        };
        Object.assign(t.navigation, {
          enable: () => {
            t.$el.removeClass(t.params.navigation.navigationDisabledClass),
              u(),
              o();
          },
          disable: p,
          update: o,
          init: u,
          destroy: c,
        });
      }
      if (47 != i.j) var J = i(3370);
      function ee(e) {
        let { swiper: t, extendParams: i, on: n, emit: s } = e;
        const r = "swiper-pagination";
        let a;
        i({
          pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: (e) => e,
            formatFractionTotal: (e) => e,
            bulletClass: `${r}-bullet`,
            bulletActiveClass: `${r}-bullet-active`,
            modifierClass: `${r}-`,
            currentClass: `${r}-current`,
            totalClass: `${r}-total`,
            hiddenClass: `${r}-hidden`,
            progressbarFillClass: `${r}-progressbar-fill`,
            progressbarOppositeClass: `${r}-progressbar-opposite`,
            clickableClass: `${r}-clickable`,
            lockClass: `${r}-lock`,
            horizontalClass: `${r}-horizontal`,
            verticalClass: `${r}-vertical`,
            paginationDisabledClass: `${r}-disabled`,
          },
        }),
          (t.pagination = { el: null, $el: null, bullets: [] });
        let o = 0;
        function l() {
          return (
            !t.params.pagination.el ||
            !t.pagination.el ||
            !t.pagination.$el ||
            0 === t.pagination.$el.length
          );
        }
        function d(e, i) {
          const { bulletActiveClass: n } = t.params.pagination;
          e[i]().addClass(`${n}-${i}`)[i]().addClass(`${n}-${i}-${i}`);
        }
        function u() {
          const e = t.rtl,
            i = t.params.pagination;
          if (l()) return;
          const n =
              t.virtual && t.params.virtual.enabled
                ? t.virtual.slides.length
                : t.slides.length,
            r = t.pagination.$el;
          let u;
          const c = t.params.loop
            ? Math.ceil((n - 2 * t.loopedSlides) / t.params.slidesPerGroup)
            : t.snapGrid.length;
          if (
            (t.params.loop
              ? ((u = Math.ceil(
                  (t.activeIndex - t.loopedSlides) / t.params.slidesPerGroup
                )),
                u > n - 1 - 2 * t.loopedSlides && (u -= n - 2 * t.loopedSlides),
                u > c - 1 && (u -= c),
                u < 0 && "bullets" !== t.params.paginationType && (u = c + u))
              : (u = void 0 !== t.snapIndex ? t.snapIndex : t.activeIndex || 0),
            "bullets" === i.type &&
              t.pagination.bullets &&
              t.pagination.bullets.length > 0)
          ) {
            const n = t.pagination.bullets;
            let s, l, c;
            if (
              (i.dynamicBullets &&
                ((a = n
                  .eq(0)
                  [t.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                r.css(
                  t.isHorizontal() ? "width" : "height",
                  a * (i.dynamicMainBullets + 4) + "px"
                ),
                i.dynamicMainBullets > 1 &&
                  void 0 !== t.previousIndex &&
                  ((o += u - (t.previousIndex - t.loopedSlides || 0)),
                  o > i.dynamicMainBullets - 1
                    ? (o = i.dynamicMainBullets - 1)
                    : o < 0 && (o = 0)),
                (s = Math.max(u - o, 0)),
                (l = s + (Math.min(n.length, i.dynamicMainBullets) - 1)),
                (c = (l + s) / 2)),
              n.removeClass(
                ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
                  .map((e) => `${i.bulletActiveClass}${e}`)
                  .join(" ")
              ),
              r.length > 1)
            )
              n.each((e) => {
                const t = g(e),
                  n = t.index();
                n === u && t.addClass(i.bulletActiveClass),
                  i.dynamicBullets &&
                    (n >= s &&
                      n <= l &&
                      t.addClass(`${i.bulletActiveClass}-main`),
                    n === s && d(t, "prev"),
                    n === l && d(t, "next"));
              });
            else {
              const e = n.eq(u),
                r = e.index();
              if ((e.addClass(i.bulletActiveClass), i.dynamicBullets)) {
                const e = n.eq(s),
                  a = n.eq(l);
                for (let e = s; e <= l; e += 1)
                  n.eq(e).addClass(`${i.bulletActiveClass}-main`);
                if (t.params.loop)
                  if (r >= n.length) {
                    for (let e = i.dynamicMainBullets; e >= 0; e -= 1)
                      n.eq(n.length - e).addClass(
                        `${i.bulletActiveClass}-main`
                      );
                    n.eq(n.length - i.dynamicMainBullets - 1).addClass(
                      `${i.bulletActiveClass}-prev`
                    );
                  } else d(e, "prev"), d(a, "next");
                else d(e, "prev"), d(a, "next");
              }
            }
            if (i.dynamicBullets) {
              const s = Math.min(n.length, i.dynamicMainBullets + 4),
                r = (a * s - a) / 2 - c * a,
                o = e ? "right" : "left";
              n.css(t.isHorizontal() ? o : "top", `${r}px`);
            }
          }
          if (
            ("fraction" === i.type &&
              (r
                .find((0, J.Z)(i.currentClass))
                .text(i.formatFractionCurrent(u + 1)),
              r.find((0, J.Z)(i.totalClass)).text(i.formatFractionTotal(c))),
            "progressbar" === i.type)
          ) {
            let e;
            e = i.progressbarOpposite
              ? t.isHorizontal()
                ? "vertical"
                : "horizontal"
              : t.isHorizontal()
              ? "horizontal"
              : "vertical";
            const n = (u + 1) / c;
            let s = 1,
              a = 1;
            "horizontal" === e ? (s = n) : (a = n),
              r
                .find((0, J.Z)(i.progressbarFillClass))
                .transform(`translate3d(0,0,0) scaleX(${s}) scaleY(${a})`)
                .transition(t.params.speed);
          }
          "custom" === i.type && i.renderCustom
            ? (r.html(i.renderCustom(t, u + 1, c)), s("paginationRender", r[0]))
            : s("paginationUpdate", r[0]),
            t.params.watchOverflow &&
              t.enabled &&
              r[t.isLocked ? "addClass" : "removeClass"](i.lockClass);
        }
        function c() {
          const e = t.params.pagination;
          if (l()) return;
          const i =
              t.virtual && t.params.virtual.enabled
                ? t.virtual.slides.length
                : t.slides.length,
            n = t.pagination.$el;
          let r = "";
          if ("bullets" === e.type) {
            let s = t.params.loop
              ? Math.ceil((i - 2 * t.loopedSlides) / t.params.slidesPerGroup)
              : t.snapGrid.length;
            t.params.freeMode &&
              t.params.freeMode.enabled &&
              !t.params.loop &&
              s > i &&
              (s = i);
            for (let i = 0; i < s; i += 1)
              e.renderBullet
                ? (r += e.renderBullet.call(t, i, e.bulletClass))
                : (r += `<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`);
            n.html(r), (t.pagination.bullets = n.find((0, J.Z)(e.bulletClass)));
          }
          "fraction" === e.type &&
            ((r = e.renderFraction
              ? e.renderFraction.call(t, e.currentClass, e.totalClass)
              : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
            n.html(r)),
            "progressbar" === e.type &&
              ((r = e.renderProgressbar
                ? e.renderProgressbar.call(t, e.progressbarFillClass)
                : `<span class="${e.progressbarFillClass}"></span>`),
              n.html(r)),
            "custom" !== e.type && s("paginationRender", t.pagination.$el[0]);
        }
        function p() {
          t.params.pagination = Q(
            t,
            t.originalParams.pagination,
            t.params.pagination,
            { el: "swiper-pagination" }
          );
          const e = t.params.pagination;
          if (!e.el) return;
          let i = g(e.el);
          0 !== i.length &&
            (t.params.uniqueNavElements &&
              "string" == typeof e.el &&
              i.length > 1 &&
              ((i = t.$el.find(e.el)),
              i.length > 1 &&
                (i = i.filter((e) => g(e).parents(".swiper")[0] === t.el))),
            "bullets" === e.type && e.clickable && i.addClass(e.clickableClass),
            i.addClass(e.modifierClass + e.type),
            i.addClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass),
            "bullets" === e.type &&
              e.dynamicBullets &&
              (i.addClass(`${e.modifierClass}${e.type}-dynamic`),
              (o = 0),
              e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
            "progressbar" === e.type &&
              e.progressbarOpposite &&
              i.addClass(e.progressbarOppositeClass),
            e.clickable &&
              i.on("click", (0, J.Z)(e.bulletClass), function (e) {
                e.preventDefault();
                let i = g(this).index() * t.params.slidesPerGroup;
                t.params.loop && (i += t.loopedSlides), t.slideTo(i);
              }),
            Object.assign(t.pagination, { $el: i, el: i[0] }),
            t.enabled || i.addClass(e.lockClass));
        }
        function h() {
          const e = t.params.pagination;
          if (l()) return;
          const i = t.pagination.$el;
          i.removeClass(e.hiddenClass),
            i.removeClass(e.modifierClass + e.type),
            i.removeClass(
              t.isHorizontal() ? e.horizontalClass : e.verticalClass
            ),
            t.pagination.bullets &&
              t.pagination.bullets.removeClass &&
              t.pagination.bullets.removeClass(e.bulletActiveClass),
            e.clickable && i.off("click", (0, J.Z)(e.bulletClass));
        }
        n("init", () => {
          !1 === t.params.pagination.enabled ? f() : (p(), c(), u());
        }),
          n("activeIndexChange", () => {
            (t.params.loop || void 0 === t.snapIndex) && u();
          }),
          n("snapIndexChange", () => {
            t.params.loop || u();
          }),
          n("slidesLengthChange", () => {
            t.params.loop && (c(), u());
          }),
          n("snapGridLengthChange", () => {
            t.params.loop || (c(), u());
          }),
          n("destroy", () => {
            h();
          }),
          n("enable disable", () => {
            const { $el: e } = t.pagination;
            e &&
              e[t.enabled ? "removeClass" : "addClass"](
                t.params.pagination.lockClass
              );
          }),
          n("lock unlock", () => {
            u();
          }),
          n("click", (e, i) => {
            const n = i.target,
              { $el: r } = t.pagination;
            if (
              t.params.pagination.el &&
              t.params.pagination.hideOnClick &&
              r &&
              r.length > 0 &&
              !g(n).hasClass(t.params.pagination.bulletClass)
            ) {
              if (
                t.navigation &&
                ((t.navigation.nextEl && n === t.navigation.nextEl) ||
                  (t.navigation.prevEl && n === t.navigation.prevEl))
              )
                return;
              const e = r.hasClass(t.params.pagination.hiddenClass);
              s(!0 === e ? "paginationShow" : "paginationHide"),
                r.toggleClass(t.params.pagination.hiddenClass);
            }
          });
        const f = () => {
          t.$el.addClass(t.params.pagination.paginationDisabledClass),
            t.pagination.$el &&
              t.pagination.$el.addClass(
                t.params.pagination.paginationDisabledClass
              ),
            h();
        };
        Object.assign(t.pagination, {
          enable: () => {
            t.$el.removeClass(t.params.pagination.paginationDisabledClass),
              t.pagination.$el &&
                t.pagination.$el.removeClass(
                  t.params.pagination.paginationDisabledClass
                ),
              p(),
              c(),
              u();
          },
          disable: f,
          render: c,
          update: u,
          init: p,
          destroy: h,
        });
      }
      function te(e) {
        let { swiper: t, extendParams: i, on: n } = e;
        i({
          a11y: {
            enabled: !0,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null,
          },
        });
        let s = null;
        function r(e) {
          const t = s;
          0 !== t.length && (t.html(""), t.html(e));
        }
        function a(e) {
          e.attr("tabIndex", "0");
        }
        function o(e) {
          e.attr("tabIndex", "-1");
        }
        function l(e, t) {
          e.attr("role", t);
        }
        function d(e, t) {
          e.attr("aria-roledescription", t);
        }
        function u(e, t) {
          e.attr("aria-label", t);
        }
        function c(e) {
          e.attr("aria-disabled", !0);
        }
        function p(e) {
          e.attr("aria-disabled", !1);
        }
        function h(e) {
          if (13 !== e.keyCode && 32 !== e.keyCode) return;
          const i = t.params.a11y,
            n = g(e.target);
          t.navigation &&
            t.navigation.$nextEl &&
            n.is(t.navigation.$nextEl) &&
            ((t.isEnd && !t.params.loop) || t.slideNext(),
            t.isEnd ? r(i.lastSlideMessage) : r(i.nextSlideMessage)),
            t.navigation &&
              t.navigation.$prevEl &&
              n.is(t.navigation.$prevEl) &&
              ((t.isBeginning && !t.params.loop) || t.slidePrev(),
              t.isBeginning ? r(i.firstSlideMessage) : r(i.prevSlideMessage)),
            t.pagination &&
              n.is((0, J.Z)(t.params.pagination.bulletClass)) &&
              n[0].click();
        }
        function f() {
          return (
            t.pagination && t.pagination.bullets && t.pagination.bullets.length
          );
        }
        function m() {
          return f() && t.params.pagination.clickable;
        }
        const v = (e, t, i) => {
            a(e),
              "BUTTON" !== e[0].tagName && (l(e, "button"), e.on("keydown", h)),
              u(e, i),
              (function (e, t) {
                e.attr("aria-controls", t);
              })(e, t);
          },
          y = (e) => {
            const i = e.target.closest(`.${t.params.slideClass}`);
            if (!i || !t.slides.includes(i)) return;
            const n = t.slides.indexOf(i) === t.activeIndex,
              s =
                t.params.watchSlidesProgress &&
                t.visibleSlides &&
                t.visibleSlides.includes(i);
            n ||
              s ||
              (t.isHorizontal() ? (t.el.scrollLeft = 0) : (t.el.scrollTop = 0),
              t.slideTo(t.slides.indexOf(i), 0));
          },
          _ = () => {
            const e = t.params.a11y;
            e.itemRoleDescriptionMessage &&
              d(g(t.slides), e.itemRoleDescriptionMessage),
              e.slideRole && l(g(t.slides), e.slideRole);
            const i = t.params.loop
              ? t.slides.filter(
                  (e) => !e.classList.contains(t.params.slideDuplicateClass)
                ).length
              : t.slides.length;
            e.slideLabelMessage &&
              t.slides.each((n, s) => {
                const r = g(n),
                  a = t.params.loop
                    ? parseInt(r.attr("data-swiper-slide-index"), 10)
                    : s;
                u(
                  r,
                  e.slideLabelMessage
                    .replace(/\{\{index\}\}/, a + 1)
                    .replace(/\{\{slidesLength\}\}/, i)
                );
              });
          };
        n("beforeInit", () => {
          s = g(
            `<span class="${t.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`
          );
        }),
          n("afterInit", () => {
            t.params.a11y.enabled &&
              (() => {
                const e = t.params.a11y;
                t.$el.append(s);
                const i = t.$el;
                e.containerRoleDescriptionMessage &&
                  d(i, e.containerRoleDescriptionMessage),
                  e.containerMessage && u(i, e.containerMessage);
                const n = t.$wrapperEl,
                  r =
                    e.id ||
                    n.attr("id") ||
                    `swiper-wrapper-${
                      ((a = 16),
                      void 0 === a && (a = 16),
                      "x"
                        .repeat(a)
                        .replace(/x/g, () =>
                          Math.round(16 * Math.random()).toString(16)
                        ))
                    }`;
                var a;
                const o =
                  t.params.autoplay && t.params.autoplay.enabled
                    ? "off"
                    : "polite";
                var l;
                let c, p;
                (l = r),
                  n.attr("id", l),
                  (function (e, t) {
                    e.attr("aria-live", t);
                  })(n, o),
                  _(),
                  t.navigation &&
                    t.navigation.$nextEl &&
                    (c = t.navigation.$nextEl),
                  t.navigation &&
                    t.navigation.$prevEl &&
                    (p = t.navigation.$prevEl),
                  c && c.length && v(c, r, e.nextSlideMessage),
                  p && p.length && v(p, r, e.prevSlideMessage),
                  m() &&
                    t.pagination.$el.on(
                      "keydown",
                      (0, J.Z)(t.params.pagination.bulletClass),
                      h
                    ),
                  t.$el.on("focus", y, !0);
              })();
          }),
          n(
            "slidesLengthChange snapGridLengthChange slidesGridLengthChange",
            () => {
              t.params.a11y.enabled && _();
            }
          ),
          n("fromEdge toEdge afterInit lock unlock", () => {
            t.params.a11y.enabled &&
              (function () {
                if (t.params.loop || t.params.rewind || !t.navigation) return;
                const { $nextEl: e, $prevEl: i } = t.navigation;
                i &&
                  i.length > 0 &&
                  (t.isBeginning ? (c(i), o(i)) : (p(i), a(i))),
                  e && e.length > 0 && (t.isEnd ? (c(e), o(e)) : (p(e), a(e)));
              })();
          }),
          n("paginationUpdate", () => {
            t.params.a11y.enabled &&
              (function () {
                const e = t.params.a11y;
                f() &&
                  t.pagination.bullets.each((i) => {
                    const n = g(i);
                    t.params.pagination.clickable &&
                      (a(n),
                      t.params.pagination.renderBullet ||
                        (l(n, "button"),
                        u(
                          n,
                          e.paginationBulletMessage.replace(
                            /\{\{index\}\}/,
                            n.index() + 1
                          )
                        ))),
                      n.is(`.${t.params.pagination.bulletActiveClass}`)
                        ? n.attr("aria-current", "true")
                        : n.removeAttr("aria-current");
                  });
              })();
          }),
          n("destroy", () => {
            t.params.a11y.enabled &&
              (function () {
                let e, i;
                s && s.length > 0 && s.remove(),
                  t.navigation &&
                    t.navigation.$nextEl &&
                    (e = t.navigation.$nextEl),
                  t.navigation &&
                    t.navigation.$prevEl &&
                    (i = t.navigation.$prevEl),
                  e && e.off("keydown", h),
                  i && i.off("keydown", h),
                  m() &&
                    t.pagination.$el.off(
                      "keydown",
                      (0, J.Z)(t.params.pagination.bulletClass),
                      h
                    ),
                  t.$el.off("focus", y, !0);
              })();
          });
      }
      function ie(e) {
        let t,
          { swiper: i, extendParams: n, on: s, emit: r } = e;
        function o() {
          if (!i.size)
            return (i.autoplay.running = !1), void (i.autoplay.paused = !1);
          const e = i.slides.eq(i.activeIndex);
          let n = i.params.autoplay.delay;
          e.attr("data-swiper-autoplay") &&
            (n = e.attr("data-swiper-autoplay") || i.params.autoplay.delay),
            clearTimeout(t),
            (t = v(() => {
              let e;
              i.params.autoplay.reverseDirection
                ? i.params.loop
                  ? (i.loopFix(),
                    (e = i.slidePrev(i.params.speed, !0, !0)),
                    r("autoplay"))
                  : i.isBeginning
                  ? i.params.autoplay.stopOnLastSlide
                    ? d()
                    : ((e = i.slideTo(
                        i.slides.length - 1,
                        i.params.speed,
                        !0,
                        !0
                      )),
                      r("autoplay"))
                  : ((e = i.slidePrev(i.params.speed, !0, !0)), r("autoplay"))
                : i.params.loop
                ? (i.loopFix(),
                  (e = i.slideNext(i.params.speed, !0, !0)),
                  r("autoplay"))
                : i.isEnd
                ? i.params.autoplay.stopOnLastSlide
                  ? d()
                  : ((e = i.slideTo(0, i.params.speed, !0, !0)), r("autoplay"))
                : ((e = i.slideNext(i.params.speed, !0, !0)), r("autoplay")),
                ((i.params.cssMode && i.autoplay.running) || !1 === e) && o();
            }, n));
        }
        function l() {
          return (
            void 0 === t &&
            !i.autoplay.running &&
            ((i.autoplay.running = !0), r("autoplayStart"), o(), !0)
          );
        }
        function d() {
          return (
            !!i.autoplay.running &&
            void 0 !== t &&
            (t && (clearTimeout(t), (t = void 0)),
            (i.autoplay.running = !1),
            r("autoplayStop"),
            !0)
          );
        }
        function u(e) {
          i.autoplay.running &&
            (i.autoplay.paused ||
              (t && clearTimeout(t),
              (i.autoplay.paused = !0),
              0 !== e && i.params.autoplay.waitForTransition
                ? ["transitionend", "webkitTransitionEnd"].forEach((e) => {
                    i.$wrapperEl[0].addEventListener(e, p);
                  })
                : ((i.autoplay.paused = !1), o())));
        }
        function c() {
          const e = a();
          "hidden" === e.visibilityState && i.autoplay.running && u(),
            "visible" === e.visibilityState &&
              i.autoplay.paused &&
              (o(), (i.autoplay.paused = !1));
        }
        function p(e) {
          i &&
            !i.destroyed &&
            i.$wrapperEl &&
            e.target === i.$wrapperEl[0] &&
            (["transitionend", "webkitTransitionEnd"].forEach((e) => {
              i.$wrapperEl[0].removeEventListener(e, p);
            }),
            (i.autoplay.paused = !1),
            i.autoplay.running ? o() : d());
        }
        function h() {
          i.params.autoplay.disableOnInteraction
            ? d()
            : (r("autoplayPause"), u()),
            ["transitionend", "webkitTransitionEnd"].forEach((e) => {
              i.$wrapperEl[0].removeEventListener(e, p);
            });
        }
        function f() {
          i.params.autoplay.disableOnInteraction ||
            ((i.autoplay.paused = !1), r("autoplayResume"), o());
        }
        (i.autoplay = { running: !1, paused: !1 }),
          n({
            autoplay: {
              enabled: !1,
              delay: 3e3,
              waitForTransition: !0,
              disableOnInteraction: !0,
              stopOnLastSlide: !1,
              reverseDirection: !1,
              pauseOnMouseEnter: !1,
            },
          }),
          s("init", () => {
            i.params.autoplay.enabled &&
              (l(),
              a().addEventListener("visibilitychange", c),
              i.params.autoplay.pauseOnMouseEnter &&
                (i.$el.on("mouseenter", h), i.$el.on("mouseleave", f)));
          }),
          s("beforeTransitionStart", (e, t, n) => {
            i.autoplay.running &&
              (n || !i.params.autoplay.disableOnInteraction
                ? i.autoplay.pause(t)
                : d());
          }),
          s("sliderFirstMove", () => {
            i.autoplay.running &&
              (i.params.autoplay.disableOnInteraction ? d() : u());
          }),
          s("touchEnd", () => {
            i.params.cssMode &&
              i.autoplay.paused &&
              !i.params.autoplay.disableOnInteraction &&
              o();
          }),
          s("destroy", () => {
            i.$el.off("mouseenter", h),
              i.$el.off("mouseleave", f),
              i.autoplay.running && d(),
              a().removeEventListener("visibilitychange", c);
          }),
          Object.assign(i.autoplay, { pause: u, run: o, start: l, stop: d });
      }
      if (47 == i.j) var ne = i(1083);
    },
  },
]);
